var T4SThemeSP = {},
    isStorageSpSession = !1,
    isStorageSpSessionAll = !1,
    isStorageSpdLocal = !1,
    isStorageSpdLocalAll = !1,
    T4Sconfigs = window.T4Sconfigs,
    IsDesignMode = window.T4Srequest.design_mode,
    isThemeRTL = "rtl" == document.documentElement.getAttribute("dir");
(T4stt_var = { HoverInterval: 35, HoverTimeout: 150, dragThreshold: 10, prevOnHref: !1 }),
    (function (t, e) {
        "use strict";
        "object" == typeof module && "object" == typeof module.exports
            ? (module.exports = t.document
                  ? e(t, !0)
                  : function (t) {
                        if (!t.document) throw new Error("jQuery requires a window with a document");
                        return e(t);
                    })
            : e(t);
    })("undefined" != typeof window ? window : this, function (t, e) {
        "use strict";
        var i = [],
            n = Object.getPrototypeOf,
            o = i.slice,
            r = i.flat
                ? function (t) {
                      return i.flat.call(t);
                  }
                : function (t) {
                      return i.concat.apply([], t);
                  },
            s = i.push,
            a = i.indexOf,
            l = {},
            u = l.toString,
            c = l.hasOwnProperty,
            h = c.toString,
            d = h.call(Object),
            f = {},
            p = function (t) {
                return "function" == typeof t && "number" != typeof t.nodeType && "function" != typeof t.item;
            },
            g = function (t) {
                return null != t && t === t.window;
            },
            m = t.document,
            v = { type: !0, src: !0, nonce: !0, noModule: !0 };
        function y(t, e, i) {
            var n,
                o,
                r = (i = i || m).createElement("script");
            if (((r.text = t), e)) for (n in v) (o = e[n] || (e.getAttribute && e.getAttribute(n))) && r.setAttribute(n, o);
            i.head.appendChild(r).parentNode.removeChild(r);
        }
        function b(t) {
            return null == t ? t + "" : "object" == typeof t || "function" == typeof t ? l[u.call(t)] || "object" : typeof t;
        }
        var x = "3.6.0",
            S = function (t, e) {
                return new S.fn.init(t, e);
            };
        function w(t) {
            var e = !!t && "length" in t && t.length,
                i = b(t);
            return !p(t) && !g(t) && ("array" === i || 0 === e || ("number" == typeof e && 0 < e && e - 1 in t));
        }
        (S.fn = S.prototype = {
            jquery: x,
            constructor: S,
            length: 0,
            toArray: function () {
                return o.call(this);
            },
            get: function (t) {
                return null == t ? o.call(this) : t < 0 ? this[t + this.length] : this[t];
            },
            pushStack: function (t) {
                var e = S.merge(this.constructor(), t);
                return (e.prevObject = this), e;
            },
            each: function (t) {
                return S.each(this, t);
            },
            map: function (t) {
                return this.pushStack(
                    S.map(this, function (e, i) {
                        return t.call(e, i, e);
                    })
                );
            },
            slice: function () {
                return this.pushStack(o.apply(this, arguments));
            },
            first: function () {
                return this.eq(0);
            },
            last: function () {
                return this.eq(-1);
            },
            even: function () {
                return this.pushStack(
                    S.grep(this, function (t, e) {
                        return (e + 1) % 2;
                    })
                );
            },
            odd: function () {
                return this.pushStack(
                    S.grep(this, function (t, e) {
                        return e % 2;
                    })
                );
            },
            eq: function (t) {
                var e = this.length,
                    i = +t + (t < 0 ? e : 0);
                return this.pushStack(0 <= i && i < e ? [this[i]] : []);
            },
            end: function () {
                return this.prevObject || this.constructor();
            },
            push: s,
            sort: i.sort,
            splice: i.splice,
        }),
            (S.extend = S.fn.extend = function () {
                var t,
                    e,
                    i,
                    n,
                    o,
                    r,
                    s = arguments[0] || {},
                    a = 1,
                    l = arguments.length,
                    u = !1;
                for ("boolean" == typeof s && ((u = s), (s = arguments[a] || {}), a++), "object" == typeof s || p(s) || (s = {}), a === l && ((s = this), a--); a < l; a++)
                    if (null != (t = arguments[a]))
                        for (e in t)
                            (n = t[e]),
                                "__proto__" !== e &&
                                    s !== n &&
                                    (u && n && (S.isPlainObject(n) || (o = Array.isArray(n)))
                                        ? ((i = s[e]), (r = o && !Array.isArray(i) ? [] : o || S.isPlainObject(i) ? i : {}), (o = !1), (s[e] = S.extend(u, r, n)))
                                        : void 0 !== n && (s[e] = n));
                return s;
            }),
            S.extend({
                expando: "jQuery" + (x + Math.random()).replace(/\D/g, ""),
                isReady: !0,
                error: function (t) {
                    throw new Error(t);
                },
                noop: function () {},
                isPlainObject: function (t) {
                    var e, i;
                    return !(!t || "[object Object]" !== u.call(t) || ((e = n(t)) && ("function" != typeof (i = c.call(e, "constructor") && e.constructor) || h.call(i) !== d)));
                },
                isEmptyObject: function (t) {
                    var e;
                    for (e in t) return !1;
                    return !0;
                },
                globalEval: function (t, e, i) {
                    y(t, { nonce: e && e.nonce }, i);
                },
                each: function (t, e) {
                    var i,
                        n = 0;
                    if (w(t)) for (i = t.length; n < i && !1 !== e.call(t[n], n, t[n]); n++);
                    else for (n in t) if (!1 === e.call(t[n], n, t[n])) break;
                    return t;
                },
                makeArray: function (t, e) {
                    var i = e || [];
                    return null != t && (w(Object(t)) ? S.merge(i, "string" == typeof t ? [t] : t) : s.call(i, t)), i;
                },
                inArray: function (t, e, i) {
                    return null == e ? -1 : a.call(e, t, i);
                },
                merge: function (t, e) {
                    for (var i = +e.length, n = 0, o = t.length; n < i; n++) t[o++] = e[n];
                    return (t.length = o), t;
                },
                grep: function (t, e, i) {
                    for (var n = [], o = 0, r = t.length, s = !i; o < r; o++) !e(t[o], o) !== s && n.push(t[o]);
                    return n;
                },
                map: function (t, e, i) {
                    var n,
                        o,
                        s = 0,
                        a = [];
                    if (w(t)) for (n = t.length; s < n; s++) null != (o = e(t[s], s, i)) && a.push(o);
                    else for (s in t) null != (o = e(t[s], s, i)) && a.push(o);
                    return r(a);
                },
                guid: 1,
                support: f,
            }),
            "function" == typeof Symbol && (S.fn[Symbol.iterator] = i[Symbol.iterator]),
            S.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (t, e) {
                l["[object " + e + "]"] = e.toLowerCase();
            });
        var T = (function (t) {
            var e,
                i,
                n,
                o,
                r,
                s,
                a,
                l,
                u,
                c,
                h,
                d,
                f,
                p,
                g,
                m,
                v,
                y,
                b,
                x = "sizzle" + 1 * new Date(),
                S = t.document,
                w = 0,
                T = 0,
                C = lt(),
                E = lt(),
                _ = lt(),
                k = lt(),
                I = function (t, e) {
                    return t === e && (h = !0), 0;
                },
                D = {}.hasOwnProperty,
                P = [],
                z = P.pop,
                L = P.push,
                A = P.push,
                N = P.slice,
                j = function (t, e) {
                    for (var i = 0, n = t.length; i < n; i++) if (t[i] === e) return i;
                    return -1;
                },
                M = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
                W = "[\\x20\\t\\r\\n\\f]",
                O = "(?:\\\\[\\da-fA-F]{1,6}" + W + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
                q = "\\[" + W + "*(" + O + ")(?:" + W + "*([*^$|!~]?=)" + W + "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + O + "))|)" + W + "*\\]",
                H = ":(" + O + ")(?:\\((('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|((?:\\\\.|[^\\\\()[\\]]|" + q + ")*)|.*)\\)|)",
                R = new RegExp(W + "+", "g"),
                F = new RegExp("^" + W + "+|((?:^|[^\\\\])(?:\\\\.)*)" + W + "+$", "g"),
                $ = new RegExp("^" + W + "*," + W + "*"),
                B = new RegExp("^" + W + "*([>+~]|" + W + ")" + W + "*"),
                U = new RegExp(W + "|>"),
                V = new RegExp(H),
                X = new RegExp("^" + O + "$"),
                G = {
                    ID: new RegExp("^#(" + O + ")"),
                    CLASS: new RegExp("^\\.(" + O + ")"),
                    TAG: new RegExp("^(" + O + "|[*])"),
                    ATTR: new RegExp("^" + q),
                    PSEUDO: new RegExp("^" + H),
                    CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + W + "*(even|odd|(([+-]|)(\\d*)n|)" + W + "*(?:([+-]|)" + W + "*(\\d+)|))" + W + "*\\)|)", "i"),
                    bool: new RegExp("^(?:" + M + ")$", "i"),
                    needsContext: new RegExp("^" + W + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + W + "*((?:-\\d)?\\d*)" + W + "*\\)|)(?=[^-]|$)", "i"),
                },
                Y = /HTML$/i,
                Q = /^(?:input|select|textarea|button)$/i,
                J = /^h\d$/i,
                Z = /^[^{]+\{\s*\[native \w/,
                K = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
                tt = /[+~]/,
                et = new RegExp("\\\\[\\da-fA-F]{1,6}" + W + "?|\\\\([^\\r\\n\\f])", "g"),
                it = function (t, e) {
                    var i = "0x" + t.slice(1) - 65536;
                    return e || (i < 0 ? String.fromCharCode(i + 65536) : String.fromCharCode((i >> 10) | 55296, (1023 & i) | 56320));
                },
                nt = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\0-\x1f\x7f-\uFFFF\w-]/g,
                ot = function (t, e) {
                    return e ? ("\0" === t ? "�" : t.slice(0, -1) + "\\" + t.charCodeAt(t.length - 1).toString(16) + " ") : "\\" + t;
                },
                rt = function () {
                    d();
                },
                st = xt(
                    function (t) {
                        return !0 === t.disabled && "fieldset" === t.nodeName.toLowerCase();
                    },
                    { dir: "parentNode", next: "legend" }
                );
            try {
                A.apply((P = N.call(S.childNodes)), S.childNodes), P[S.childNodes.length].nodeType;
            } catch (e) {
                A = {
                    apply: P.length
                        ? function (t, e) {
                              L.apply(t, N.call(e));
                          }
                        : function (t, e) {
                              for (var i = t.length, n = 0; (t[i++] = e[n++]); );
                              t.length = i - 1;
                          },
                };
            }
            function at(t, e, n, o) {
                var r,
                    a,
                    u,
                    c,
                    h,
                    p,
                    v,
                    y = e && e.ownerDocument,
                    S = e ? e.nodeType : 9;
                if (((n = n || []), "string" != typeof t || !t || (1 !== S && 9 !== S && 11 !== S))) return n;
                if (!o && (d(e), (e = e || f), g)) {
                    if (11 !== S && (h = K.exec(t)))
                        if ((r = h[1])) {
                            if (9 === S) {
                                if (!(u = e.getElementById(r))) return n;
                                if (u.id === r) return n.push(u), n;
                            } else if (y && (u = y.getElementById(r)) && b(e, u) && u.id === r) return n.push(u), n;
                        } else {
                            if (h[2]) return A.apply(n, e.getElementsByTagName(t)), n;
                            if ((r = h[3]) && i.getElementsByClassName && e.getElementsByClassName) return A.apply(n, e.getElementsByClassName(r)), n;
                        }
                    if (i.qsa && !k[t + " "] && (!m || !m.test(t)) && (1 !== S || "object" !== e.nodeName.toLowerCase())) {
                        if (((v = t), (y = e), 1 === S && (U.test(t) || B.test(t)))) {
                            for (((y = (tt.test(t) && vt(e.parentNode)) || e) === e && i.scope) || ((c = e.getAttribute("id")) ? (c = c.replace(nt, ot)) : e.setAttribute("id", (c = x))), a = (p = s(t)).length; a--; )
                                p[a] = (c ? "#" + c : ":scope") + " " + bt(p[a]);
                            v = p.join(",");
                        }
                        try {
                            return A.apply(n, y.querySelectorAll(v)), n;
                        } catch (e) {
                            k(t, !0);
                        } finally {
                            c === x && e.removeAttribute("id");
                        }
                    }
                }
                return l(t.replace(F, "$1"), e, n, o);
            }
            function lt() {
                var t = [];
                return function e(i, o) {
                    return t.push(i + " ") > n.cacheLength && delete e[t.shift()], (e[i + " "] = o);
                };
            }
            function ut(t) {
                return (t[x] = !0), t;
            }
            function ct(t) {
                var e = f.createElement("fieldset");
                try {
                    return !!t(e);
                } catch (t) {
                    return !1;
                } finally {
                    e.parentNode && e.parentNode.removeChild(e), (e = null);
                }
            }
            function ht(t, e) {
                for (var i = t.split("|"), o = i.length; o--; ) n.attrHandle[i[o]] = e;
            }
            function dt(t, e) {
                var i = e && t,
                    n = i && 1 === t.nodeType && 1 === e.nodeType && t.sourceIndex - e.sourceIndex;
                if (n) return n;
                if (i) for (; (i = i.nextSibling); ) if (i === e) return -1;
                return t ? 1 : -1;
            }
            function ft(t) {
                return function (e) {
                    return "input" === e.nodeName.toLowerCase() && e.type === t;
                };
            }
            function pt(t) {
                return function (e) {
                    var i = e.nodeName.toLowerCase();
                    return ("input" === i || "button" === i) && e.type === t;
                };
            }
            function gt(t) {
                return function (e) {
                    return "form" in e
                        ? e.parentNode && !1 === e.disabled
                            ? "label" in e
                                ? "label" in e.parentNode
                                    ? e.parentNode.disabled === t
                                    : e.disabled === t
                                : e.isDisabled === t || (e.isDisabled !== !t && st(e) === t)
                            : e.disabled === t
                        : "label" in e && e.disabled === t;
                };
            }
            function mt(t) {
                return ut(function (e) {
                    return (
                        (e = +e),
                        ut(function (i, n) {
                            for (var o, r = t([], i.length, e), s = r.length; s--; ) i[(o = r[s])] && (i[o] = !(n[o] = i[o]));
                        })
                    );
                });
            }
            function vt(t) {
                return t && void 0 !== t.getElementsByTagName && t;
            }
            for (e in ((i = at.support = {}),
            (r = at.isXML = function (t) {
                var e = t && t.namespaceURI,
                    i = t && (t.ownerDocument || t).documentElement;
                return !Y.test(e || (i && i.nodeName) || "HTML");
            }),
            (d = at.setDocument = function (t) {
                var e,
                    o,
                    s = t ? t.ownerDocument || t : S;
                return (
                    s != f &&
                        9 === s.nodeType &&
                        s.documentElement &&
                        ((p = (f = s).documentElement),
                        (g = !r(f)),
                        S != f && (o = f.defaultView) && o.top !== o && (o.addEventListener ? o.addEventListener("unload", rt, !1) : o.attachEvent && o.attachEvent("onunload", rt)),
                        (i.scope = ct(function (t) {
                            return p.appendChild(t).appendChild(f.createElement("div")), void 0 !== t.querySelectorAll && !t.querySelectorAll(":scope fieldset div").length;
                        })),
                        (i.attributes = ct(function (t) {
                            return (t.className = "i"), !t.getAttribute("className");
                        })),
                        (i.getElementsByTagName = ct(function (t) {
                            return t.appendChild(f.createComment("")), !t.getElementsByTagName("*").length;
                        })),
                        (i.getElementsByClassName = Z.test(f.getElementsByClassName)),
                        (i.getById = ct(function (t) {
                            return (p.appendChild(t).id = x), !f.getElementsByName || !f.getElementsByName(x).length;
                        })),
                        i.getById
                            ? ((n.filter.ID = function (t) {
                                  var e = t.replace(et, it);
                                  return function (t) {
                                      return t.getAttribute("id") === e;
                                  };
                              }),
                              (n.find.ID = function (t, e) {
                                  if (void 0 !== e.getElementById && g) {
                                      var i = e.getElementById(t);
                                      return i ? [i] : [];
                                  }
                              }))
                            : ((n.filter.ID = function (t) {
                                  var e = t.replace(et, it);
                                  return function (t) {
                                      var i = void 0 !== t.getAttributeNode && t.getAttributeNode("id");
                                      return i && i.value === e;
                                  };
                              }),
                              (n.find.ID = function (t, e) {
                                  if (void 0 !== e.getElementById && g) {
                                      var i,
                                          n,
                                          o,
                                          r = e.getElementById(t);
                                      if (r) {
                                          if ((i = r.getAttributeNode("id")) && i.value === t) return [r];
                                          for (o = e.getElementsByName(t), n = 0; (r = o[n++]); ) if ((i = r.getAttributeNode("id")) && i.value === t) return [r];
                                      }
                                      return [];
                                  }
                              })),
                        (n.find.TAG = i.getElementsByTagName
                            ? function (t, e) {
                                  return void 0 !== e.getElementsByTagName ? e.getElementsByTagName(t) : i.qsa ? e.querySelectorAll(t) : void 0;
                              }
                            : function (t, e) {
                                  var i,
                                      n = [],
                                      o = 0,
                                      r = e.getElementsByTagName(t);
                                  if ("*" === t) {
                                      for (; (i = r[o++]); ) 1 === i.nodeType && n.push(i);
                                      return n;
                                  }
                                  return r;
                              }),
                        (n.find.CLASS =
                            i.getElementsByClassName &&
                            function (t, e) {
                                if (void 0 !== e.getElementsByClassName && g) return e.getElementsByClassName(t);
                            }),
                        (v = []),
                        (m = []),
                        (i.qsa = Z.test(f.querySelectorAll)) &&
                            (ct(function (t) {
                                var e;
                                (p.appendChild(t).innerHTML = "<a id='" + x + "'></a><select id='" + x + "-\r\\' msallowcapture=''><option selected=''></option></select>"),
                                    t.querySelectorAll("[msallowcapture^='']").length && m.push("[*^$]=" + W + "*(?:''|\"\")"),
                                    t.querySelectorAll("[selected]").length || m.push("\\[" + W + "*(?:value|" + M + ")"),
                                    t.querySelectorAll("[id~=" + x + "-]").length || m.push("~="),
                                    (e = f.createElement("input")).setAttribute("name", ""),
                                    t.appendChild(e),
                                    t.querySelectorAll("[name='']").length || m.push("\\[" + W + "*name" + W + "*=" + W + "*(?:''|\"\")"),
                                    t.querySelectorAll(":checked").length || m.push(":checked"),
                                    t.querySelectorAll("a#" + x + "+*").length || m.push(".#.+[+~]"),
                                    t.querySelectorAll("\\\f"),
                                    m.push("[\\r\\n\\f]");
                            }),
                            ct(function (t) {
                                t.innerHTML = "<a href='' disabled='disabled'></a><select disabled='disabled'><option/></select>";
                                var e = f.createElement("input");
                                e.setAttribute("type", "hidden"),
                                    t.appendChild(e).setAttribute("name", "D"),
                                    t.querySelectorAll("[name=d]").length && m.push("name" + W + "*[*^$|!~]?="),
                                    2 !== t.querySelectorAll(":enabled").length && m.push(":enabled", ":disabled"),
                                    (p.appendChild(t).disabled = !0),
                                    2 !== t.querySelectorAll(":disabled").length && m.push(":enabled", ":disabled"),
                                    t.querySelectorAll("*,:x"),
                                    m.push(",.*:");
                            })),
                        (i.matchesSelector = Z.test((y = p.matches || p.webkitMatchesSelector || p.mozMatchesSelector || p.oMatchesSelector || p.msMatchesSelector))) &&
                            ct(function (t) {
                                (i.disconnectedMatch = y.call(t, "*")), y.call(t, "[s!='']:x"), v.push("!=", H);
                            }),
                        (m = m.length && new RegExp(m.join("|"))),
                        (v = v.length && new RegExp(v.join("|"))),
                        (e = Z.test(p.compareDocumentPosition)),
                        (b =
                            e || Z.test(p.contains)
                                ? function (t, e) {
                                      var i = 9 === t.nodeType ? t.documentElement : t,
                                          n = e && e.parentNode;
                                      return t === n || !(!n || 1 !== n.nodeType || !(i.contains ? i.contains(n) : t.compareDocumentPosition && 16 & t.compareDocumentPosition(n)));
                                  }
                                : function (t, e) {
                                      if (e) for (; (e = e.parentNode); ) if (e === t) return !0;
                                      return !1;
                                  }),
                        (I = e
                            ? function (t, e) {
                                  if (t === e) return (h = !0), 0;
                                  var n = !t.compareDocumentPosition - !e.compareDocumentPosition;
                                  return (
                                      n ||
                                      (1 & (n = (t.ownerDocument || t) == (e.ownerDocument || e) ? t.compareDocumentPosition(e) : 1) || (!i.sortDetached && e.compareDocumentPosition(t) === n)
                                          ? t == f || (t.ownerDocument == S && b(S, t))
                                              ? -1
                                              : e == f || (e.ownerDocument == S && b(S, e))
                                              ? 1
                                              : c
                                              ? j(c, t) - j(c, e)
                                              : 0
                                          : 4 & n
                                          ? -1
                                          : 1)
                                  );
                              }
                            : function (t, e) {
                                  if (t === e) return (h = !0), 0;
                                  var i,
                                      n = 0,
                                      o = t.parentNode,
                                      r = e.parentNode,
                                      s = [t],
                                      a = [e];
                                  if (!o || !r) return t == f ? -1 : e == f ? 1 : o ? -1 : r ? 1 : c ? j(c, t) - j(c, e) : 0;
                                  if (o === r) return dt(t, e);
                                  for (i = t; (i = i.parentNode); ) s.unshift(i);
                                  for (i = e; (i = i.parentNode); ) a.unshift(i);
                                  for (; s[n] === a[n]; ) n++;
                                  return n ? dt(s[n], a[n]) : s[n] == S ? -1 : a[n] == S ? 1 : 0;
                              })),
                    f
                );
            }),
            (at.matches = function (t, e) {
                return at(t, null, null, e);
            }),
            (at.matchesSelector = function (t, e) {
                if ((d(t), i.matchesSelector && g && !k[e + " "] && (!v || !v.test(e)) && (!m || !m.test(e))))
                    try {
                        var n = y.call(t, e);
                        if (n || i.disconnectedMatch || (t.document && 11 !== t.document.nodeType)) return n;
                    } catch (t) {
                        k(e, !0);
                    }
                return 0 < at(e, f, null, [t]).length;
            }),
            (at.contains = function (t, e) {
                return (t.ownerDocument || t) != f && d(t), b(t, e);
            }),
            (at.attr = function (t, e) {
                (t.ownerDocument || t) != f && d(t);
                var o = n.attrHandle[e.toLowerCase()],
                    r = o && D.call(n.attrHandle, e.toLowerCase()) ? o(t, e, !g) : void 0;
                return void 0 !== r ? r : i.attributes || !g ? t.getAttribute(e) : (r = t.getAttributeNode(e)) && r.specified ? r.value : null;
            }),
            (at.escape = function (t) {
                return (t + "").replace(nt, ot);
            }),
            (at.error = function (t) {
                throw new Error("Syntax error, unrecognized expression: " + t);
            }),
            (at.uniqueSort = function (t) {
                var e,
                    n = [],
                    o = 0,
                    r = 0;
                if (((h = !i.detectDuplicates), (c = !i.sortStable && t.slice(0)), t.sort(I), h)) {
                    for (; (e = t[r++]); ) e === t[r] && (o = n.push(r));
                    for (; o--; ) t.splice(n[o], 1);
                }
                return (c = null), t;
            }),
            (o = at.getText = function (t) {
                var e,
                    i = "",
                    n = 0,
                    r = t.nodeType;
                if (r) {
                    if (1 === r || 9 === r || 11 === r) {
                        if ("string" == typeof t.textContent) return t.textContent;
                        for (t = t.firstChild; t; t = t.nextSibling) i += o(t);
                    } else if (3 === r || 4 === r) return t.nodeValue;
                } else for (; (e = t[n++]); ) i += o(e);
                return i;
            }),
            ((n = at.selectors = {
                cacheLength: 50,
                createPseudo: ut,
                match: G,
                attrHandle: {},
                find: {},
                relative: { ">": { dir: "parentNode", first: !0 }, " ": { dir: "parentNode" }, "+": { dir: "previousSibling", first: !0 }, "~": { dir: "previousSibling" } },
                preFilter: {
                    ATTR: function (t) {
                        return (t[1] = t[1].replace(et, it)), (t[3] = (t[3] || t[4] || t[5] || "").replace(et, it)), "~=" === t[2] && (t[3] = " " + t[3] + " "), t.slice(0, 4);
                    },
                    CHILD: function (t) {
                        return (
                            (t[1] = t[1].toLowerCase()),
                            "nth" === t[1].slice(0, 3) ? (t[3] || at.error(t[0]), (t[4] = +(t[4] ? t[5] + (t[6] || 1) : 2 * ("even" === t[3] || "odd" === t[3]))), (t[5] = +(t[7] + t[8] || "odd" === t[3]))) : t[3] && at.error(t[0]),
                            t
                        );
                    },
                    PSEUDO: function (t) {
                        var e,
                            i = !t[6] && t[2];
                        return G.CHILD.test(t[0])
                            ? null
                            : (t[3] ? (t[2] = t[4] || t[5] || "") : i && V.test(i) && (e = s(i, !0)) && (e = i.indexOf(")", i.length - e) - i.length) && ((t[0] = t[0].slice(0, e)), (t[2] = i.slice(0, e))), t.slice(0, 3));
                    },
                },
                filter: {
                    TAG: function (t) {
                        var e = t.replace(et, it).toLowerCase();
                        return "*" === t
                            ? function () {
                                  return !0;
                              }
                            : function (t) {
                                  return t.nodeName && t.nodeName.toLowerCase() === e;
                              };
                    },
                    CLASS: function (t) {
                        var e = C[t + " "];
                        return (
                            e ||
                            ((e = new RegExp("(^|" + W + ")" + t + "(" + W + "|$)")) &&
                                C(t, function (t) {
                                    return e.test(("string" == typeof t.className && t.className) || (void 0 !== t.getAttribute && t.getAttribute("class")) || "");
                                }))
                        );
                    },
                    ATTR: function (t, e, i) {
                        return function (n) {
                            var o = at.attr(n, t);
                            return null == o
                                ? "!=" === e
                                : !e ||
                                      ((o += ""),
                                      "=" === e
                                          ? o === i
                                          : "!=" === e
                                          ? o !== i
                                          : "^=" === e
                                          ? i && 0 === o.indexOf(i)
                                          : "*=" === e
                                          ? i && -1 < o.indexOf(i)
                                          : "$=" === e
                                          ? i && o.slice(-i.length) === i
                                          : "~=" === e
                                          ? -1 < (" " + o.replace(R, " ") + " ").indexOf(i)
                                          : "|=" === e && (o === i || o.slice(0, i.length + 1) === i + "-"));
                        };
                    },
                    CHILD: function (t, e, i, n, o) {
                        var r = "nth" !== t.slice(0, 3),
                            s = "last" !== t.slice(-4),
                            a = "of-type" === e;
                        return 1 === n && 0 === o
                            ? function (t) {
                                  return !!t.parentNode;
                              }
                            : function (e, i, l) {
                                  var u,
                                      c,
                                      h,
                                      d,
                                      f,
                                      p,
                                      g = r !== s ? "nextSibling" : "previousSibling",
                                      m = e.parentNode,
                                      v = a && e.nodeName.toLowerCase(),
                                      y = !l && !a,
                                      b = !1;
                                  if (m) {
                                      if (r) {
                                          for (; g; ) {
                                              for (d = e; (d = d[g]); ) if (a ? d.nodeName.toLowerCase() === v : 1 === d.nodeType) return !1;
                                              p = g = "only" === t && !p && "nextSibling";
                                          }
                                          return !0;
                                      }
                                      if (((p = [s ? m.firstChild : m.lastChild]), s && y)) {
                                          for (
                                              b = (f = (u = (c = (h = (d = m)[x] || (d[x] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] || [])[0] === w && u[1]) && u[2], d = f && m.childNodes[f];
                                              (d = (++f && d && d[g]) || (b = f = 0) || p.pop());

                                          )
                                              if (1 === d.nodeType && ++b && d === e) {
                                                  c[t] = [w, f, b];
                                                  break;
                                              }
                                      } else if ((y && (b = f = (u = (c = (h = (d = e)[x] || (d[x] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] || [])[0] === w && u[1]), !1 === b))
                                          for (
                                              ;
                                              (d = (++f && d && d[g]) || (b = f = 0) || p.pop()) &&
                                              ((a ? d.nodeName.toLowerCase() !== v : 1 !== d.nodeType) || !++b || (y && ((c = (h = d[x] || (d[x] = {}))[d.uniqueID] || (h[d.uniqueID] = {}))[t] = [w, b]), d !== e));

                                          );
                                      return (b -= o) === n || (b % n == 0 && 0 <= b / n);
                                  }
                              };
                    },
                    PSEUDO: function (t, e) {
                        var i,
                            o = n.pseudos[t] || n.setFilters[t.toLowerCase()] || at.error("unsupported pseudo: " + t);
                        return o[x]
                            ? o(e)
                            : 1 < o.length
                            ? ((i = [t, t, "", e]),
                              n.setFilters.hasOwnProperty(t.toLowerCase())
                                  ? ut(function (t, i) {
                                        for (var n, r = o(t, e), s = r.length; s--; ) t[(n = j(t, r[s]))] = !(i[n] = r[s]);
                                    })
                                  : function (t) {
                                        return o(t, 0, i);
                                    })
                            : o;
                    },
                },
                pseudos: {
                    not: ut(function (t) {
                        var e = [],
                            i = [],
                            n = a(t.replace(F, "$1"));
                        return n[x]
                            ? ut(function (t, e, i, o) {
                                  for (var r, s = n(t, null, o, []), a = t.length; a--; ) (r = s[a]) && (t[a] = !(e[a] = r));
                              })
                            : function (t, o, r) {
                                  return (e[0] = t), n(e, null, r, i), (e[0] = null), !i.pop();
                              };
                    }),
                    has: ut(function (t) {
                        return function (e) {
                            return 0 < at(t, e).length;
                        };
                    }),
                    contains: ut(function (t) {
                        return (
                            (t = t.replace(et, it)),
                            function (e) {
                                return -1 < (e.textContent || o(e)).indexOf(t);
                            }
                        );
                    }),
                    lang: ut(function (t) {
                        return (
                            X.test(t || "") || at.error("unsupported lang: " + t),
                            (t = t.replace(et, it).toLowerCase()),
                            function (e) {
                                var i;
                                do {
                                    if ((i = g ? e.lang : e.getAttribute("xml:lang") || e.getAttribute("lang"))) return (i = i.toLowerCase()) === t || 0 === i.indexOf(t + "-");
                                } while ((e = e.parentNode) && 1 === e.nodeType);
                                return !1;
                            }
                        );
                    }),
                    target: function (e) {
                        var i = t.location && t.location.hash;
                        return i && i.slice(1) === e.id;
                    },
                    root: function (t) {
                        return t === p;
                    },
                    focus: function (t) {
                        return t === f.activeElement && (!f.hasFocus || f.hasFocus()) && !!(t.type || t.href || ~t.tabIndex);
                    },
                    enabled: gt(!1),
                    disabled: gt(!0),
                    checked: function (t) {
                        var e = t.nodeName.toLowerCase();
                        return ("input" === e && !!t.checked) || ("option" === e && !!t.selected);
                    },
                    selected: function (t) {
                        return t.parentNode && t.parentNode.selectedIndex, !0 === t.selected;
                    },
                    empty: function (t) {
                        for (t = t.firstChild; t; t = t.nextSibling) if (t.nodeType < 6) return !1;
                        return !0;
                    },
                    parent: function (t) {
                        return !n.pseudos.empty(t);
                    },
                    header: function (t) {
                        return J.test(t.nodeName);
                    },
                    input: function (t) {
                        return Q.test(t.nodeName);
                    },
                    button: function (t) {
                        var e = t.nodeName.toLowerCase();
                        return ("input" === e && "button" === t.type) || "button" === e;
                    },
                    text: function (t) {
                        var e;
                        return "input" === t.nodeName.toLowerCase() && "text" === t.type && (null == (e = t.getAttribute("type")) || "text" === e.toLowerCase());
                    },
                    first: mt(function () {
                        return [0];
                    }),
                    last: mt(function (t, e) {
                        return [e - 1];
                    }),
                    eq: mt(function (t, e, i) {
                        return [i < 0 ? i + e : i];
                    }),
                    even: mt(function (t, e) {
                        for (var i = 0; i < e; i += 2) t.push(i);
                        return t;
                    }),
                    odd: mt(function (t, e) {
                        for (var i = 1; i < e; i += 2) t.push(i);
                        return t;
                    }),
                    lt: mt(function (t, e, i) {
                        for (var n = i < 0 ? i + e : e < i ? e : i; 0 <= --n; ) t.push(n);
                        return t;
                    }),
                    gt: mt(function (t, e, i) {
                        for (var n = i < 0 ? i + e : i; ++n < e; ) t.push(n);
                        return t;
                    }),
                },
            }).pseudos.nth = n.pseudos.eq),
            { radio: !0, checkbox: !0, file: !0, password: !0, image: !0 }))
                n.pseudos[e] = ft(e);
            for (e in { submit: !0, reset: !0 }) n.pseudos[e] = pt(e);
            function yt() {}
            function bt(t) {
                for (var e = 0, i = t.length, n = ""; e < i; e++) n += t[e].value;
                return n;
            }
            function xt(t, e, i) {
                var n = e.dir,
                    o = e.next,
                    r = o || n,
                    s = i && "parentNode" === r,
                    a = T++;
                return e.first
                    ? function (e, i, o) {
                          for (; (e = e[n]); ) if (1 === e.nodeType || s) return t(e, i, o);
                          return !1;
                      }
                    : function (e, i, l) {
                          var u,
                              c,
                              h,
                              d = [w, a];
                          if (l) {
                              for (; (e = e[n]); ) if ((1 === e.nodeType || s) && t(e, i, l)) return !0;
                          } else
                              for (; (e = e[n]); )
                                  if (1 === e.nodeType || s)
                                      if (((c = (h = e[x] || (e[x] = {}))[e.uniqueID] || (h[e.uniqueID] = {})), o && o === e.nodeName.toLowerCase())) e = e[n] || e;
                                      else {
                                          if ((u = c[r]) && u[0] === w && u[1] === a) return (d[2] = u[2]);
                                          if (((c[r] = d)[2] = t(e, i, l))) return !0;
                                      }
                          return !1;
                      };
            }
            function St(t) {
                return 1 < t.length
                    ? function (e, i, n) {
                          for (var o = t.length; o--; ) if (!t[o](e, i, n)) return !1;
                          return !0;
                      }
                    : t[0];
            }
            function wt(t, e, i, n, o) {
                for (var r, s = [], a = 0, l = t.length, u = null != e; a < l; a++) (r = t[a]) && ((i && !i(r, n, o)) || (s.push(r), u && e.push(a)));
                return s;
            }
            function Tt(t, e, i, n, o, r) {
                return (
                    n && !n[x] && (n = Tt(n)),
                    o && !o[x] && (o = Tt(o, r)),
                    ut(function (r, s, a, l) {
                        var u,
                            c,
                            h,
                            d = [],
                            f = [],
                            p = s.length,
                            g =
                                r ||
                                (function (t, e, i) {
                                    for (var n = 0, o = e.length; n < o; n++) at(t, e[n], i);
                                    return i;
                                })(e || "*", a.nodeType ? [a] : a, []),
                            m = !t || (!r && e) ? g : wt(g, d, t, a, l),
                            v = i ? (o || (r ? t : p || n) ? [] : s) : m;
                        if ((i && i(m, v, a, l), n)) for (u = wt(v, f), n(u, [], a, l), c = u.length; c--; ) (h = u[c]) && (v[f[c]] = !(m[f[c]] = h));
                        if (r) {
                            if (o || t) {
                                if (o) {
                                    for (u = [], c = v.length; c--; ) (h = v[c]) && u.push((m[c] = h));
                                    o(null, (v = []), u, l);
                                }
                                for (c = v.length; c--; ) (h = v[c]) && -1 < (u = o ? j(r, h) : d[c]) && (r[u] = !(s[u] = h));
                            }
                        } else (v = wt(v === s ? v.splice(p, v.length) : v)), o ? o(null, s, v, l) : A.apply(s, v);
                    })
                );
            }
            function Ct(t) {
                for (
                    var e,
                        i,
                        o,
                        r = t.length,
                        s = n.relative[t[0].type],
                        a = s || n.relative[" "],
                        l = s ? 1 : 0,
                        c = xt(
                            function (t) {
                                return t === e;
                            },
                            a,
                            !0
                        ),
                        h = xt(
                            function (t) {
                                return -1 < j(e, t);
                            },
                            a,
                            !0
                        ),
                        d = [
                            function (t, i, n) {
                                var o = (!s && (n || i !== u)) || ((e = i).nodeType ? c(t, i, n) : h(t, i, n));
                                return (e = null), o;
                            },
                        ];
                    l < r;
                    l++
                )
                    if ((i = n.relative[t[l].type])) d = [xt(St(d), i)];
                    else {
                        if ((i = n.filter[t[l].type].apply(null, t[l].matches))[x]) {
                            for (o = ++l; o < r && !n.relative[t[o].type]; o++);
                            return Tt(1 < l && St(d), 1 < l && bt(t.slice(0, l - 1).concat({ value: " " === t[l - 2].type ? "*" : "" })).replace(F, "$1"), i, l < o && Ct(t.slice(l, o)), o < r && Ct((t = t.slice(o))), o < r && bt(t));
                        }
                        d.push(i);
                    }
                return St(d);
            }
            return (
                (yt.prototype = n.filters = n.pseudos),
                (n.setFilters = new yt()),
                (s = at.tokenize = function (t, e) {
                    var i,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c = E[t + " "];
                    if (c) return e ? 0 : c.slice(0);
                    for (a = t, l = [], u = n.preFilter; a; ) {
                        for (s in ((i && !(o = $.exec(a))) || (o && (a = a.slice(o[0].length) || a), l.push((r = []))),
                        (i = !1),
                        (o = B.exec(a)) && ((i = o.shift()), r.push({ value: i, type: o[0].replace(F, " ") }), (a = a.slice(i.length))),
                        n.filter))
                            !(o = G[s].exec(a)) || (u[s] && !(o = u[s](o))) || ((i = o.shift()), r.push({ value: i, type: s, matches: o }), (a = a.slice(i.length)));
                        if (!i) break;
                    }
                    return e ? a.length : a ? at.error(t) : E(t, l).slice(0);
                }),
                (a = at.compile = function (t, e) {
                    var i,
                        o,
                        r,
                        a,
                        l,
                        c,
                        h = [],
                        p = [],
                        m = _[t + " "];
                    if (!m) {
                        for (e || (e = s(t)), i = e.length; i--; ) (m = Ct(e[i]))[x] ? h.push(m) : p.push(m);
                        (m = _(
                            t,
                            ((o = p),
                            (a = 0 < (r = h).length),
                            (l = 0 < o.length),
                            (c = function (t, e, i, s, c) {
                                var h,
                                    p,
                                    m,
                                    v = 0,
                                    y = "0",
                                    b = t && [],
                                    x = [],
                                    S = u,
                                    T = t || (l && n.find.TAG("*", c)),
                                    C = (w += null == S ? 1 : Math.random() || 0.1),
                                    E = T.length;
                                for (c && (u = e == f || e || c); y !== E && null != (h = T[y]); y++) {
                                    if (l && h) {
                                        for (p = 0, e || h.ownerDocument == f || (d(h), (i = !g)); (m = o[p++]); )
                                            if (m(h, e || f, i)) {
                                                s.push(h);
                                                break;
                                            }
                                        c && (w = C);
                                    }
                                    a && ((h = !m && h) && v--, t && b.push(h));
                                }
                                if (((v += y), a && y !== v)) {
                                    for (p = 0; (m = r[p++]); ) m(b, x, e, i);
                                    if (t) {
                                        if (0 < v) for (; y--; ) b[y] || x[y] || (x[y] = z.call(s));
                                        x = wt(x);
                                    }
                                    A.apply(s, x), c && !t && 0 < x.length && 1 < v + r.length && at.uniqueSort(s);
                                }
                                return c && ((w = C), (u = S)), b;
                            }),
                            a ? ut(c) : c)
                        )).selector = t;
                    }
                    return m;
                }),
                (l = at.select = function (t, e, i, o) {
                    var r,
                        l,
                        u,
                        c,
                        h,
                        d = "function" == typeof t && t,
                        f = !o && s((t = d.selector || t));
                    if (((i = i || []), 1 === f.length)) {
                        if (2 < (l = f[0] = f[0].slice(0)).length && "ID" === (u = l[0]).type && 9 === e.nodeType && g && n.relative[l[1].type]) {
                            if (!(e = (n.find.ID(u.matches[0].replace(et, it), e) || [])[0])) return i;
                            d && (e = e.parentNode), (t = t.slice(l.shift().value.length));
                        }
                        for (r = G.needsContext.test(t) ? 0 : l.length; r-- && ((u = l[r]), !n.relative[(c = u.type)]); )
                            if ((h = n.find[c]) && (o = h(u.matches[0].replace(et, it), (tt.test(l[0].type) && vt(e.parentNode)) || e))) {
                                if ((l.splice(r, 1), !(t = o.length && bt(l)))) return A.apply(i, o), i;
                                break;
                            }
                    }
                    return (d || a(t, f))(o, e, !g, i, !e || (tt.test(t) && vt(e.parentNode)) || e), i;
                }),
                (i.sortStable = x.split("").sort(I).join("") === x),
                (i.detectDuplicates = !!h),
                d(),
                (i.sortDetached = ct(function (t) {
                    return 1 & t.compareDocumentPosition(f.createElement("fieldset"));
                })),
                ct(function (t) {
                    return (t.innerHTML = "<a href='#'></a>"), "#" === t.firstChild.getAttribute("href");
                }) ||
                    ht("type|href|height|width", function (t, e, i) {
                        if (!i) return t.getAttribute(e, "type" === e.toLowerCase() ? 1 : 2);
                    }),
                (i.attributes &&
                    ct(function (t) {
                        return (t.innerHTML = "<input/>"), t.firstChild.setAttribute("value", ""), "" === t.firstChild.getAttribute("value");
                    })) ||
                    ht("value", function (t, e, i) {
                        if (!i && "input" === t.nodeName.toLowerCase()) return t.defaultValue;
                    }),
                ct(function (t) {
                    return null == t.getAttribute("disabled");
                }) ||
                    ht(M, function (t, e, i) {
                        var n;
                        if (!i) return !0 === t[e] ? e.toLowerCase() : (n = t.getAttributeNode(e)) && n.specified ? n.value : null;
                    }),
                at
            );
        })(t);
        (S.find = T), (S.expr = T.selectors), (S.expr[":"] = S.expr.pseudos), (S.uniqueSort = S.unique = T.uniqueSort), (S.text = T.getText), (S.isXMLDoc = T.isXML), (S.contains = T.contains), (S.escapeSelector = T.escape);
        var C = function (t, e, i) {
                for (var n = [], o = void 0 !== i; (t = t[e]) && 9 !== t.nodeType; )
                    if (1 === t.nodeType) {
                        if (o && S(t).is(i)) break;
                        n.push(t);
                    }
                return n;
            },
            E = function (t, e) {
                for (var i = []; t; t = t.nextSibling) 1 === t.nodeType && t !== e && i.push(t);
                return i;
            },
            _ = S.expr.match.needsContext;
        function k(t, e) {
            return t.nodeName && t.nodeName.toLowerCase() === e.toLowerCase();
        }
        var I = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;
        function D(t, e, i) {
            return p(e)
                ? S.grep(t, function (t, n) {
                      return !!e.call(t, n, t) !== i;
                  })
                : e.nodeType
                ? S.grep(t, function (t) {
                      return (t === e) !== i;
                  })
                : "string" != typeof e
                ? S.grep(t, function (t) {
                      return -1 < a.call(e, t) !== i;
                  })
                : S.filter(e, t, i);
        }
        (S.filter = function (t, e, i) {
            var n = e[0];
            return (
                i && (t = ":not(" + t + ")"),
                1 === e.length && 1 === n.nodeType
                    ? S.find.matchesSelector(n, t)
                        ? [n]
                        : []
                    : S.find.matches(
                          t,
                          S.grep(e, function (t) {
                              return 1 === t.nodeType;
                          })
                      )
            );
        }),
            S.fn.extend({
                find: function (t) {
                    var e,
                        i,
                        n = this.length,
                        o = this;
                    if ("string" != typeof t)
                        return this.pushStack(
                            S(t).filter(function () {
                                for (e = 0; e < n; e++) if (S.contains(o[e], this)) return !0;
                            })
                        );
                    for (i = this.pushStack([]), e = 0; e < n; e++) S.find(t, o[e], i);
                    return 1 < n ? S.uniqueSort(i) : i;
                },
                filter: function (t) {
                    return this.pushStack(D(this, t || [], !1));
                },
                not: function (t) {
                    return this.pushStack(D(this, t || [], !0));
                },
                is: function (t) {
                    return !!D(this, "string" == typeof t && _.test(t) ? S(t) : t || [], !1).length;
                },
            });
        var P,
            z = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/;
        ((S.fn.init = function (t, e, i) {
            var n, o;
            if (!t) return this;
            if (((i = i || P), "string" == typeof t)) {
                if (!(n = "<" === t[0] && ">" === t[t.length - 1] && 3 <= t.length ? [null, t, null] : z.exec(t)) || (!n[1] && e)) return !e || e.jquery ? (e || i).find(t) : this.constructor(e).find(t);
                if (n[1]) {
                    if (((e = e instanceof S ? e[0] : e), S.merge(this, S.parseHTML(n[1], e && e.nodeType ? e.ownerDocument || e : m, !0)), I.test(n[1]) && S.isPlainObject(e))) for (n in e) p(this[n]) ? this[n](e[n]) : this.attr(n, e[n]);
                    return this;
                }
                return (o = m.getElementById(n[2])) && ((this[0] = o), (this.length = 1)), this;
            }
            return t.nodeType ? ((this[0] = t), (this.length = 1), this) : p(t) ? (void 0 !== i.ready ? i.ready(t) : t(S)) : S.makeArray(t, this);
        }).prototype = S.fn),
            (P = S(m));
        var L = /^(?:parents|prev(?:Until|All))/,
            A = { children: !0, contents: !0, next: !0, prev: !0 };
        function N(t, e) {
            for (; (t = t[e]) && 1 !== t.nodeType; );
            return t;
        }
        S.fn.extend({
            has: function (t) {
                var e = S(t, this),
                    i = e.length;
                return this.filter(function () {
                    for (var t = 0; t < i; t++) if (S.contains(this, e[t])) return !0;
                });
            },
            closest: function (t, e) {
                var i,
                    n = 0,
                    o = this.length,
                    r = [],
                    s = "string" != typeof t && S(t);
                if (!_.test(t))
                    for (; n < o; n++)
                        for (i = this[n]; i && i !== e; i = i.parentNode)
                            if (i.nodeType < 11 && (s ? -1 < s.index(i) : 1 === i.nodeType && S.find.matchesSelector(i, t))) {
                                r.push(i);
                                break;
                            }
                return this.pushStack(1 < r.length ? S.uniqueSort(r) : r);
            },
            index: function (t) {
                return t ? ("string" == typeof t ? a.call(S(t), this[0]) : a.call(this, t.jquery ? t[0] : t)) : this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
            },
            add: function (t, e) {
                return this.pushStack(S.uniqueSort(S.merge(this.get(), S(t, e))));
            },
            addBack: function (t) {
                return this.add(null == t ? this.prevObject : this.prevObject.filter(t));
            },
        }),
            S.each(
                {
                    parent: function (t) {
                        var e = t.parentNode;
                        return e && 11 !== e.nodeType ? e : null;
                    },
                    parents: function (t) {
                        return C(t, "parentNode");
                    },
                    parentsUntil: function (t, e, i) {
                        return C(t, "parentNode", i);
                    },
                    next: function (t) {
                        return N(t, "nextSibling");
                    },
                    prev: function (t) {
                        return N(t, "previousSibling");
                    },
                    nextAll: function (t) {
                        return C(t, "nextSibling");
                    },
                    prevAll: function (t) {
                        return C(t, "previousSibling");
                    },
                    nextUntil: function (t, e, i) {
                        return C(t, "nextSibling", i);
                    },
                    prevUntil: function (t, e, i) {
                        return C(t, "previousSibling", i);
                    },
                    siblings: function (t) {
                        return E((t.parentNode || {}).firstChild, t);
                    },
                    children: function (t) {
                        return E(t.firstChild);
                    },
                    contents: function (t) {
                        return null != t.contentDocument && n(t.contentDocument) ? t.contentDocument : (k(t, "template") && (t = t.content || t), S.merge([], t.childNodes));
                    },
                },
                function (t, e) {
                    S.fn[t] = function (i, n) {
                        var o = S.map(this, e, i);
                        return "Until" !== t.slice(-5) && (n = i), n && "string" == typeof n && (o = S.filter(n, o)), 1 < this.length && (A[t] || S.uniqueSort(o), L.test(t) && o.reverse()), this.pushStack(o);
                    };
                }
            );
        var j = /[^\x20\t\r\n\f]+/g;
        function M(t) {
            return t;
        }
        function W(t) {
            throw t;
        }
        function O(t, e, i, n) {
            var o;
            try {
                t && p((o = t.promise)) ? o.call(t).done(e).fail(i) : t && p((o = t.then)) ? o.call(t, e, i) : e.apply(void 0, [t].slice(n));
            } catch (t) {
                i.apply(void 0, [t]);
            }
        }
        (S.Callbacks = function (t) {
            var e, i;
            t =
                "string" == typeof t
                    ? ((e = t),
                      (i = {}),
                      S.each(e.match(j) || [], function (t, e) {
                          i[e] = !0;
                      }),
                      i)
                    : S.extend({}, t);
            var n,
                o,
                r,
                s,
                a = [],
                l = [],
                u = -1,
                c = function () {
                    for (s = s || t.once, r = n = !0; l.length; u = -1) for (o = l.shift(); ++u < a.length; ) !1 === a[u].apply(o[0], o[1]) && t.stopOnFalse && ((u = a.length), (o = !1));
                    t.memory || (o = !1), (n = !1), s && (a = o ? [] : "");
                },
                h = {
                    add: function () {
                        return (
                            a &&
                                (o && !n && ((u = a.length - 1), l.push(o)),
                                (function e(i) {
                                    S.each(i, function (i, n) {
                                        p(n) ? (t.unique && h.has(n)) || a.push(n) : n && n.length && "string" !== b(n) && e(n);
                                    });
                                })(arguments),
                                o && !n && c()),
                            this
                        );
                    },
                    remove: function () {
                        return (
                            S.each(arguments, function (t, e) {
                                for (var i; -1 < (i = S.inArray(e, a, i)); ) a.splice(i, 1), i <= u && u--;
                            }),
                            this
                        );
                    },
                    has: function (t) {
                        return t ? -1 < S.inArray(t, a) : 0 < a.length;
                    },
                    empty: function () {
                        return a && (a = []), this;
                    },
                    disable: function () {
                        return (s = l = []), (a = o = ""), this;
                    },
                    disabled: function () {
                        return !a;
                    },
                    lock: function () {
                        return (s = l = []), o || n || (a = o = ""), this;
                    },
                    locked: function () {
                        return !!s;
                    },
                    fireWith: function (t, e) {
                        return s || ((e = [t, (e = e || []).slice ? e.slice() : e]), l.push(e), n || c()), this;
                    },
                    fire: function () {
                        return h.fireWith(this, arguments), this;
                    },
                    fired: function () {
                        return !!r;
                    },
                };
            return h;
        }),
            S.extend({
                Deferred: function (e) {
                    var i = [
                            ["notify", "progress", S.Callbacks("memory"), S.Callbacks("memory"), 2],
                            ["resolve", "done", S.Callbacks("once memory"), S.Callbacks("once memory"), 0, "resolved"],
                            ["reject", "fail", S.Callbacks("once memory"), S.Callbacks("once memory"), 1, "rejected"],
                        ],
                        n = "pending",
                        o = {
                            state: function () {
                                return n;
                            },
                            always: function () {
                                return r.done(arguments).fail(arguments), this;
                            },
                            catch: function (t) {
                                return o.then(null, t);
                            },
                            pipe: function () {
                                var t = arguments;
                                return S.Deferred(function (e) {
                                    S.each(i, function (i, n) {
                                        var o = p(t[n[4]]) && t[n[4]];
                                        r[n[1]](function () {
                                            var t = o && o.apply(this, arguments);
                                            t && p(t.promise) ? t.promise().progress(e.notify).done(e.resolve).fail(e.reject) : e[n[0] + "With"](this, o ? [t] : arguments);
                                        });
                                    }),
                                        (t = null);
                                }).promise();
                            },
                            then: function (e, n, o) {
                                var r = 0;
                                function s(e, i, n, o) {
                                    return function () {
                                        var a = this,
                                            l = arguments,
                                            u = function () {
                                                var t, u;
                                                if (!(e < r)) {
                                                    if ((t = n.apply(a, l)) === i.promise()) throw new TypeError("Thenable self-resolution");
                                                    (u = t && ("object" == typeof t || "function" == typeof t) && t.then),
                                                        p(u)
                                                            ? o
                                                                ? u.call(t, s(r, i, M, o), s(r, i, W, o))
                                                                : (r++, u.call(t, s(r, i, M, o), s(r, i, W, o), s(r, i, M, i.notifyWith)))
                                                            : (n !== M && ((a = void 0), (l = [t])), (o || i.resolveWith)(a, l));
                                                }
                                            },
                                            c = o
                                                ? u
                                                : function () {
                                                      try {
                                                          u();
                                                      } catch (t) {
                                                          S.Deferred.exceptionHook && S.Deferred.exceptionHook(t, c.stackTrace), r <= e + 1 && (n !== W && ((a = void 0), (l = [t])), i.rejectWith(a, l));
                                                      }
                                                  };
                                        e ? c() : (S.Deferred.getStackHook && (c.stackTrace = S.Deferred.getStackHook()), t.setTimeout(c));
                                    };
                                }
                                return S.Deferred(function (t) {
                                    i[0][3].add(s(0, t, p(o) ? o : M, t.notifyWith)), i[1][3].add(s(0, t, p(e) ? e : M)), i[2][3].add(s(0, t, p(n) ? n : W));
                                }).promise();
                            },
                            promise: function (t) {
                                return null != t ? S.extend(t, o) : o;
                            },
                        },
                        r = {};
                    return (
                        S.each(i, function (t, e) {
                            var s = e[2],
                                a = e[5];
                            (o[e[1]] = s.add),
                                a &&
                                    s.add(
                                        function () {
                                            n = a;
                                        },
                                        i[3 - t][2].disable,
                                        i[3 - t][3].disable,
                                        i[0][2].lock,
                                        i[0][3].lock
                                    ),
                                s.add(e[3].fire),
                                (r[e[0]] = function () {
                                    return r[e[0] + "With"](this === r ? void 0 : this, arguments), this;
                                }),
                                (r[e[0] + "With"] = s.fireWith);
                        }),
                        o.promise(r),
                        e && e.call(r, r),
                        r
                    );
                },
                when: function (t) {
                    var e = arguments.length,
                        i = e,
                        n = Array(i),
                        r = o.call(arguments),
                        s = S.Deferred(),
                        a = function (t) {
                            return function (i) {
                                (n[t] = this), (r[t] = 1 < arguments.length ? o.call(arguments) : i), --e || s.resolveWith(n, r);
                            };
                        };
                    if (e <= 1 && (O(t, s.done(a(i)).resolve, s.reject, !e), "pending" === s.state() || p(r[i] && r[i].then))) return s.then();
                    for (; i--; ) O(r[i], a(i), s.reject);
                    return s.promise();
                },
            });
        var q = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;
        (S.Deferred.exceptionHook = function (e, i) {
            t.console && t.console.warn && e && q.test(e.name) && t.console.warn("jQuery.Deferred exception: " + e.message, e.stack, i);
        }),
            (S.readyException = function (e) {
                t.setTimeout(function () {
                    throw e;
                });
            });
        var H = S.Deferred();
        function R() {
            m.removeEventListener("DOMContentLoaded", R), t.removeEventListener("load", R), S.ready();
        }
        (S.fn.ready = function (t) {
            return (
                H.then(t).catch(function (t) {
                    S.readyException(t);
                }),
                this
            );
        }),
            S.extend({
                isReady: !1,
                readyWait: 1,
                ready: function (t) {
                    (!0 === t ? --S.readyWait : S.isReady) || ((S.isReady = !0) !== t && 0 < --S.readyWait) || H.resolveWith(m, [S]);
                },
            }),
            (S.ready.then = H.then),
            "complete" === m.readyState || ("loading" !== m.readyState && !m.documentElement.doScroll) ? t.setTimeout(S.ready) : (m.addEventListener("DOMContentLoaded", R), t.addEventListener("load", R));
        var F = function (t, e, i, n, o, r, s) {
                var a = 0,
                    l = t.length,
                    u = null == i;
                if ("object" === b(i)) for (a in ((o = !0), i)) F(t, e, a, i[a], !0, r, s);
                else if (
                    void 0 !== n &&
                    ((o = !0),
                    p(n) || (s = !0),
                    u &&
                        (s
                            ? (e.call(t, n), (e = null))
                            : ((u = e),
                              (e = function (t, e, i) {
                                  return u.call(S(t), i);
                              }))),
                    e)
                )
                    for (; a < l; a++) e(t[a], i, s ? n : n.call(t[a], a, e(t[a], i)));
                return o ? t : u ? e.call(t) : l ? e(t[0], i) : r;
            },
            $ = /^-ms-/,
            B = /-([a-z])/g;
        function U(t, e) {
            return e.toUpperCase();
        }
        function V(t) {
            return t.replace($, "ms-").replace(B, U);
        }
        var X = function (t) {
            return 1 === t.nodeType || 9 === t.nodeType || !+t.nodeType;
        };
        function G() {
            this.expando = S.expando + G.uid++;
        }
        (G.uid = 1),
            (G.prototype = {
                cache: function (t) {
                    var e = t[this.expando];
                    return e || ((e = {}), X(t) && (t.nodeType ? (t[this.expando] = e) : Object.defineProperty(t, this.expando, { value: e, configurable: !0 }))), e;
                },
                set: function (t, e, i) {
                    var n,
                        o = this.cache(t);
                    if ("string" == typeof e) o[V(e)] = i;
                    else for (n in e) o[V(n)] = e[n];
                    return o;
                },
                get: function (t, e) {
                    return void 0 === e ? this.cache(t) : t[this.expando] && t[this.expando][V(e)];
                },
                access: function (t, e, i) {
                    return void 0 === e || (e && "string" == typeof e && void 0 === i) ? this.get(t, e) : (this.set(t, e, i), void 0 !== i ? i : e);
                },
                remove: function (t, e) {
                    var i,
                        n = t[this.expando];
                    if (void 0 !== n) {
                        if (void 0 !== e) {
                            i = (e = Array.isArray(e) ? e.map(V) : (e = V(e)) in n ? [e] : e.match(j) || []).length;
                            for (; i--; ) delete n[e[i]];
                        }
                        (void 0 === e || S.isEmptyObject(n)) && (t.nodeType ? (t[this.expando] = void 0) : delete t[this.expando]);
                    }
                },
                hasData: function (t) {
                    var e = t[this.expando];
                    return void 0 !== e && !S.isEmptyObject(e);
                },
            });
        var Y = new G(),
            Q = new G(),
            J = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
            Z = /[A-Z]/g;
        function K(t, e, i) {
            var n, o;
            if (void 0 === i && 1 === t.nodeType)
                if (((n = "data-" + e.replace(Z, "-$&").toLowerCase()), "string" == typeof (i = t.getAttribute(n)))) {
                    try {
                        i = "true" === (o = i) || ("false" !== o && ("null" === o ? null : o === +o + "" ? +o : J.test(o) ? JSON.parse(o) : o));
                    } catch (t) {}
                    Q.set(t, e, i);
                } else i = void 0;
            return i;
        }
        S.extend({
            hasData: function (t) {
                return Q.hasData(t) || Y.hasData(t);
            },
            data: function (t, e, i) {
                return Q.access(t, e, i);
            },
            removeData: function (t, e) {
                Q.remove(t, e);
            },
            _data: function (t, e, i) {
                return Y.access(t, e, i);
            },
            _removeData: function (t, e) {
                Y.remove(t, e);
            },
        }),
            S.fn.extend({
                data: function (t, e) {
                    var i,
                        n,
                        o,
                        r = this[0],
                        s = r && r.attributes;
                    if (void 0 === t) {
                        if (this.length && ((o = Q.get(r)), 1 === r.nodeType && !Y.get(r, "hasDataAttrs"))) {
                            for (i = s.length; i--; ) s[i] && 0 === (n = s[i].name).indexOf("data-") && ((n = V(n.slice(5))), K(r, n, o[n]));
                            Y.set(r, "hasDataAttrs", !0);
                        }
                        return o;
                    }
                    return "object" == typeof t
                        ? this.each(function () {
                              Q.set(this, t);
                          })
                        : F(
                              this,
                              function (e) {
                                  var i;
                                  if (r && void 0 === e) return void 0 !== (i = Q.get(r, t)) ? i : void 0 !== (i = K(r, t)) ? i : void 0;
                                  this.each(function () {
                                      Q.set(this, t, e);
                                  });
                              },
                              null,
                              e,
                              1 < arguments.length,
                              null,
                              !0
                          );
                },
                removeData: function (t) {
                    return this.each(function () {
                        Q.remove(this, t);
                    });
                },
            }),
            S.extend({
                queue: function (t, e, i) {
                    var n;
                    if (t) return (e = (e || "fx") + "queue"), (n = Y.get(t, e)), i && (!n || Array.isArray(i) ? (n = Y.access(t, e, S.makeArray(i))) : n.push(i)), n || [];
                },
                dequeue: function (t, e) {
                    e = e || "fx";
                    var i = S.queue(t, e),
                        n = i.length,
                        o = i.shift(),
                        r = S._queueHooks(t, e);
                    "inprogress" === o && ((o = i.shift()), n--),
                        o &&
                            ("fx" === e && i.unshift("inprogress"),
                            delete r.stop,
                            o.call(
                                t,
                                function () {
                                    S.dequeue(t, e);
                                },
                                r
                            )),
                        !n && r && r.empty.fire();
                },
                _queueHooks: function (t, e) {
                    var i = e + "queueHooks";
                    return (
                        Y.get(t, i) ||
                        Y.access(t, i, {
                            empty: S.Callbacks("once memory").add(function () {
                                Y.remove(t, [e + "queue", i]);
                            }),
                        })
                    );
                },
            }),
            S.fn.extend({
                queue: function (t, e) {
                    var i = 2;
                    return (
                        "string" != typeof t && ((e = t), (t = "fx"), i--),
                        arguments.length < i
                            ? S.queue(this[0], t)
                            : void 0 === e
                            ? this
                            : this.each(function () {
                                  var i = S.queue(this, t, e);
                                  S._queueHooks(this, t), "fx" === t && "inprogress" !== i[0] && S.dequeue(this, t);
                              })
                    );
                },
                dequeue: function (t) {
                    return this.each(function () {
                        S.dequeue(this, t);
                    });
                },
                clearQueue: function (t) {
                    return this.queue(t || "fx", []);
                },
                promise: function (t, e) {
                    var i,
                        n = 1,
                        o = S.Deferred(),
                        r = this,
                        s = this.length,
                        a = function () {
                            --n || o.resolveWith(r, [r]);
                        };
                    for ("string" != typeof t && ((e = t), (t = void 0)), t = t || "fx"; s--; ) (i = Y.get(r[s], t + "queueHooks")) && i.empty && (n++, i.empty.add(a));
                    return a(), o.promise(e);
                },
            });
        var tt = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source,
            et = new RegExp("^(?:([+-])=|)(" + tt + ")([a-z%]*)$", "i"),
            it = ["Top", "Right", "Bottom", "Left"],
            nt = m.documentElement,
            ot = function (t) {
                return S.contains(t.ownerDocument, t);
            },
            rt = { composed: !0 };
        nt.getRootNode &&
            (ot = function (t) {
                return S.contains(t.ownerDocument, t) || t.getRootNode(rt) === t.ownerDocument;
            });
        var st = function (t, e) {
            return "none" === (t = e || t).style.display || ("" === t.style.display && ot(t) && "none" === S.css(t, "display"));
        };
        function at(t, e, i, n) {
            var o,
                r,
                s = 20,
                a = n
                    ? function () {
                          return n.cur();
                      }
                    : function () {
                          return S.css(t, e, "");
                      },
                l = a(),
                u = (i && i[3]) || (S.cssNumber[e] ? "" : "px"),
                c = t.nodeType && (S.cssNumber[e] || ("px" !== u && +l)) && et.exec(S.css(t, e));
            if (c && c[3] !== u) {
                for (l /= 2, u = u || c[3], c = +l || 1; s--; ) S.style(t, e, c + u), (1 - r) * (1 - (r = a() / l || 0.5)) <= 0 && (s = 0), (c /= r);
                (c *= 2), S.style(t, e, c + u), (i = i || []);
            }
            return i && ((c = +c || +l || 0), (o = i[1] ? c + (i[1] + 1) * i[2] : +i[2]), n && ((n.unit = u), (n.start = c), (n.end = o))), o;
        }
        var lt = {};
        function ut(t, e) {
            for (var i, n, o, r, s, a, l, u = [], c = 0, h = t.length; c < h; c++)
                (n = t[c]).style &&
                    ((i = n.style.display),
                    e
                        ? ("none" === i && ((u[c] = Y.get(n, "display") || null), u[c] || (n.style.display = "")),
                          "" === n.style.display &&
                              st(n) &&
                              (u[c] =
                                  ((l = s = r = void 0),
                                  (s = (o = n).ownerDocument),
                                  (a = o.nodeName),
                                  (l = lt[a]) || ((r = s.body.appendChild(s.createElement(a))), (l = S.css(r, "display")), r.parentNode.removeChild(r), "none" === l && (l = "block"), (lt[a] = l)))))
                        : "none" !== i && ((u[c] = "none"), Y.set(n, "display", i)));
            for (c = 0; c < h; c++) null != u[c] && (t[c].style.display = u[c]);
            return t;
        }
        S.fn.extend({
            show: function () {
                return ut(this, !0);
            },
            hide: function () {
                return ut(this);
            },
            toggle: function (t) {
                return "boolean" == typeof t
                    ? t
                        ? this.show()
                        : this.hide()
                    : this.each(function () {
                          st(this) ? S(this).show() : S(this).hide();
                      });
            },
        });
        var ct,
            ht,
            dt = /^(?:checkbox|radio)$/i,
            ft = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i,
            pt = /^$|^module$|\/(?:java|ecma)script/i;
        (ct = m.createDocumentFragment().appendChild(m.createElement("div"))),
            (ht = m.createElement("input")).setAttribute("type", "radio"),
            ht.setAttribute("checked", "checked"),
            ht.setAttribute("name", "t"),
            ct.appendChild(ht),
            (f.checkClone = ct.cloneNode(!0).cloneNode(!0).lastChild.checked),
            (ct.innerHTML = "<textarea>x</textarea>"),
            (f.noCloneChecked = !!ct.cloneNode(!0).lastChild.defaultValue),
            (ct.innerHTML = "<option></option>"),
            (f.option = !!ct.lastChild);
        var gt = { thead: [1, "<table>", "</table>"], col: [2, "<table><colgroup>", "</colgroup></table>"], tr: [2, "<table><tbody>", "</tbody></table>"], td: [3, "<table><tbody><tr>", "</tr></tbody></table>"], _default: [0, "", ""] };
        function mt(t, e) {
            var i;
            return (i = void 0 !== t.getElementsByTagName ? t.getElementsByTagName(e || "*") : void 0 !== t.querySelectorAll ? t.querySelectorAll(e || "*") : []), void 0 === e || (e && k(t, e)) ? S.merge([t], i) : i;
        }
        function vt(t, e) {
            for (var i = 0, n = t.length; i < n; i++) Y.set(t[i], "globalEval", !e || Y.get(e[i], "globalEval"));
        }
        (gt.tbody = gt.tfoot = gt.colgroup = gt.caption = gt.thead), (gt.th = gt.td), f.option || (gt.optgroup = gt.option = [1, "<select multiple='multiple'>", "</select>"]);
        var yt = /<|&#?\w+;/;
        function bt(t, e, i, n, o) {
            for (var r, s, a, l, u, c, h = e.createDocumentFragment(), d = [], f = 0, p = t.length; f < p; f++)
                if ((r = t[f]) || 0 === r)
                    if ("object" === b(r)) S.merge(d, r.nodeType ? [r] : r);
                    else if (yt.test(r)) {
                        for (s = s || h.appendChild(e.createElement("div")), a = (ft.exec(r) || ["", ""])[1].toLowerCase(), l = gt[a] || gt._default, s.innerHTML = l[1] + S.htmlPrefilter(r) + l[2], c = l[0]; c--; ) s = s.lastChild;
                        S.merge(d, s.childNodes), ((s = h.firstChild).textContent = "");
                    } else d.push(e.createTextNode(r));
            for (h.textContent = "", f = 0; (r = d[f++]); )
                if (n && -1 < S.inArray(r, n)) o && o.push(r);
                else if (((u = ot(r)), (s = mt(h.appendChild(r), "script")), u && vt(s), i)) for (c = 0; (r = s[c++]); ) pt.test(r.type || "") && i.push(r);
            return h;
        }
        var xt = /^([^.]*)(?:\.(.+)|)/;
        function St() {
            return !0;
        }
        function wt() {
            return !1;
        }
        function Tt(t, e) {
            return (
                (t ===
                    (function () {
                        try {
                            return m.activeElement;
                        } catch (t) {}
                    })()) ==
                ("focus" === e)
            );
        }
        function Ct(t, e, i, n, o, r) {
            var s, a;
            if ("object" == typeof e) {
                for (a in ("string" != typeof i && ((n = n || i), (i = void 0)), e)) Ct(t, a, i, n, e[a], r);
                return t;
            }
            if ((null == n && null == o ? ((o = i), (n = i = void 0)) : null == o && ("string" == typeof i ? ((o = n), (n = void 0)) : ((o = n), (n = i), (i = void 0))), !1 === o)) o = wt;
            else if (!o) return t;
            return (
                1 === r &&
                    ((s = o),
                    ((o = function (t) {
                        return S().off(t), s.apply(this, arguments);
                    }).guid = s.guid || (s.guid = S.guid++))),
                t.each(function () {
                    S.event.add(this, e, o, n, i);
                })
            );
        }
        function Et(t, e, i) {
            i
                ? (Y.set(t, e, !1),
                  S.event.add(t, e, {
                      namespace: !1,
                      handler: function (t) {
                          var n,
                              r,
                              s = Y.get(this, e);
                          if (1 & t.isTrigger && this[e]) {
                              if (s.length) (S.event.special[e] || {}).delegateType && t.stopPropagation();
                              else if (((s = o.call(arguments)), Y.set(this, e, s), (n = i(this, e)), this[e](), s !== (r = Y.get(this, e)) || n ? Y.set(this, e, !1) : (r = {}), s !== r))
                                  return t.stopImmediatePropagation(), t.preventDefault(), r && r.value;
                          } else s.length && (Y.set(this, e, { value: S.event.trigger(S.extend(s[0], S.Event.prototype), s.slice(1), this) }), t.stopImmediatePropagation());
                      },
                  }))
                : void 0 === Y.get(t, e) && S.event.add(t, e, St);
        }
        (S.event = {
            global: {},
            add: function (t, e, i, n, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    h,
                    d,
                    f,
                    p,
                    g,
                    m = Y.get(t);
                if (X(t))
                    for (
                        i.handler && ((i = (r = i).handler), (o = r.selector)),
                            o && S.find.matchesSelector(nt, o),
                            i.guid || (i.guid = S.guid++),
                            (l = m.events) || (l = m.events = Object.create(null)),
                            (s = m.handle) ||
                                (s = m.handle = function (e) {
                                    return void 0 !== S && S.event.triggered !== e.type ? S.event.dispatch.apply(t, arguments) : void 0;
                                }),
                            u = (e = (e || "").match(j) || [""]).length;
                        u--;

                    )
                        (f = g = (a = xt.exec(e[u]) || [])[1]),
                            (p = (a[2] || "").split(".").sort()),
                            f &&
                                ((h = S.event.special[f] || {}),
                                (f = (o ? h.delegateType : h.bindType) || f),
                                (h = S.event.special[f] || {}),
                                (c = S.extend({ type: f, origType: g, data: n, handler: i, guid: i.guid, selector: o, needsContext: o && S.expr.match.needsContext.test(o), namespace: p.join(".") }, r)),
                                (d = l[f]) || (((d = l[f] = []).delegateCount = 0), (h.setup && !1 !== h.setup.call(t, n, p, s)) || (t.addEventListener && t.addEventListener(f, s))),
                                h.add && (h.add.call(t, c), c.handler.guid || (c.handler.guid = i.guid)),
                                o ? d.splice(d.delegateCount++, 0, c) : d.push(c),
                                (S.event.global[f] = !0));
            },
            remove: function (t, e, i, n, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    c,
                    h,
                    d,
                    f,
                    p,
                    g,
                    m = Y.hasData(t) && Y.get(t);
                if (m && (l = m.events)) {
                    for (u = (e = (e || "").match(j) || [""]).length; u--; )
                        if (((f = g = (a = xt.exec(e[u]) || [])[1]), (p = (a[2] || "").split(".").sort()), f)) {
                            for (h = S.event.special[f] || {}, d = l[(f = (n ? h.delegateType : h.bindType) || f)] || [], a = a[2] && new RegExp("(^|\\.)" + p.join("\\.(?:.*\\.|)") + "(\\.|$)"), s = r = d.length; r--; )
                                (c = d[r]),
                                    (!o && g !== c.origType) ||
                                        (i && i.guid !== c.guid) ||
                                        (a && !a.test(c.namespace)) ||
                                        (n && n !== c.selector && ("**" !== n || !c.selector)) ||
                                        (d.splice(r, 1), c.selector && d.delegateCount--, h.remove && h.remove.call(t, c));
                            s && !d.length && ((h.teardown && !1 !== h.teardown.call(t, p, m.handle)) || S.removeEvent(t, f, m.handle), delete l[f]);
                        } else for (f in l) S.event.remove(t, f + e[u], i, n, !0);
                    S.isEmptyObject(l) && Y.remove(t, "handle events");
                }
            },
            dispatch: function (t) {
                var e,
                    i,
                    n,
                    o,
                    r,
                    s,
                    a = new Array(arguments.length),
                    l = S.event.fix(t),
                    u = (Y.get(this, "events") || Object.create(null))[l.type] || [],
                    c = S.event.special[l.type] || {};
                for (a[0] = l, e = 1; e < arguments.length; e++) a[e] = arguments[e];
                if (((l.delegateTarget = this), !c.preDispatch || !1 !== c.preDispatch.call(this, l))) {
                    for (s = S.event.handlers.call(this, l, u), e = 0; (o = s[e++]) && !l.isPropagationStopped(); )
                        for (l.currentTarget = o.elem, i = 0; (r = o.handlers[i++]) && !l.isImmediatePropagationStopped(); )
                            (l.rnamespace && !1 !== r.namespace && !l.rnamespace.test(r.namespace)) ||
                                ((l.handleObj = r), (l.data = r.data), void 0 !== (n = ((S.event.special[r.origType] || {}).handle || r.handler).apply(o.elem, a)) && !1 === (l.result = n) && (l.preventDefault(), l.stopPropagation()));
                    return c.postDispatch && c.postDispatch.call(this, l), l.result;
                }
            },
            handlers: function (t, e) {
                var i,
                    n,
                    o,
                    r,
                    s,
                    a = [],
                    l = e.delegateCount,
                    u = t.target;
                if (l && u.nodeType && !("click" === t.type && 1 <= t.button))
                    for (; u !== this; u = u.parentNode || this)
                        if (1 === u.nodeType && ("click" !== t.type || !0 !== u.disabled)) {
                            for (r = [], s = {}, i = 0; i < l; i++) void 0 === s[(o = (n = e[i]).selector + " ")] && (s[o] = n.needsContext ? -1 < S(o, this).index(u) : S.find(o, this, null, [u]).length), s[o] && r.push(n);
                            r.length && a.push({ elem: u, handlers: r });
                        }
                return (u = this), l < e.length && a.push({ elem: u, handlers: e.slice(l) }), a;
            },
            addProp: function (t, e) {
                Object.defineProperty(S.Event.prototype, t, {
                    enumerable: !0,
                    configurable: !0,
                    get: p(e)
                        ? function () {
                              if (this.originalEvent) return e(this.originalEvent);
                          }
                        : function () {
                              if (this.originalEvent) return this.originalEvent[t];
                          },
                    set: function (e) {
                        Object.defineProperty(this, t, { enumerable: !0, configurable: !0, writable: !0, value: e });
                    },
                });
            },
            fix: function (t) {
                return t[S.expando] ? t : new S.Event(t);
            },
            special: {
                load: { noBubble: !0 },
                click: {
                    setup: function (t) {
                        var e = this || t;
                        return dt.test(e.type) && e.click && k(e, "input") && Et(e, "click", St), !1;
                    },
                    trigger: function (t) {
                        var e = this || t;
                        return dt.test(e.type) && e.click && k(e, "input") && Et(e, "click"), !0;
                    },
                    _default: function (t) {
                        var e = t.target;
                        return (dt.test(e.type) && e.click && k(e, "input") && Y.get(e, "click")) || k(e, "a");
                    },
                },
                beforeunload: {
                    postDispatch: function (t) {
                        void 0 !== t.result && t.originalEvent && (t.originalEvent.returnValue = t.result);
                    },
                },
            },
        }),
            (S.removeEvent = function (t, e, i) {
                t.removeEventListener && t.removeEventListener(e, i);
            }),
            (S.Event = function (t, e) {
                if (!(this instanceof S.Event)) return new S.Event(t, e);
                t && t.type
                    ? ((this.originalEvent = t),
                      (this.type = t.type),
                      (this.isDefaultPrevented = t.defaultPrevented || (void 0 === t.defaultPrevented && !1 === t.returnValue) ? St : wt),
                      (this.target = t.target && 3 === t.target.nodeType ? t.target.parentNode : t.target),
                      (this.currentTarget = t.currentTarget),
                      (this.relatedTarget = t.relatedTarget))
                    : (this.type = t),
                    e && S.extend(this, e),
                    (this.timeStamp = (t && t.timeStamp) || Date.now()),
                    (this[S.expando] = !0);
            }),
            (S.Event.prototype = {
                constructor: S.Event,
                isDefaultPrevented: wt,
                isPropagationStopped: wt,
                isImmediatePropagationStopped: wt,
                isSimulated: !1,
                preventDefault: function () {
                    var t = this.originalEvent;
                    (this.isDefaultPrevented = St), t && !this.isSimulated && t.preventDefault();
                },
                stopPropagation: function () {
                    var t = this.originalEvent;
                    (this.isPropagationStopped = St), t && !this.isSimulated && t.stopPropagation();
                },
                stopImmediatePropagation: function () {
                    var t = this.originalEvent;
                    (this.isImmediatePropagationStopped = St), t && !this.isSimulated && t.stopImmediatePropagation(), this.stopPropagation();
                },
            }),
            S.each(
                {
                    altKey: !0,
                    bubbles: !0,
                    cancelable: !0,
                    changedTouches: !0,
                    ctrlKey: !0,
                    detail: !0,
                    eventPhase: !0,
                    metaKey: !0,
                    pageX: !0,
                    pageY: !0,
                    shiftKey: !0,
                    view: !0,
                    char: !0,
                    code: !0,
                    charCode: !0,
                    key: !0,
                    keyCode: !0,
                    button: !0,
                    buttons: !0,
                    clientX: !0,
                    clientY: !0,
                    offsetX: !0,
                    offsetY: !0,
                    pointerId: !0,
                    pointerType: !0,
                    screenX: !0,
                    screenY: !0,
                    targetTouches: !0,
                    toElement: !0,
                    touches: !0,
                    which: !0,
                },
                S.event.addProp
            ),
            S.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                S.event.special[t] = {
                    setup: function () {
                        return Et(this, t, Tt), !1;
                    },
                    trigger: function () {
                        return Et(this, t), !0;
                    },
                    _default: function () {
                        return !0;
                    },
                    delegateType: e,
                };
            }),
            S.each({ mouseenter: "mouseover", mouseleave: "mouseout", pointerenter: "pointerover", pointerleave: "pointerout" }, function (t, e) {
                S.event.special[t] = {
                    delegateType: e,
                    bindType: e,
                    handle: function (t) {
                        var i,
                            n = t.relatedTarget,
                            o = t.handleObj;
                        return (n && (n === this || S.contains(this, n))) || ((t.type = o.origType), (i = o.handler.apply(this, arguments)), (t.type = e)), i;
                    },
                };
            }),
            S.fn.extend({
                on: function (t, e, i, n) {
                    return Ct(this, t, e, i, n);
                },
                one: function (t, e, i, n) {
                    return Ct(this, t, e, i, n, 1);
                },
                off: function (t, e, i) {
                    var n, o;
                    if (t && t.preventDefault && t.handleObj) return (n = t.handleObj), S(t.delegateTarget).off(n.namespace ? n.origType + "." + n.namespace : n.origType, n.selector, n.handler), this;
                    if ("object" == typeof t) {
                        for (o in t) this.off(o, e, t[o]);
                        return this;
                    }
                    return (
                        (!1 !== e && "function" != typeof e) || ((i = e), (e = void 0)),
                        !1 === i && (i = wt),
                        this.each(function () {
                            S.event.remove(this, t, i, e);
                        })
                    );
                },
            });
        var _t = /<script|<style|<link/i,
            kt = /checked\s*(?:[^=]|=\s*.checked.)/i,
            It = /^\s*<!(?:\[CDATA\[|--)|(?:\]\]|--)>\s*$/g;
        function Dt(t, e) {
            return (k(t, "table") && k(11 !== e.nodeType ? e : e.firstChild, "tr") && S(t).children("tbody")[0]) || t;
        }
        function Pt(t) {
            return (t.type = (null !== t.getAttribute("type")) + "/" + t.type), t;
        }
        function zt(t) {
            return "true/" === (t.type || "").slice(0, 5) ? (t.type = t.type.slice(5)) : t.removeAttribute("type"), t;
        }
        function Lt(t, e) {
            var i, n, o, r, s, a;
            if (1 === e.nodeType) {
                if (Y.hasData(t) && (a = Y.get(t).events)) for (o in (Y.remove(e, "handle events"), a)) for (i = 0, n = a[o].length; i < n; i++) S.event.add(e, o, a[o][i]);
                Q.hasData(t) && ((r = Q.access(t)), (s = S.extend({}, r)), Q.set(e, s));
            }
        }
        function At(t, e, i, n) {
            e = r(e);
            var o,
                s,
                a,
                l,
                u,
                c,
                h = 0,
                d = t.length,
                g = d - 1,
                m = e[0],
                v = p(m);
            if (v || (1 < d && "string" == typeof m && !f.checkClone && kt.test(m)))
                return t.each(function (o) {
                    var r = t.eq(o);
                    v && (e[0] = m.call(this, o, r.html())), At(r, e, i, n);
                });
            if (d && ((s = (o = bt(e, t[0].ownerDocument, !1, t, n)).firstChild), 1 === o.childNodes.length && (o = s), s || n)) {
                for (l = (a = S.map(mt(o, "script"), Pt)).length; h < d; h++) (u = o), h !== g && ((u = S.clone(u, !0, !0)), l && S.merge(a, mt(u, "script"))), i.call(t[h], u, h);
                if (l)
                    for (c = a[a.length - 1].ownerDocument, S.map(a, zt), h = 0; h < l; h++)
                        (u = a[h]),
                            pt.test(u.type || "") &&
                                !Y.access(u, "globalEval") &&
                                S.contains(c, u) &&
                                (u.src && "module" !== (u.type || "").toLowerCase() ? S._evalUrl && !u.noModule && S._evalUrl(u.src, { nonce: u.nonce || u.getAttribute("nonce") }, c) : y(u.textContent.replace(It, ""), u, c));
            }
            return t;
        }
        function Nt(t, e, i) {
            for (var n, o = e ? S.filter(e, t) : t, r = 0; null != (n = o[r]); r++) i || 1 !== n.nodeType || S.cleanData(mt(n)), n.parentNode && (i && ot(n) && vt(mt(n, "script")), n.parentNode.removeChild(n));
            return t;
        }
        S.extend({
            htmlPrefilter: function (t) {
                return t;
            },
            clone: function (t, e, i) {
                var n,
                    o,
                    r,
                    s,
                    a,
                    l,
                    u,
                    c = t.cloneNode(!0),
                    h = ot(t);
                if (!(f.noCloneChecked || (1 !== t.nodeType && 11 !== t.nodeType) || S.isXMLDoc(t)))
                    for (s = mt(c), n = 0, o = (r = mt(t)).length; n < o; n++)
                        (a = r[n]), "input" === (u = (l = s[n]).nodeName.toLowerCase()) && dt.test(a.type) ? (l.checked = a.checked) : ("input" !== u && "textarea" !== u) || (l.defaultValue = a.defaultValue);
                if (e)
                    if (i) for (r = r || mt(t), s = s || mt(c), n = 0, o = r.length; n < o; n++) Lt(r[n], s[n]);
                    else Lt(t, c);
                return 0 < (s = mt(c, "script")).length && vt(s, !h && mt(t, "script")), c;
            },
            cleanData: function (t) {
                for (var e, i, n, o = S.event.special, r = 0; void 0 !== (i = t[r]); r++)
                    if (X(i)) {
                        if ((e = i[Y.expando])) {
                            if (e.events) for (n in e.events) o[n] ? S.event.remove(i, n) : S.removeEvent(i, n, e.handle);
                            i[Y.expando] = void 0;
                        }
                        i[Q.expando] && (i[Q.expando] = void 0);
                    }
            },
        }),
            S.fn.extend({
                detach: function (t) {
                    return Nt(this, t, !0);
                },
                remove: function (t) {
                    return Nt(this, t);
                },
                text: function (t) {
                    return F(
                        this,
                        function (t) {
                            return void 0 === t
                                ? S.text(this)
                                : this.empty().each(function () {
                                      (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || (this.textContent = t);
                                  });
                        },
                        null,
                        t,
                        arguments.length
                    );
                },
                append: function () {
                    return At(this, arguments, function (t) {
                        (1 !== this.nodeType && 11 !== this.nodeType && 9 !== this.nodeType) || Dt(this, t).appendChild(t);
                    });
                },
                prepend: function () {
                    return At(this, arguments, function (t) {
                        if (1 === this.nodeType || 11 === this.nodeType || 9 === this.nodeType) {
                            var e = Dt(this, t);
                            e.insertBefore(t, e.firstChild);
                        }
                    });
                },
                before: function () {
                    return At(this, arguments, function (t) {
                        this.parentNode && this.parentNode.insertBefore(t, this);
                    });
                },
                after: function () {
                    return At(this, arguments, function (t) {
                        this.parentNode && this.parentNode.insertBefore(t, this.nextSibling);
                    });
                },
                empty: function () {
                    for (var t, e = 0; null != (t = this[e]); e++) 1 === t.nodeType && (S.cleanData(mt(t, !1)), (t.textContent = ""));
                    return this;
                },
                clone: function (t, e) {
                    return (
                        (t = null != t && t),
                        (e = null == e ? t : e),
                        this.map(function () {
                            return S.clone(this, t, e);
                        })
                    );
                },
                html: function (t) {
                    return F(
                        this,
                        function (t) {
                            var e = this[0] || {},
                                i = 0,
                                n = this.length;
                            if (void 0 === t && 1 === e.nodeType) return e.innerHTML;
                            if ("string" == typeof t && !_t.test(t) && !gt[(ft.exec(t) || ["", ""])[1].toLowerCase()]) {
                                t = S.htmlPrefilter(t);
                                try {
                                    for (; i < n; i++) 1 === (e = this[i] || {}).nodeType && (S.cleanData(mt(e, !1)), (e.innerHTML = t));
                                    e = 0;
                                } catch (t) {}
                            }
                            e && this.empty().append(t);
                        },
                        null,
                        t,
                        arguments.length
                    );
                },
                replaceWith: function () {
                    var t = [];
                    return At(
                        this,
                        arguments,
                        function (e) {
                            var i = this.parentNode;
                            S.inArray(this, t) < 0 && (S.cleanData(mt(this)), i && i.replaceChild(e, this));
                        },
                        t
                    );
                },
            }),
            S.each({ appendTo: "append", prependTo: "prepend", insertBefore: "before", insertAfter: "after", replaceAll: "replaceWith" }, function (t, e) {
                S.fn[t] = function (t) {
                    for (var i, n = [], o = S(t), r = o.length - 1, a = 0; a <= r; a++) (i = a === r ? this : this.clone(!0)), S(o[a])[e](i), s.apply(n, i.get());
                    return this.pushStack(n);
                };
            });
        var jt = new RegExp("^(" + tt + ")(?!px)[a-z%]+$", "i"),
            Mt = function (e) {
                var i = e.ownerDocument.defaultView;
                return (i && i.opener) || (i = t), i.getComputedStyle(e);
            },
            Wt = function (t, e, i) {
                var n,
                    o,
                    r = {};
                for (o in e) (r[o] = t.style[o]), (t.style[o] = e[o]);
                for (o in ((n = i.call(t)), e)) t.style[o] = r[o];
                return n;
            },
            Ot = new RegExp(it.join("|"), "i");
        function qt(t, e, i) {
            var n,
                o,
                r,
                s,
                a = t.style;
            return (
                (i = i || Mt(t)) &&
                    ("" !== (s = i.getPropertyValue(e) || i[e]) || ot(t) || (s = S.style(t, e)),
                    !f.pixelBoxStyles() && jt.test(s) && Ot.test(e) && ((n = a.width), (o = a.minWidth), (r = a.maxWidth), (a.minWidth = a.maxWidth = a.width = s), (s = i.width), (a.width = n), (a.minWidth = o), (a.maxWidth = r))),
                void 0 !== s ? s + "" : s
            );
        }
        function Ht(t, e) {
            return {
                get: function () {
                    if (!t()) return (this.get = e).apply(this, arguments);
                    delete this.get;
                },
            };
        }
        !(function () {
            function e() {
                if (c) {
                    (u.style.cssText = "position:absolute;left:-11111px;width:60px;margin-top:1px;padding:0;border:0"),
                        (c.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;margin:auto;border:1px;padding:1px;width:60%;top:1%"),
                        nt.appendChild(u).appendChild(c);
                    var e = t.getComputedStyle(c);
                    (n = "1%" !== e.top),
                        (l = 12 === i(e.marginLeft)),
                        (c.style.right = "60%"),
                        (s = 36 === i(e.right)),
                        (o = 36 === i(e.width)),
                        (c.style.position = "absolute"),
                        (r = 12 === i(c.offsetWidth / 3)),
                        nt.removeChild(u),
                        (c = null);
                }
            }
            function i(t) {
                return Math.round(parseFloat(t));
            }
            var n,
                o,
                r,
                s,
                a,
                l,
                u = m.createElement("div"),
                c = m.createElement("div");
            c.style &&
                ((c.style.backgroundClip = "content-box"),
                (c.cloneNode(!0).style.backgroundClip = ""),
                (f.clearCloneStyle = "content-box" === c.style.backgroundClip),
                S.extend(f, {
                    boxSizingReliable: function () {
                        return e(), o;
                    },
                    pixelBoxStyles: function () {
                        return e(), s;
                    },
                    pixelPosition: function () {
                        return e(), n;
                    },
                    reliableMarginLeft: function () {
                        return e(), l;
                    },
                    scrollboxSize: function () {
                        return e(), r;
                    },
                    reliableTrDimensions: function () {
                        var e, i, n, o;
                        return (
                            null == a &&
                                ((e = m.createElement("table")),
                                (i = m.createElement("tr")),
                                (n = m.createElement("div")),
                                (e.style.cssText = "position:absolute;left:-11111px;border-collapse:separate"),
                                (i.style.cssText = "border:1px solid"),
                                (i.style.height = "1px"),
                                (n.style.height = "9px"),
                                (n.style.display = "block"),
                                nt.appendChild(e).appendChild(i).appendChild(n),
                                (o = t.getComputedStyle(i)),
                                (a = parseInt(o.height, 10) + parseInt(o.borderTopWidth, 10) + parseInt(o.borderBottomWidth, 10) === i.offsetHeight),
                                nt.removeChild(e)),
                            a
                        );
                    },
                }));
        })();
        var Rt = ["Webkit", "Moz", "ms"],
            Ft = m.createElement("div").style,
            $t = {};
        function Bt(t) {
            return (
                S.cssProps[t] ||
                $t[t] ||
                (t in Ft
                    ? t
                    : ($t[t] =
                          (function (t) {
                              for (var e = t[0].toUpperCase() + t.slice(1), i = Rt.length; i--; ) if ((t = Rt[i] + e) in Ft) return t;
                          })(t) || t))
            );
        }
        var Ut = /^(none|table(?!-c[ea]).+)/,
            Vt = /^--/,
            Xt = { position: "absolute", visibility: "hidden", display: "block" },
            Gt = { letterSpacing: "0", fontWeight: "400" };
        function Yt(t, e, i) {
            var n = et.exec(e);
            return n ? Math.max(0, n[2] - (i || 0)) + (n[3] || "px") : e;
        }
        function Qt(t, e, i, n, o, r) {
            var s = "width" === e ? 1 : 0,
                a = 0,
                l = 0;
            if (i === (n ? "border" : "content")) return 0;
            for (; s < 4; s += 2)
                "margin" === i && (l += S.css(t, i + it[s], !0, o)),
                    n
                        ? ("content" === i && (l -= S.css(t, "padding" + it[s], !0, o)), "margin" !== i && (l -= S.css(t, "border" + it[s] + "Width", !0, o)))
                        : ((l += S.css(t, "padding" + it[s], !0, o)), "padding" !== i ? (l += S.css(t, "border" + it[s] + "Width", !0, o)) : (a += S.css(t, "border" + it[s] + "Width", !0, o)));
            return !n && 0 <= r && (l += Math.max(0, Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - r - l - a - 0.5)) || 0), l;
        }
        function Jt(t, e, i) {
            var n = Mt(t),
                o = (!f.boxSizingReliable() || i) && "border-box" === S.css(t, "boxSizing", !1, n),
                r = o,
                s = qt(t, e, n),
                a = "offset" + e[0].toUpperCase() + e.slice(1);
            if (jt.test(s)) {
                if (!i) return s;
                s = "auto";
            }
            return (
                ((!f.boxSizingReliable() && o) || (!f.reliableTrDimensions() && k(t, "tr")) || "auto" === s || (!parseFloat(s) && "inline" === S.css(t, "display", !1, n))) &&
                    t.getClientRects().length &&
                    ((o = "border-box" === S.css(t, "boxSizing", !1, n)), (r = a in t) && (s = t[a])),
                (s = parseFloat(s) || 0) + Qt(t, e, i || (o ? "border" : "content"), r, n, s) + "px"
            );
        }
        function Zt(t, e, i, n, o) {
            return new Zt.prototype.init(t, e, i, n, o);
        }
        S.extend({
            cssHooks: {
                opacity: {
                    get: function (t, e) {
                        if (e) {
                            var i = qt(t, "opacity");
                            return "" === i ? "1" : i;
                        }
                    },
                },
            },
            cssNumber: {
                animationIterationCount: !0,
                columnCount: !0,
                fillOpacity: !0,
                flexGrow: !0,
                flexShrink: !0,
                fontWeight: !0,
                gridArea: !0,
                gridColumn: !0,
                gridColumnEnd: !0,
                gridColumnStart: !0,
                gridRow: !0,
                gridRowEnd: !0,
                gridRowStart: !0,
                lineHeight: !0,
                opacity: !0,
                order: !0,
                orphans: !0,
                widows: !0,
                zIndex: !0,
                zoom: !0,
            },
            cssProps: {},
            style: function (t, e, i, n) {
                if (t && 3 !== t.nodeType && 8 !== t.nodeType && t.style) {
                    var o,
                        r,
                        s,
                        a = V(e),
                        l = Vt.test(e),
                        u = t.style;
                    if ((l || (e = Bt(a)), (s = S.cssHooks[e] || S.cssHooks[a]), void 0 === i)) return s && "get" in s && void 0 !== (o = s.get(t, !1, n)) ? o : u[e];
                    "string" == (r = typeof i) && (o = et.exec(i)) && o[1] && ((i = at(t, e, o)), (r = "number")),
                        null != i &&
                            i == i &&
                            ("number" !== r || l || (i += (o && o[3]) || (S.cssNumber[a] ? "" : "px")),
                            f.clearCloneStyle || "" !== i || 0 !== e.indexOf("background") || (u[e] = "inherit"),
                            (s && "set" in s && void 0 === (i = s.set(t, i, n))) || (l ? u.setProperty(e, i) : (u[e] = i)));
                }
            },
            css: function (t, e, i, n) {
                var o,
                    r,
                    s,
                    a = V(e);
                return (
                    Vt.test(e) || (e = Bt(a)),
                    (s = S.cssHooks[e] || S.cssHooks[a]) && "get" in s && (o = s.get(t, !0, i)),
                    void 0 === o && (o = qt(t, e, n)),
                    "normal" === o && e in Gt && (o = Gt[e]),
                    "" === i || i ? ((r = parseFloat(o)), !0 === i || isFinite(r) ? r || 0 : o) : o
                );
            },
        }),
            S.each(["height", "width"], function (t, e) {
                S.cssHooks[e] = {
                    get: function (t, i, n) {
                        if (i)
                            return !Ut.test(S.css(t, "display")) || (t.getClientRects().length && t.getBoundingClientRect().width)
                                ? Jt(t, e, n)
                                : Wt(t, Xt, function () {
                                      return Jt(t, e, n);
                                  });
                    },
                    set: function (t, i, n) {
                        var o,
                            r = Mt(t),
                            s = !f.scrollboxSize() && "absolute" === r.position,
                            a = (s || n) && "border-box" === S.css(t, "boxSizing", !1, r),
                            l = n ? Qt(t, e, n, a, r) : 0;
                        return (
                            a && s && (l -= Math.ceil(t["offset" + e[0].toUpperCase() + e.slice(1)] - parseFloat(r[e]) - Qt(t, e, "border", !1, r) - 0.5)),
                            l && (o = et.exec(i)) && "px" !== (o[3] || "px") && ((t.style[e] = i), (i = S.css(t, e))),
                            Yt(0, i, l)
                        );
                    },
                };
            }),
            (S.cssHooks.marginLeft = Ht(f.reliableMarginLeft, function (t, e) {
                if (e)
                    return (
                        (parseFloat(qt(t, "marginLeft")) ||
                            t.getBoundingClientRect().left -
                                Wt(t, { marginLeft: 0 }, function () {
                                    return t.getBoundingClientRect().left;
                                })) + "px"
                    );
            })),
            S.each({ margin: "", padding: "", border: "Width" }, function (t, e) {
                (S.cssHooks[t + e] = {
                    expand: function (i) {
                        for (var n = 0, o = {}, r = "string" == typeof i ? i.split(" ") : [i]; n < 4; n++) o[t + it[n] + e] = r[n] || r[n - 2] || r[0];
                        return o;
                    },
                }),
                    "margin" !== t && (S.cssHooks[t + e].set = Yt);
            }),
            S.fn.extend({
                css: function (t, e) {
                    return F(
                        this,
                        function (t, e, i) {
                            var n,
                                o,
                                r = {},
                                s = 0;
                            if (Array.isArray(e)) {
                                for (n = Mt(t), o = e.length; s < o; s++) r[e[s]] = S.css(t, e[s], !1, n);
                                return r;
                            }
                            return void 0 !== i ? S.style(t, e, i) : S.css(t, e);
                        },
                        t,
                        e,
                        1 < arguments.length
                    );
                },
            }),
            (((S.Tween = Zt).prototype = {
                constructor: Zt,
                init: function (t, e, i, n, o, r) {
                    (this.elem = t), (this.prop = i), (this.easing = o || S.easing._default), (this.options = e), (this.start = this.now = this.cur()), (this.end = n), (this.unit = r || (S.cssNumber[i] ? "" : "px"));
                },
                cur: function () {
                    var t = Zt.propHooks[this.prop];
                    return t && t.get ? t.get(this) : Zt.propHooks._default.get(this);
                },
                run: function (t) {
                    var e,
                        i = Zt.propHooks[this.prop];
                    return (
                        this.options.duration ? (this.pos = e = S.easing[this.easing](t, this.options.duration * t, 0, 1, this.options.duration)) : (this.pos = e = t),
                        (this.now = (this.end - this.start) * e + this.start),
                        this.options.step && this.options.step.call(this.elem, this.now, this),
                        i && i.set ? i.set(this) : Zt.propHooks._default.set(this),
                        this
                    );
                },
            }).init.prototype = Zt.prototype),
            ((Zt.propHooks = {
                _default: {
                    get: function (t) {
                        var e;
                        return 1 !== t.elem.nodeType || (null != t.elem[t.prop] && null == t.elem.style[t.prop]) ? t.elem[t.prop] : (e = S.css(t.elem, t.prop, "")) && "auto" !== e ? e : 0;
                    },
                    set: function (t) {
                        S.fx.step[t.prop] ? S.fx.step[t.prop](t) : 1 !== t.elem.nodeType || (!S.cssHooks[t.prop] && null == t.elem.style[Bt(t.prop)]) ? (t.elem[t.prop] = t.now) : S.style(t.elem, t.prop, t.now + t.unit);
                    },
                },
            }).scrollTop = Zt.propHooks.scrollLeft = {
                set: function (t) {
                    t.elem.nodeType && t.elem.parentNode && (t.elem[t.prop] = t.now);
                },
            }),
            (S.easing = {
                linear: function (t) {
                    return t;
                },
                swing: function (t) {
                    return 0.5 - Math.cos(t * Math.PI) / 2;
                },
                _default: "swing",
            }),
            (S.fx = Zt.prototype.init),
            (S.fx.step = {});
        var Kt,
            te,
            ee,
            ie,
            ne = /^(?:toggle|show|hide)$/,
            oe = /queueHooks$/;
        function re() {
            te && (!1 === m.hidden && t.requestAnimationFrame ? t.requestAnimationFrame(re) : t.setTimeout(re, S.fx.interval), S.fx.tick());
        }
        function se() {
            return (
                t.setTimeout(function () {
                    Kt = void 0;
                }),
                (Kt = Date.now())
            );
        }
        function ae(t, e) {
            var i,
                n = 0,
                o = { height: t };
            for (e = e ? 1 : 0; n < 4; n += 2 - e) o["margin" + (i = it[n])] = o["padding" + i] = t;
            return e && (o.opacity = o.width = t), o;
        }
        function le(t, e, i) {
            for (var n, o = (ue.tweeners[e] || []).concat(ue.tweeners["*"]), r = 0, s = o.length; r < s; r++) if ((n = o[r].call(i, e, t))) return n;
        }
        function ue(t, e, i) {
            var n,
                o,
                r = 0,
                s = ue.prefilters.length,
                a = S.Deferred().always(function () {
                    delete l.elem;
                }),
                l = function () {
                    if (o) return !1;
                    for (var e = Kt || se(), i = Math.max(0, u.startTime + u.duration - e), n = 1 - (i / u.duration || 0), r = 0, s = u.tweens.length; r < s; r++) u.tweens[r].run(n);
                    return a.notifyWith(t, [u, n, i]), n < 1 && s ? i : (s || a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u]), !1);
                },
                u = a.promise({
                    elem: t,
                    props: S.extend({}, e),
                    opts: S.extend(!0, { specialEasing: {}, easing: S.easing._default }, i),
                    originalProperties: e,
                    originalOptions: i,
                    startTime: Kt || se(),
                    duration: i.duration,
                    tweens: [],
                    createTween: function (e, i) {
                        var n = S.Tween(t, u.opts, e, i, u.opts.specialEasing[e] || u.opts.easing);
                        return u.tweens.push(n), n;
                    },
                    stop: function (e) {
                        var i = 0,
                            n = e ? u.tweens.length : 0;
                        if (o) return this;
                        for (o = !0; i < n; i++) u.tweens[i].run(1);
                        return e ? (a.notifyWith(t, [u, 1, 0]), a.resolveWith(t, [u, e])) : a.rejectWith(t, [u, e]), this;
                    },
                }),
                c = u.props;
            for (
                (function (t, e) {
                    var i, n, o, r, s;
                    for (i in t)
                        if (((o = e[(n = V(i))]), (r = t[i]), Array.isArray(r) && ((o = r[1]), (r = t[i] = r[0])), i !== n && ((t[n] = r), delete t[i]), (s = S.cssHooks[n]) && ("expand" in s)))
                            for (i in ((r = s.expand(r)), delete t[n], r)) (i in t) || ((t[i] = r[i]), (e[i] = o));
                        else e[n] = o;
                })(c, u.opts.specialEasing);
                r < s;
                r++
            )
                if ((n = ue.prefilters[r].call(u, t, c, u.opts))) return p(n.stop) && (S._queueHooks(u.elem, u.opts.queue).stop = n.stop.bind(n)), n;
            return (
                S.map(c, le, u),
                p(u.opts.start) && u.opts.start.call(t, u),
                u.progress(u.opts.progress).done(u.opts.done, u.opts.complete).fail(u.opts.fail).always(u.opts.always),
                S.fx.timer(S.extend(l, { elem: t, anim: u, queue: u.opts.queue })),
                u
            );
        }
        (S.Animation = S.extend(ue, {
            tweeners: {
                "*": [
                    function (t, e) {
                        var i = this.createTween(t, e);
                        return at(i.elem, t, et.exec(e), i), i;
                    },
                ],
            },
            tweener: function (t, e) {
                p(t) ? ((e = t), (t = ["*"])) : (t = t.match(j));
                for (var i, n = 0, o = t.length; n < o; n++) (i = t[n]), (ue.tweeners[i] = ue.tweeners[i] || []), ue.tweeners[i].unshift(e);
            },
            prefilters: [
                function (t, e, i) {
                    var n,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c,
                        h = "width" in e || "height" in e,
                        d = this,
                        f = {},
                        p = t.style,
                        g = t.nodeType && st(t),
                        m = Y.get(t, "fxshow");
                    for (n in (i.queue ||
                        (null == (s = S._queueHooks(t, "fx")).unqueued &&
                            ((s.unqueued = 0),
                            (a = s.empty.fire),
                            (s.empty.fire = function () {
                                s.unqueued || a();
                            })),
                        s.unqueued++,
                        d.always(function () {
                            d.always(function () {
                                s.unqueued--, S.queue(t, "fx").length || s.empty.fire();
                            });
                        })),
                    e))
                        if (((o = e[n]), ne.test(o))) {
                            if ((delete e[n], (r = r || "toggle" === o), o === (g ? "hide" : "show"))) {
                                if ("show" !== o || !m || void 0 === m[n]) continue;
                                g = !0;
                            }
                            f[n] = (m && m[n]) || S.style(t, n);
                        }
                    if ((l = !S.isEmptyObject(e)) || !S.isEmptyObject(f))
                        for (n in (h &&
                            1 === t.nodeType &&
                            ((i.overflow = [p.overflow, p.overflowX, p.overflowY]),
                            null == (u = m && m.display) && (u = Y.get(t, "display")),
                            "none" === (c = S.css(t, "display")) && (u ? (c = u) : (ut([t], !0), (u = t.style.display || u), (c = S.css(t, "display")), ut([t]))),
                            ("inline" === c || ("inline-block" === c && null != u)) &&
                                "none" === S.css(t, "float") &&
                                (l ||
                                    (d.done(function () {
                                        p.display = u;
                                    }),
                                    null == u && ((c = p.display), (u = "none" === c ? "" : c))),
                                (p.display = "inline-block"))),
                        i.overflow &&
                            ((p.overflow = "hidden"),
                            d.always(function () {
                                (p.overflow = i.overflow[0]), (p.overflowX = i.overflow[1]), (p.overflowY = i.overflow[2]);
                            })),
                        (l = !1),
                        f))
                            l ||
                                (m ? "hidden" in m && (g = m.hidden) : (m = Y.access(t, "fxshow", { display: u })),
                                r && (m.hidden = !g),
                                g && ut([t], !0),
                                d.done(function () {
                                    for (n in (g || ut([t]), Y.remove(t, "fxshow"), f)) S.style(t, n, f[n]);
                                })),
                                (l = le(g ? m[n] : 0, n, d)),
                                n in m || ((m[n] = l.start), g && ((l.end = l.start), (l.start = 0)));
                },
            ],
            prefilter: function (t, e) {
                e ? ue.prefilters.unshift(t) : ue.prefilters.push(t);
            },
        })),
            (S.speed = function (t, e, i) {
                var n = t && "object" == typeof t ? S.extend({}, t) : { complete: i || (!i && e) || (p(t) && t), duration: t, easing: (i && e) || (e && !p(e) && e) };
                return (
                    S.fx.off ? (n.duration = 0) : "number" != typeof n.duration && (n.duration in S.fx.speeds ? (n.duration = S.fx.speeds[n.duration]) : (n.duration = S.fx.speeds._default)),
                    (null != n.queue && !0 !== n.queue) || (n.queue = "fx"),
                    (n.old = n.complete),
                    (n.complete = function () {
                        p(n.old) && n.old.call(this), n.queue && S.dequeue(this, n.queue);
                    }),
                    n
                );
            }),
            S.fn.extend({
                fadeTo: function (t, e, i, n) {
                    return this.filter(st).css("opacity", 0).show().end().animate({ opacity: e }, t, i, n);
                },
                animate: function (t, e, i, n) {
                    var o = S.isEmptyObject(t),
                        r = S.speed(e, i, n),
                        s = function () {
                            var e = ue(this, S.extend({}, t), r);
                            (o || Y.get(this, "finish")) && e.stop(!0);
                        };
                    return (s.finish = s), o || !1 === r.queue ? this.each(s) : this.queue(r.queue, s);
                },
                stop: function (t, e, i) {
                    var n = function (t) {
                        var e = t.stop;
                        delete t.stop, e(i);
                    };
                    return (
                        "string" != typeof t && ((i = e), (e = t), (t = void 0)),
                        e && this.queue(t || "fx", []),
                        this.each(function () {
                            var e = !0,
                                o = null != t && t + "queueHooks",
                                r = S.timers,
                                s = Y.get(this);
                            if (o) s[o] && s[o].stop && n(s[o]);
                            else for (o in s) s[o] && s[o].stop && oe.test(o) && n(s[o]);
                            for (o = r.length; o--; ) r[o].elem !== this || (null != t && r[o].queue !== t) || (r[o].anim.stop(i), (e = !1), r.splice(o, 1));
                            (!e && i) || S.dequeue(this, t);
                        })
                    );
                },
                finish: function (t) {
                    return (
                        !1 !== t && (t = t || "fx"),
                        this.each(function () {
                            var e,
                                i = Y.get(this),
                                n = i[t + "queue"],
                                o = i[t + "queueHooks"],
                                r = S.timers,
                                s = n ? n.length : 0;
                            for (i.finish = !0, S.queue(this, t, []), o && o.stop && o.stop.call(this, !0), e = r.length; e--; ) r[e].elem === this && r[e].queue === t && (r[e].anim.stop(!0), r.splice(e, 1));
                            for (e = 0; e < s; e++) n[e] && n[e].finish && n[e].finish.call(this);
                            delete i.finish;
                        })
                    );
                },
            }),
            S.each(["toggle", "show", "hide"], function (t, e) {
                var i = S.fn[e];
                S.fn[e] = function (t, n, o) {
                    return null == t || "boolean" == typeof t ? i.apply(this, arguments) : this.animate(ae(e, !0), t, n, o);
                };
            }),
            S.each({ slideDown: ae("show"), slideUp: ae("hide"), slideToggle: ae("toggle"), fadeIn: { opacity: "show" }, fadeOut: { opacity: "hide" }, fadeToggle: { opacity: "toggle" } }, function (t, e) {
                S.fn[t] = function (t, i, n) {
                    return this.animate(e, t, i, n);
                };
            }),
            (S.timers = []),
            (S.fx.tick = function () {
                var t,
                    e = 0,
                    i = S.timers;
                for (Kt = Date.now(); e < i.length; e++) (t = i[e])() || i[e] !== t || i.splice(e--, 1);
                i.length || S.fx.stop(), (Kt = void 0);
            }),
            (S.fx.timer = function (t) {
                S.timers.push(t), S.fx.start();
            }),
            (S.fx.interval = 13),
            (S.fx.start = function () {
                te || ((te = !0), re());
            }),
            (S.fx.stop = function () {
                te = null;
            }),
            (S.fx.speeds = { slow: 600, fast: 200, _default: 400 }),
            (S.fn.delay = function (e, i) {
                return (
                    (e = (S.fx && S.fx.speeds[e]) || e),
                    (i = i || "fx"),
                    this.queue(i, function (i, n) {
                        var o = t.setTimeout(i, e);
                        n.stop = function () {
                            t.clearTimeout(o);
                        };
                    })
                );
            }),
            (ee = m.createElement("input")),
            (ie = m.createElement("select").appendChild(m.createElement("option"))),
            (ee.type = "checkbox"),
            (f.checkOn = "" !== ee.value),
            (f.optSelected = ie.selected),
            ((ee = m.createElement("input")).value = "t"),
            (ee.type = "radio"),
            (f.radioValue = "t" === ee.value);
        var ce,
            he = S.expr.attrHandle;
        S.fn.extend({
            attr: function (t, e) {
                return F(this, S.attr, t, e, 1 < arguments.length);
            },
            removeAttr: function (t) {
                return this.each(function () {
                    S.removeAttr(this, t);
                });
            },
        }),
            S.extend({
                attr: function (t, e, i) {
                    var n,
                        o,
                        r = t.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return void 0 === t.getAttribute
                            ? S.prop(t, e, i)
                            : ((1 === r && S.isXMLDoc(t)) || (o = S.attrHooks[e.toLowerCase()] || (S.expr.match.bool.test(e) ? ce : void 0)),
                              void 0 !== i
                                  ? null === i
                                      ? void S.removeAttr(t, e)
                                      : o && "set" in o && void 0 !== (n = o.set(t, i, e))
                                      ? n
                                      : (t.setAttribute(e, i + ""), i)
                                  : o && "get" in o && null !== (n = o.get(t, e))
                                  ? n
                                  : null == (n = S.find.attr(t, e))
                                  ? void 0
                                  : n);
                },
                attrHooks: {
                    type: {
                        set: function (t, e) {
                            if (!f.radioValue && "radio" === e && k(t, "input")) {
                                var i = t.value;
                                return t.setAttribute("type", e), i && (t.value = i), e;
                            }
                        },
                    },
                },
                removeAttr: function (t, e) {
                    var i,
                        n = 0,
                        o = e && e.match(j);
                    if (o && 1 === t.nodeType) for (; (i = o[n++]); ) t.removeAttribute(i);
                },
            }),
            (ce = {
                set: function (t, e, i) {
                    return !1 === e ? S.removeAttr(t, i) : t.setAttribute(i, i), i;
                },
            }),
            S.each(S.expr.match.bool.source.match(/\w+/g), function (t, e) {
                var i = he[e] || S.find.attr;
                he[e] = function (t, e, n) {
                    var o,
                        r,
                        s = e.toLowerCase();
                    return n || ((r = he[s]), (he[s] = o), (o = null != i(t, e, n) ? s : null), (he[s] = r)), o;
                };
            });
        var de = /^(?:input|select|textarea|button)$/i,
            fe = /^(?:a|area)$/i;
        function pe(t) {
            return (t.match(j) || []).join(" ");
        }
        function ge(t) {
            return (t.getAttribute && t.getAttribute("class")) || "";
        }
        function me(t) {
            return Array.isArray(t) ? t : ("string" == typeof t && t.match(j)) || [];
        }
        S.fn.extend({
            prop: function (t, e) {
                return F(this, S.prop, t, e, 1 < arguments.length);
            },
            removeProp: function (t) {
                return this.each(function () {
                    delete this[S.propFix[t] || t];
                });
            },
        }),
            S.extend({
                prop: function (t, e, i) {
                    var n,
                        o,
                        r = t.nodeType;
                    if (3 !== r && 8 !== r && 2 !== r)
                        return (
                            (1 === r && S.isXMLDoc(t)) || ((e = S.propFix[e] || e), (o = S.propHooks[e])),
                            void 0 !== i ? (o && "set" in o && void 0 !== (n = o.set(t, i, e)) ? n : (t[e] = i)) : o && "get" in o && null !== (n = o.get(t, e)) ? n : t[e]
                        );
                },
                propHooks: {
                    tabIndex: {
                        get: function (t) {
                            var e = S.find.attr(t, "tabindex");
                            return e ? parseInt(e, 10) : de.test(t.nodeName) || (fe.test(t.nodeName) && t.href) ? 0 : -1;
                        },
                    },
                },
                propFix: { for: "htmlFor", class: "className" },
            }),
            f.optSelected ||
                (S.propHooks.selected = {
                    get: function (t) {
                        var e = t.parentNode;
                        return e && e.parentNode && e.parentNode.selectedIndex, null;
                    },
                    set: function (t) {
                        var e = t.parentNode;
                        e && (e.selectedIndex, e.parentNode && e.parentNode.selectedIndex);
                    },
                }),
            S.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
                S.propFix[this.toLowerCase()] = this;
            }),
            S.fn.extend({
                addClass: function (t) {
                    var e,
                        i,
                        n,
                        o,
                        r,
                        s,
                        a,
                        l = 0;
                    if (p(t))
                        return this.each(function (e) {
                            S(this).addClass(t.call(this, e, ge(this)));
                        });
                    if ((e = me(t)).length)
                        for (; (i = this[l++]); )
                            if (((o = ge(i)), (n = 1 === i.nodeType && " " + pe(o) + " "))) {
                                for (s = 0; (r = e[s++]); ) n.indexOf(" " + r + " ") < 0 && (n += r + " ");
                                o !== (a = pe(n)) && i.setAttribute("class", a);
                            }
                    return this;
                },
                removeClass: function (t) {
                    var e,
                        i,
                        n,
                        o,
                        r,
                        s,
                        a,
                        l = 0;
                    if (p(t))
                        return this.each(function (e) {
                            S(this).removeClass(t.call(this, e, ge(this)));
                        });
                    if (!arguments.length) return this.attr("class", "");
                    if ((e = me(t)).length)
                        for (; (i = this[l++]); )
                            if (((o = ge(i)), (n = 1 === i.nodeType && " " + pe(o) + " "))) {
                                for (s = 0; (r = e[s++]); ) for (; -1 < n.indexOf(" " + r + " "); ) n = n.replace(" " + r + " ", " ");
                                o !== (a = pe(n)) && i.setAttribute("class", a);
                            }
                    return this;
                },
                toggleClass: function (t, e) {
                    var i = typeof t,
                        n = "string" === i || Array.isArray(t);
                    return "boolean" == typeof e && n
                        ? e
                            ? this.addClass(t)
                            : this.removeClass(t)
                        : p(t)
                        ? this.each(function (i) {
                              S(this).toggleClass(t.call(this, i, ge(this), e), e);
                          })
                        : this.each(function () {
                              var e, o, r, s;
                              if (n) for (o = 0, r = S(this), s = me(t); (e = s[o++]); ) r.hasClass(e) ? r.removeClass(e) : r.addClass(e);
                              else (void 0 !== t && "boolean" !== i) || ((e = ge(this)) && Y.set(this, "__className__", e), this.setAttribute && this.setAttribute("class", e || !1 === t ? "" : Y.get(this, "__className__") || ""));
                          });
                },
                hasClass: function (t) {
                    var e,
                        i,
                        n = 0;
                    for (e = " " + t + " "; (i = this[n++]); ) if (1 === i.nodeType && -1 < (" " + pe(ge(i)) + " ").indexOf(e)) return !0;
                    return !1;
                },
            });
        var ve = /\r/g;
        S.fn.extend({
            val: function (t) {
                var e,
                    i,
                    n,
                    o = this[0];
                return arguments.length
                    ? ((n = p(t)),
                      this.each(function (i) {
                          var o;
                          1 === this.nodeType &&
                              (null == (o = n ? t.call(this, i, S(this).val()) : t)
                                  ? (o = "")
                                  : "number" == typeof o
                                  ? (o += "")
                                  : Array.isArray(o) &&
                                    (o = S.map(o, function (t) {
                                        return null == t ? "" : t + "";
                                    })),
                              ((e = S.valHooks[this.type] || S.valHooks[this.nodeName.toLowerCase()]) && "set" in e && void 0 !== e.set(this, o, "value")) || (this.value = o));
                      }))
                    : o
                    ? (e = S.valHooks[o.type] || S.valHooks[o.nodeName.toLowerCase()]) && "get" in e && void 0 !== (i = e.get(o, "value"))
                        ? i
                        : "string" == typeof (i = o.value)
                        ? i.replace(ve, "")
                        : null == i
                        ? ""
                        : i
                    : void 0;
            },
        }),
            S.extend({
                valHooks: {
                    option: {
                        get: function (t) {
                            var e = S.find.attr(t, "value");
                            return null != e ? e : pe(S.text(t));
                        },
                    },
                    select: {
                        get: function (t) {
                            var e,
                                i,
                                n,
                                o = t.options,
                                r = t.selectedIndex,
                                s = "select-one" === t.type,
                                a = s ? null : [],
                                l = s ? r + 1 : o.length;
                            for (n = r < 0 ? l : s ? r : 0; n < l; n++)
                                if (((i = o[n]).selected || n === r) && !i.disabled && (!i.parentNode.disabled || !k(i.parentNode, "optgroup"))) {
                                    if (((e = S(i).val()), s)) return e;
                                    a.push(e);
                                }
                            return a;
                        },
                        set: function (t, e) {
                            for (var i, n, o = t.options, r = S.makeArray(e), s = o.length; s--; ) ((n = o[s]).selected = -1 < S.inArray(S.valHooks.option.get(n), r)) && (i = !0);
                            return i || (t.selectedIndex = -1), r;
                        },
                    },
                },
            }),
            S.each(["radio", "checkbox"], function () {
                (S.valHooks[this] = {
                    set: function (t, e) {
                        if (Array.isArray(e)) return (t.checked = -1 < S.inArray(S(t).val(), e));
                    },
                }),
                    f.checkOn ||
                        (S.valHooks[this].get = function (t) {
                            return null === t.getAttribute("value") ? "on" : t.value;
                        });
            }),
            (f.focusin = "onfocusin" in t);
        var ye = /^(?:focusinfocus|focusoutblur)$/,
            be = function (t) {
                t.stopPropagation();
            };
        S.extend(S.event, {
            trigger: function (e, i, n, o) {
                var r,
                    s,
                    a,
                    l,
                    u,
                    h,
                    d,
                    f,
                    v = [n || m],
                    y = c.call(e, "type") ? e.type : e,
                    b = c.call(e, "namespace") ? e.namespace.split(".") : [];
                if (
                    ((s = f = a = n = n || m),
                    3 !== n.nodeType &&
                        8 !== n.nodeType &&
                        !ye.test(y + S.event.triggered) &&
                        (-1 < y.indexOf(".") && ((y = (b = y.split(".")).shift()), b.sort()),
                        (u = y.indexOf(":") < 0 && "on" + y),
                        ((e = e[S.expando] ? e : new S.Event(y, "object" == typeof e && e)).isTrigger = o ? 2 : 3),
                        (e.namespace = b.join(".")),
                        (e.rnamespace = e.namespace ? new RegExp("(^|\\.)" + b.join("\\.(?:.*\\.|)") + "(\\.|$)") : null),
                        (e.result = void 0),
                        e.target || (e.target = n),
                        (i = null == i ? [e] : S.makeArray(i, [e])),
                        (d = S.event.special[y] || {}),
                        o || !d.trigger || !1 !== d.trigger.apply(n, i)))
                ) {
                    if (!o && !d.noBubble && !g(n)) {
                        for (l = d.delegateType || y, ye.test(l + y) || (s = s.parentNode); s; s = s.parentNode) v.push(s), (a = s);
                        a === (n.ownerDocument || m) && v.push(a.defaultView || a.parentWindow || t);
                    }
                    for (r = 0; (s = v[r++]) && !e.isPropagationStopped(); )
                        (f = s),
                            (e.type = 1 < r ? l : d.bindType || y),
                            (h = (Y.get(s, "events") || Object.create(null))[e.type] && Y.get(s, "handle")) && h.apply(s, i),
                            (h = u && s[u]) && h.apply && X(s) && ((e.result = h.apply(s, i)), !1 === e.result && e.preventDefault());
                    return (
                        (e.type = y),
                        o ||
                            e.isDefaultPrevented() ||
                            (d._default && !1 !== d._default.apply(v.pop(), i)) ||
                            !X(n) ||
                            (u &&
                                p(n[y]) &&
                                !g(n) &&
                                ((a = n[u]) && (n[u] = null),
                                (S.event.triggered = y),
                                e.isPropagationStopped() && f.addEventListener(y, be),
                                n[y](),
                                e.isPropagationStopped() && f.removeEventListener(y, be),
                                (S.event.triggered = void 0),
                                a && (n[u] = a))),
                        e.result
                    );
                }
            },
            simulate: function (t, e, i) {
                var n = S.extend(new S.Event(), i, { type: t, isSimulated: !0 });
                S.event.trigger(n, null, e);
            },
        }),
            S.fn.extend({
                trigger: function (t, e) {
                    return this.each(function () {
                        S.event.trigger(t, e, this);
                    });
                },
                triggerHandler: function (t, e) {
                    var i = this[0];
                    if (i) return S.event.trigger(t, e, i, !0);
                },
            }),
            f.focusin ||
                S.each({ focus: "focusin", blur: "focusout" }, function (t, e) {
                    var i = function (t) {
                        S.event.simulate(e, t.target, S.event.fix(t));
                    };
                    S.event.special[e] = {
                        setup: function () {
                            var n = this.ownerDocument || this.document || this,
                                o = Y.access(n, e);
                            o || n.addEventListener(t, i, !0), Y.access(n, e, (o || 0) + 1);
                        },
                        teardown: function () {
                            var n = this.ownerDocument || this.document || this,
                                o = Y.access(n, e) - 1;
                            o ? Y.access(n, e, o) : (n.removeEventListener(t, i, !0), Y.remove(n, e));
                        },
                    };
                });
        var xe = t.location,
            Se = { guid: Date.now() },
            we = /\?/;
        S.parseXML = function (e) {
            var i, n;
            if (!e || "string" != typeof e) return null;
            try {
                i = new t.DOMParser().parseFromString(e, "text/xml");
            } catch (e) {}
            return (
                (n = i && i.getElementsByTagName("parsererror")[0]),
                (i && !n) ||
                    S.error(
                        "Invalid XML: " +
                            (n
                                ? S.map(n.childNodes, function (t) {
                                      return t.textContent;
                                  }).join("\n")
                                : e)
                    ),
                i
            );
        };
        var Te = /\[\]$/,
            Ce = /\r?\n/g,
            Ee = /^(?:submit|button|image|reset|file)$/i,
            _e = /^(?:input|select|textarea|keygen)/i;
        function ke(t, e, i, n) {
            var o;
            if (Array.isArray(e))
                S.each(e, function (e, o) {
                    i || Te.test(t) ? n(t, o) : ke(t + "[" + ("object" == typeof o && null != o ? e : "") + "]", o, i, n);
                });
            else if (i || "object" !== b(e)) n(t, e);
            else for (o in e) ke(t + "[" + o + "]", e[o], i, n);
        }
        (S.param = function (t, e) {
            var i,
                n = [],
                o = function (t, e) {
                    var i = p(e) ? e() : e;
                    n[n.length] = encodeURIComponent(t) + "=" + encodeURIComponent(null == i ? "" : i);
                };
            if (null == t) return "";
            if (Array.isArray(t) || (t.jquery && !S.isPlainObject(t)))
                S.each(t, function () {
                    o(this.name, this.value);
                });
            else for (i in t) ke(i, t[i], e, o);
            return n.join("&");
        }),
            S.fn.extend({
                serialize: function () {
                    return S.param(this.serializeArray());
                },
                serializeArray: function () {
                    return this.map(function () {
                        var t = S.prop(this, "elements");
                        return t ? S.makeArray(t) : this;
                    })
                        .filter(function () {
                            var t = this.type;
                            return this.name && !S(this).is(":disabled") && _e.test(this.nodeName) && !Ee.test(t) && (this.checked || !dt.test(t));
                        })
                        .map(function (t, e) {
                            var i = S(this).val();
                            return null == i
                                ? null
                                : Array.isArray(i)
                                ? S.map(i, function (t) {
                                      return { name: e.name, value: t.replace(Ce, "\r\n") };
                                  })
                                : { name: e.name, value: i.replace(Ce, "\r\n") };
                        })
                        .get();
                },
            });
        var Ie = /%20/g,
            De = /#.*$/,
            Pe = /([?&])_=[^&]*/,
            ze = /^(.*?):[ \t]*([^\r\n]*)$/gm,
            Le = /^(?:GET|HEAD)$/,
            Ae = /^\/\//,
            Ne = {},
            je = {},
            Me = "*/".concat("*"),
            We = m.createElement("a");
        function Oe(t) {
            return function (e, i) {
                "string" != typeof e && ((i = e), (e = "*"));
                var n,
                    o = 0,
                    r = e.toLowerCase().match(j) || [];
                if (p(i)) for (; (n = r[o++]); ) "+" === n[0] ? ((n = n.slice(1) || "*"), (t[n] = t[n] || []).unshift(i)) : (t[n] = t[n] || []).push(i);
            };
        }
        function qe(t, e, i, n) {
            var o = {},
                r = t === je;
            function s(a) {
                var l;
                return (
                    (o[a] = !0),
                    S.each(t[a] || [], function (t, a) {
                        var u = a(e, i, n);
                        return "string" != typeof u || r || o[u] ? (r ? !(l = u) : void 0) : (e.dataTypes.unshift(u), s(u), !1);
                    }),
                    l
                );
            }
            return s(e.dataTypes[0]) || (!o["*"] && s("*"));
        }
        function He(t, e) {
            var i,
                n,
                o = S.ajaxSettings.flatOptions || {};
            for (i in e) void 0 !== e[i] && ((o[i] ? t : n || (n = {}))[i] = e[i]);
            return n && S.extend(!0, t, n), t;
        }
        (We.href = xe.href),
            S.extend({
                active: 0,
                lastModified: {},
                etag: {},
                ajaxSettings: {
                    url: xe.href,
                    type: "GET",
                    isLocal: /^(?:about|app|app-storage|.+-extension|file|res|widget):$/.test(xe.protocol),
                    global: !0,
                    processData: !0,
                    async: !0,
                    contentType: "application/x-www-form-urlencoded; charset=UTF-8",
                    accepts: { "*": Me, text: "text/plain", html: "text/html", xml: "application/xml, text/xml", json: "application/json, text/javascript" },
                    contents: { xml: /\bxml\b/, html: /\bhtml/, json: /\bjson\b/ },
                    responseFields: { xml: "responseXML", text: "responseText", json: "responseJSON" },
                    converters: { "* text": String, "text html": !0, "text json": JSON.parse, "text xml": S.parseXML },
                    flatOptions: { url: !0, context: !0 },
                },
                ajaxSetup: function (t, e) {
                    return e ? He(He(t, S.ajaxSettings), e) : He(S.ajaxSettings, t);
                },
                ajaxPrefilter: Oe(Ne),
                ajaxTransport: Oe(je),
                ajax: function (e, i) {
                    "object" == typeof e && ((i = e), (e = void 0)), (i = i || {});
                    var n,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u,
                        c,
                        h,
                        d,
                        f = S.ajaxSetup({}, i),
                        p = f.context || f,
                        g = f.context && (p.nodeType || p.jquery) ? S(p) : S.event,
                        v = S.Deferred(),
                        y = S.Callbacks("once memory"),
                        b = f.statusCode || {},
                        x = {},
                        w = {},
                        T = "canceled",
                        C = {
                            readyState: 0,
                            getResponseHeader: function (t) {
                                var e;
                                if (u) {
                                    if (!s) for (s = {}; (e = ze.exec(r)); ) s[e[1].toLowerCase() + " "] = (s[e[1].toLowerCase() + " "] || []).concat(e[2]);
                                    e = s[t.toLowerCase() + " "];
                                }
                                return null == e ? null : e.join(", ");
                            },
                            getAllResponseHeaders: function () {
                                return u ? r : null;
                            },
                            setRequestHeader: function (t, e) {
                                return null == u && ((t = w[t.toLowerCase()] = w[t.toLowerCase()] || t), (x[t] = e)), this;
                            },
                            overrideMimeType: function (t) {
                                return null == u && (f.mimeType = t), this;
                            },
                            statusCode: function (t) {
                                var e;
                                if (t)
                                    if (u) C.always(t[C.status]);
                                    else for (e in t) b[e] = [b[e], t[e]];
                                return this;
                            },
                            abort: function (t) {
                                var e = t || T;
                                return n && n.abort(e), E(0, e), this;
                            },
                        };
                    if (
                        (v.promise(C),
                        (f.url = ((e || f.url || xe.href) + "").replace(Ae, xe.protocol + "//")),
                        (f.type = i.method || i.type || f.method || f.type),
                        (f.dataTypes = (f.dataType || "*").toLowerCase().match(j) || [""]),
                        null == f.crossDomain)
                    ) {
                        l = m.createElement("a");
                        try {
                            (l.href = f.url), (l.href = l.href), (f.crossDomain = We.protocol + "//" + We.host != l.protocol + "//" + l.host);
                        } catch (e) {
                            f.crossDomain = !0;
                        }
                    }
                    if ((f.data && f.processData && "string" != typeof f.data && (f.data = S.param(f.data, f.traditional)), qe(Ne, f, i, C), u)) return C;
                    for (h in ((c = S.event && f.global) && 0 == S.active++ && S.event.trigger("ajaxStart"),
                    (f.type = f.type.toUpperCase()),
                    (f.hasContent = !Le.test(f.type)),
                    (o = f.url.replace(De, "")),
                    f.hasContent
                        ? f.data && f.processData && 0 === (f.contentType || "").indexOf("application/x-www-form-urlencoded") && (f.data = f.data.replace(Ie, "+"))
                        : ((d = f.url.slice(o.length)),
                          f.data && (f.processData || "string" == typeof f.data) && ((o += (we.test(o) ? "&" : "?") + f.data), delete f.data),
                          !1 === f.cache && ((o = o.replace(Pe, "$1")), (d = (we.test(o) ? "&" : "?") + "_=" + Se.guid++ + d)),
                          (f.url = o + d)),
                    f.ifModified && (S.lastModified[o] && C.setRequestHeader("If-Modified-Since", S.lastModified[o]), S.etag[o] && C.setRequestHeader("If-None-Match", S.etag[o])),
                    ((f.data && f.hasContent && !1 !== f.contentType) || i.contentType) && C.setRequestHeader("Content-Type", f.contentType),
                    C.setRequestHeader("Accept", f.dataTypes[0] && f.accepts[f.dataTypes[0]] ? f.accepts[f.dataTypes[0]] + ("*" !== f.dataTypes[0] ? ", " + Me + "; q=0.01" : "") : f.accepts["*"]),
                    f.headers))
                        C.setRequestHeader(h, f.headers[h]);
                    if (f.beforeSend && (!1 === f.beforeSend.call(p, C, f) || u)) return C.abort();
                    if (((T = "abort"), y.add(f.complete), C.done(f.success), C.fail(f.error), (n = qe(je, f, i, C)))) {
                        if (((C.readyState = 1), c && g.trigger("ajaxSend", [C, f]), u)) return C;
                        f.async &&
                            0 < f.timeout &&
                            (a = t.setTimeout(function () {
                                C.abort("timeout");
                            }, f.timeout));
                        try {
                            (u = !1), n.send(x, E);
                        } catch (e) {
                            if (u) throw e;
                            E(-1, e);
                        }
                    } else E(-1, "No Transport");
                    function E(e, i, s, l) {
                        var h,
                            d,
                            m,
                            x,
                            w,
                            T = i;
                        u ||
                            ((u = !0),
                            a && t.clearTimeout(a),
                            (n = void 0),
                            (r = l || ""),
                            (C.readyState = 0 < e ? 4 : 0),
                            (h = (200 <= e && e < 300) || 304 === e),
                            s &&
                                (x = (function (t, e, i) {
                                    for (var n, o, r, s, a = t.contents, l = t.dataTypes; "*" === l[0]; ) l.shift(), void 0 === n && (n = t.mimeType || e.getResponseHeader("Content-Type"));
                                    if (n)
                                        for (o in a)
                                            if (a[o] && a[o].test(n)) {
                                                l.unshift(o);
                                                break;
                                            }
                                    if (l[0] in i) r = l[0];
                                    else {
                                        for (o in i) {
                                            if (!l[0] || t.converters[o + " " + l[0]]) {
                                                r = o;
                                                break;
                                            }
                                            s || (s = o);
                                        }
                                        r = r || s;
                                    }
                                    if (r) return r !== l[0] && l.unshift(r), i[r];
                                })(f, C, s)),
                            !h && -1 < S.inArray("script", f.dataTypes) && S.inArray("json", f.dataTypes) < 0 && (f.converters["text script"] = function () {}),
                            (x = (function (t, e, i, n) {
                                var o,
                                    r,
                                    s,
                                    a,
                                    l,
                                    u = {},
                                    c = t.dataTypes.slice();
                                if (c[1]) for (s in t.converters) u[s.toLowerCase()] = t.converters[s];
                                for (r = c.shift(); r; )
                                    if ((t.responseFields[r] && (i[t.responseFields[r]] = e), !l && n && t.dataFilter && (e = t.dataFilter(e, t.dataType)), (l = r), (r = c.shift())))
                                        if ("*" === r) r = l;
                                        else if ("*" !== l && l !== r) {
                                            if (!(s = u[l + " " + r] || u["* " + r]))
                                                for (o in u)
                                                    if ((a = o.split(" "))[1] === r && (s = u[l + " " + a[0]] || u["* " + a[0]])) {
                                                        !0 === s ? (s = u[o]) : !0 !== u[o] && ((r = a[0]), c.unshift(a[1]));
                                                        break;
                                                    }
                                            if (!0 !== s)
                                                if (s && t.throws) e = s(e);
                                                else
                                                    try {
                                                        e = s(e);
                                                    } catch (t) {
                                                        return { state: "parsererror", error: s ? t : "No conversion from " + l + " to " + r };
                                                    }
                                        }
                                return { state: "success", data: e };
                            })(f, x, C, h)),
                            h
                                ? (f.ifModified && ((w = C.getResponseHeader("Last-Modified")) && (S.lastModified[o] = w), (w = C.getResponseHeader("etag")) && (S.etag[o] = w)),
                                  204 === e || "HEAD" === f.type ? (T = "nocontent") : 304 === e ? (T = "notmodified") : ((T = x.state), (d = x.data), (h = !(m = x.error))))
                                : ((m = T), (!e && T) || ((T = "error"), e < 0 && (e = 0))),
                            (C.status = e),
                            (C.statusText = (i || T) + ""),
                            h ? v.resolveWith(p, [d, T, C]) : v.rejectWith(p, [C, T, m]),
                            C.statusCode(b),
                            (b = void 0),
                            c && g.trigger(h ? "ajaxSuccess" : "ajaxError", [C, f, h ? d : m]),
                            y.fireWith(p, [C, T]),
                            c && (g.trigger("ajaxComplete", [C, f]), --S.active || S.event.trigger("ajaxStop")));
                    }
                    return C;
                },
                getJSON: function (t, e, i) {
                    return S.get(t, e, i, "json");
                },
                getScript: function (t, e) {
                    return S.get(t, void 0, e, "script");
                },
            }),
            S.each(["get", "post"], function (t, e) {
                S[e] = function (t, i, n, o) {
                    return p(i) && ((o = o || n), (n = i), (i = void 0)), S.ajax(S.extend({ url: t, type: e, dataType: o, data: i, success: n }, S.isPlainObject(t) && t));
                };
            }),
            S.ajaxPrefilter(function (t) {
                var e;
                for (e in t.headers) "content-type" === e.toLowerCase() && (t.contentType = t.headers[e] || "");
            }),
            (S._evalUrl = function (t, e, i) {
                return S.ajax({
                    url: t,
                    type: "GET",
                    dataType: "script",
                    cache: !0,
                    async: !1,
                    global: !1,
                    converters: { "text script": function () {} },
                    dataFilter: function (t) {
                        S.globalEval(t, e, i);
                    },
                });
            }),
            S.fn.extend({
                wrapAll: function (t) {
                    var e;
                    return (
                        this[0] &&
                            (p(t) && (t = t.call(this[0])),
                            (e = S(t, this[0].ownerDocument).eq(0).clone(!0)),
                            this[0].parentNode && e.insertBefore(this[0]),
                            e
                                .map(function () {
                                    for (var t = this; t.firstElementChild; ) t = t.firstElementChild;
                                    return t;
                                })
                                .append(this)),
                        this
                    );
                },
                wrapInner: function (t) {
                    return p(t)
                        ? this.each(function (e) {
                              S(this).wrapInner(t.call(this, e));
                          })
                        : this.each(function () {
                              var e = S(this),
                                  i = e.contents();
                              i.length ? i.wrapAll(t) : e.append(t);
                          });
                },
                wrap: function (t) {
                    var e = p(t);
                    return this.each(function (i) {
                        S(this).wrapAll(e ? t.call(this, i) : t);
                    });
                },
                unwrap: function (t) {
                    return (
                        this.parent(t)
                            .not("body")
                            .each(function () {
                                S(this).replaceWith(this.childNodes);
                            }),
                        this
                    );
                },
            }),
            (S.expr.pseudos.hidden = function (t) {
                return !S.expr.pseudos.visible(t);
            }),
            (S.expr.pseudos.visible = function (t) {
                return !!(t.offsetWidth || t.offsetHeight || t.getClientRects().length);
            }),
            (S.ajaxSettings.xhr = function () {
                try {
                    return new t.XMLHttpRequest();
                } catch (t) {}
            });
        var Re = { 0: 200, 1223: 204 },
            Fe = S.ajaxSettings.xhr();
        (f.cors = !!Fe && "withCredentials" in Fe),
            (f.ajax = Fe = !!Fe),
            S.ajaxTransport(function (e) {
                var i, n;
                if (f.cors || (Fe && !e.crossDomain))
                    return {
                        send: function (o, r) {
                            var s,
                                a = e.xhr();
                            if ((a.open(e.type, e.url, e.async, e.username, e.password), e.xhrFields)) for (s in e.xhrFields) a[s] = e.xhrFields[s];
                            for (s in (e.mimeType && a.overrideMimeType && a.overrideMimeType(e.mimeType), e.crossDomain || o["X-Requested-With"] || (o["X-Requested-With"] = "XMLHttpRequest"), o)) a.setRequestHeader(s, o[s]);
                            (i = function (t) {
                                return function () {
                                    i &&
                                        ((i = n = a.onload = a.onerror = a.onabort = a.ontimeout = a.onreadystatechange = null),
                                        "abort" === t
                                            ? a.abort()
                                            : "error" === t
                                            ? "number" != typeof a.status
                                                ? r(0, "error")
                                                : r(a.status, a.statusText)
                                            : r(
                                                  Re[a.status] || a.status,
                                                  a.statusText,
                                                  "text" !== (a.responseType || "text") || "string" != typeof a.responseText ? { binary: a.response } : { text: a.responseText },
                                                  a.getAllResponseHeaders()
                                              ));
                                };
                            }),
                                (a.onload = i()),
                                (n = a.onerror = a.ontimeout = i("error")),
                                void 0 !== a.onabort
                                    ? (a.onabort = n)
                                    : (a.onreadystatechange = function () {
                                          4 === a.readyState &&
                                              t.setTimeout(function () {
                                                  i && n();
                                              });
                                      }),
                                (i = i("abort"));
                            try {
                                a.send((e.hasContent && e.data) || null);
                            } catch (o) {
                                if (i) throw o;
                            }
                        },
                        abort: function () {
                            i && i();
                        },
                    };
            }),
            S.ajaxPrefilter(function (t) {
                t.crossDomain && (t.contents.script = !1);
            }),
            S.ajaxSetup({
                accepts: { script: "text/javascript, application/javascript, application/ecmascript, application/x-ecmascript" },
                contents: { script: /\b(?:java|ecma)script\b/ },
                converters: {
                    "text script": function (t) {
                        return S.globalEval(t), t;
                    },
                },
            }),
            S.ajaxPrefilter("script", function (t) {
                void 0 === t.cache && (t.cache = !1), t.crossDomain && (t.type = "GET");
            }),
            S.ajaxTransport("script", function (t) {
                var e, i;
                if (t.crossDomain || t.scriptAttrs)
                    return {
                        send: function (n, o) {
                            (e = S("<script>")
                                .attr(t.scriptAttrs || {})
                                .prop({ charset: t.scriptCharset, src: t.url })
                                .on(
                                    "load error",
                                    (i = function (t) {
                                        e.remove(), (i = null), t && o("error" === t.type ? 404 : 200, t.type);
                                    })
                                )),
                                m.head.appendChild(e[0]);
                        },
                        abort: function () {
                            i && i();
                        },
                    };
            });
        var $e,
            Be = [],
            Ue = /(=)\?(?=&|$)|\?\?/;
        S.ajaxSetup({
            jsonp: "callback",
            jsonpCallback: function () {
                var t = Be.pop() || S.expando + "_" + Se.guid++;
                return (this[t] = !0), t;
            },
        }),
            S.ajaxPrefilter("json jsonp", function (e, i, n) {
                var o,
                    r,
                    s,
                    a = !1 !== e.jsonp && (Ue.test(e.url) ? "url" : "string" == typeof e.data && 0 === (e.contentType || "").indexOf("application/x-www-form-urlencoded") && Ue.test(e.data) && "data");
                if (a || "jsonp" === e.dataTypes[0])
                    return (
                        (o = e.jsonpCallback = p(e.jsonpCallback) ? e.jsonpCallback() : e.jsonpCallback),
                        a ? (e[a] = e[a].replace(Ue, "$1" + o)) : !1 !== e.jsonp && (e.url += (we.test(e.url) ? "&" : "?") + e.jsonp + "=" + o),
                        (e.converters["script json"] = function () {
                            return s || S.error(o + " was not called"), s[0];
                        }),
                        (e.dataTypes[0] = "json"),
                        (r = t[o]),
                        (t[o] = function () {
                            s = arguments;
                        }),
                        n.always(function () {
                            void 0 === r ? S(t).removeProp(o) : (t[o] = r), e[o] && ((e.jsonpCallback = i.jsonpCallback), Be.push(o)), s && p(r) && r(s[0]), (s = r = void 0);
                        }),
                        "script"
                    );
            }),
            (f.createHTMLDocument = ((($e = m.implementation.createHTMLDocument("").body).innerHTML = "<form></form><form></form>"), 2 === $e.childNodes.length)),
            (S.parseHTML = function (t, e, i) {
                return "string" != typeof t
                    ? []
                    : ("boolean" == typeof e && ((i = e), (e = !1)),
                      e || (f.createHTMLDocument ? (((n = (e = m.implementation.createHTMLDocument("")).createElement("base")).href = m.location.href), e.head.appendChild(n)) : (e = m)),
                      (r = !i && []),
                      (o = I.exec(t)) ? [e.createElement(o[1])] : ((o = bt([t], e, r)), r && r.length && S(r).remove(), S.merge([], o.childNodes)));
                var n, o, r;
            }),
            (S.fn.load = function (t, e, i) {
                var n,
                    o,
                    r,
                    s = this,
                    a = t.indexOf(" ");
                return (
                    -1 < a && ((n = pe(t.slice(a))), (t = t.slice(0, a))),
                    p(e) ? ((i = e), (e = void 0)) : e && "object" == typeof e && (o = "POST"),
                    0 < s.length &&
                        S.ajax({ url: t, type: o || "GET", dataType: "html", data: e })
                            .done(function (t) {
                                (r = arguments), s.html(n ? S("<div>").append(S.parseHTML(t)).find(n) : t);
                            })
                            .always(
                                i &&
                                    function (t, e) {
                                        s.each(function () {
                                            i.apply(this, r || [t.responseText, e, t]);
                                        });
                                    }
                            ),
                    this
                );
            }),
            (S.expr.pseudos.animated = function (t) {
                return S.grep(S.timers, function (e) {
                    return t === e.elem;
                }).length;
            }),
            (S.offset = {
                setOffset: function (t, e, i) {
                    var n,
                        o,
                        r,
                        s,
                        a,
                        l,
                        u = S.css(t, "position"),
                        c = S(t),
                        h = {};
                    "static" === u && (t.style.position = "relative"),
                        (a = c.offset()),
                        (r = S.css(t, "top")),
                        (l = S.css(t, "left")),
                        ("absolute" === u || "fixed" === u) && -1 < (r + l).indexOf("auto") ? ((s = (n = c.position()).top), (o = n.left)) : ((s = parseFloat(r) || 0), (o = parseFloat(l) || 0)),
                        p(e) && (e = e.call(t, i, S.extend({}, a))),
                        null != e.top && (h.top = e.top - a.top + s),
                        null != e.left && (h.left = e.left - a.left + o),
                        "using" in e ? e.using.call(t, h) : c.css(h);
                },
            }),
            S.fn.extend({
                offset: function (t) {
                    if (arguments.length)
                        return void 0 === t
                            ? this
                            : this.each(function (e) {
                                  S.offset.setOffset(this, t, e);
                              });
                    var e,
                        i,
                        n = this[0];
                    return n ? (n.getClientRects().length ? ((e = n.getBoundingClientRect()), (i = n.ownerDocument.defaultView), { top: e.top + i.pageYOffset, left: e.left + i.pageXOffset }) : { top: 0, left: 0 }) : void 0;
                },
                position: function () {
                    if (this[0]) {
                        var t,
                            e,
                            i,
                            n = this[0],
                            o = { top: 0, left: 0 };
                        if ("fixed" === S.css(n, "position")) e = n.getBoundingClientRect();
                        else {
                            for (e = this.offset(), i = n.ownerDocument, t = n.offsetParent || i.documentElement; t && (t === i.body || t === i.documentElement) && "static" === S.css(t, "position"); ) t = t.parentNode;
                            t && t !== n && 1 === t.nodeType && (((o = S(t).offset()).top += S.css(t, "borderTopWidth", !0)), (o.left += S.css(t, "borderLeftWidth", !0)));
                        }
                        return { top: e.top - o.top - S.css(n, "marginTop", !0), left: e.left - o.left - S.css(n, "marginLeft", !0) };
                    }
                },
                offsetParent: function () {
                    return this.map(function () {
                        for (var t = this.offsetParent; t && "static" === S.css(t, "position"); ) t = t.offsetParent;
                        return t || nt;
                    });
                },
            }),
            S.each({ scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function (t, e) {
                var i = "pageYOffset" === e;
                S.fn[t] = function (n) {
                    return F(
                        this,
                        function (t, n, o) {
                            var r;
                            if ((g(t) ? (r = t) : 9 === t.nodeType && (r = t.defaultView), void 0 === o)) return r ? r[e] : t[n];
                            r ? r.scrollTo(i ? r.pageXOffset : o, i ? o : r.pageYOffset) : (t[n] = o);
                        },
                        t,
                        n,
                        arguments.length
                    );
                };
            }),
            S.each(["top", "left"], function (t, e) {
                S.cssHooks[e] = Ht(f.pixelPosition, function (t, i) {
                    if (i) return (i = qt(t, e)), jt.test(i) ? S(t).position()[e] + "px" : i;
                });
            }),
            S.each({ Height: "height", Width: "width" }, function (t, e) {
                S.each({ padding: "inner" + t, content: e, "": "outer" + t }, function (i, n) {
                    S.fn[n] = function (o, r) {
                        var s = arguments.length && (i || "boolean" != typeof o),
                            a = i || (!0 === o || !0 === r ? "margin" : "border");
                        return F(
                            this,
                            function (e, i, o) {
                                var r;
                                return g(e)
                                    ? 0 === n.indexOf("outer")
                                        ? e["inner" + t]
                                        : e.document.documentElement["client" + t]
                                    : 9 === e.nodeType
                                    ? ((r = e.documentElement), Math.max(e.body["scroll" + t], r["scroll" + t], e.body["offset" + t], r["offset" + t], r["client" + t]))
                                    : void 0 === o
                                    ? S.css(e, i, a)
                                    : S.style(e, i, o, a);
                            },
                            e,
                            s ? o : void 0,
                            s
                        );
                    };
                });
            }),
            S.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (t, e) {
                S.fn[e] = function (t) {
                    return this.on(e, t);
                };
            }),
            S.fn.extend({
                bind: function (t, e, i) {
                    return this.on(t, null, e, i);
                },
                unbind: function (t, e) {
                    return this.off(t, null, e);
                },
                delegate: function (t, e, i, n) {
                    return this.on(e, t, i, n);
                },
                undelegate: function (t, e, i) {
                    return 1 === arguments.length ? this.off(t, "**") : this.off(e, t || "**", i);
                },
                hover: function (t, e) {
                    return this.mouseenter(t).mouseleave(e || t);
                },
            }),
            S.each("blur focus focusin focusout resize scroll click dblclick mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave change select submit keydown keypress keyup contextmenu".split(" "), function (t, e) {
                S.fn[e] = function (t, i) {
                    return 0 < arguments.length ? this.on(e, null, t, i) : this.trigger(e);
                };
            });
        var Ve = /^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g;
        (S.proxy = function (t, e) {
            var i, n, r;
            if (("string" == typeof e && ((i = t[e]), (e = t), (t = i)), p(t)))
                return (
                    (n = o.call(arguments, 2)),
                    ((r = function () {
                        return t.apply(e || this, n.concat(o.call(arguments)));
                    }).guid = t.guid = t.guid || S.guid++),
                    r
                );
        }),
            (S.holdReady = function (t) {
                t ? S.readyWait++ : S.ready(!0);
            }),
            (S.isArray = Array.isArray),
            (S.parseJSON = JSON.parse),
            (S.nodeName = k),
            (S.isFunction = p),
            (S.isWindow = g),
            (S.camelCase = V),
            (S.type = b),
            (S.now = Date.now),
            (S.isNumeric = function (t) {
                var e = S.type(t);
                return ("number" === e || "string" === e) && !isNaN(t - parseFloat(t));
            }),
            (S.trim = function (t) {
                return null == t ? "" : (t + "").replace(Ve, "");
            }),
            "function" == typeof define &&
                define.amd &&
                define("jquery", [], function () {
                    return S;
                });
        var Xe = t.jQuery,
            Ge = t.$;
        return (
            (S.noConflict = function (e) {
                return t.$ === S && (t.$ = Ge), e && t.jQuery === S && (t.jQuery = Xe), S;
            }),
            void 0 === e && (t.jQuery = t.$ = S),
            S
        );
    });
var jQuery_T4NT = jQuery;
!(function (t) {
    var e = "";
    screen.width && ((width = screen.width ? screen.width : ""), (height = screen.height ? screen.height : ""), (e += width + " x " + height));
    var i,
        n,
        o,
        r = navigator.appVersion,
        s = navigator.userAgent,
        a = navigator.appName,
        l = "" + parseFloat(navigator.appVersion),
        u = parseInt(navigator.appVersion, 10);
    -1 != (n = s.indexOf("Opera")) && ((a = "Opera"), (l = s.substring(n + 6)), -1 != (n = s.indexOf("Version")) && (l = s.substring(n + 8))),
        -1 != (n = s.indexOf("OPR"))
            ? ((a = "Opera"), (l = s.substring(n + 4)))
            : -1 != (n = s.indexOf("Edge"))
            ? ((a = "Edge"), (l = s.substring(n + 5)))
            : -1 != (n = s.indexOf("MSIE"))
            ? ((a = "Internet"), (l = s.substring(n + 5)))
            : -1 != (n = s.indexOf("Chrome"))
            ? ((a = "Chrome"), (l = s.substring(n + 7)))
            : -1 != (n = s.indexOf("Safari"))
            ? ((a = "Safari"), (l = s.substring(n + 7)), -1 != (n = s.indexOf("Version")) && (l = s.substring(n + 8)))
            : -1 != (n = s.indexOf("Firefox"))
            ? ((a = "Firefox"), (l = s.substring(n + 8)))
            : -1 != s.indexOf("Trident/")
            ? ((a = "Internet"), (l = s.substring(s.indexOf("rv:") + 3)))
            : (i = s.lastIndexOf(" ") + 1) < (n = s.lastIndexOf("/")) && ((a = s.substring(i, n)), (l = s.substring(n + 1)), a.toLowerCase() == a.toUpperCase() && (a = navigator.appName)),
        -1 != (o = l.indexOf(";")) && (l = l.substring(0, o)),
        -1 != (o = l.indexOf(" ")) && (l = l.substring(0, o)),
        -1 != (o = l.indexOf(")")) && (l = l.substring(0, o)),
        (u = parseInt("" + l, 10)),
        isNaN(u) && ((l = "" + parseFloat(navigator.appVersion)), (u = parseInt(navigator.appVersion, 10)));
    var c = /Mobile|mini|Fennec|Android|iP(ad|od|hone)/.test(r),
        h = "-",
        d = [
            { s: "Windows 10", r: /(Windows 10.0|Windows NT 10.0)/ },
            { s: "Windows 8.1", r: /(Windows 8.1|Windows NT 6.3)/ },
            { s: "Windows 8", r: /(Windows 8|Windows NT 6.2)/ },
            { s: "Windows 7", r: /(Windows 7|Windows NT 6.1)/ },
            { s: "Windows Vista", r: /Windows NT 6.0/ },
            { s: "Windows Server 2003", r: /Windows NT 5.2/ },
            { s: "Windows XP", r: /(Windows NT 5.1|Windows XP)/ },
            { s: "Windows 2000", r: /(Windows NT 5.0|Windows 2000)/ },
            { s: "Windows ME", r: /(Win 9x 4.90|Windows ME)/ },
            { s: "Windows 98", r: /(Windows 98|Win98)/ },
            { s: "Windows 95", r: /(Windows 95|Win95|Windows_95)/ },
            { s: "Windows NT 4.0", r: /(Windows NT 4.0|WinNT4.0|WinNT|Windows NT)/ },
            { s: "Windows CE", r: /Windows CE/ },
            { s: "Windows 3.11", r: /Win16/ },
            { s: "Android", r: /Android/ },
            { s: "Open BSD", r: /OpenBSD/ },
            { s: "Sun OS", r: /SunOS/ },
            { s: "Linux", r: /(Linux|X11)/ },
            { s: "iOS", r: /(iPhone|iPad|iPod)/ },
            { s: "Mac OS X", r: /Mac OS X/ },
            { s: "Mac OS", r: /(MacPPC|MacIntel|Mac_PowerPC|Macintosh)/ },
            { s: "QNX", r: /QNX/ },
            { s: "UNIX", r: /UNIX/ },
            { s: "BeOS", r: /BeOS/ },
            { s: "OS/2", r: /OS\/2/ },
            { s: "Search Bot", r: /(nuhk|Googlebot|Yammybot|Openbot|Slurp|MSNBot|Ask Jeeves\/Teoma|ia_archiver)/ },
        ];
    for (var f in d) {
        var p = d[f];
        if (p.r.test(s)) {
            h = p.s;
            break;
        }
    }
    /Windows/.test(h) && (h = "Windows");
    var g = "no check";
    if ("undefined" != typeof swfobject) {
        var m = swfobject.getFlashPlayerVersion();
        g = m.major > 0 ? m.major + "." + m.minor + " r" + m.release : "-";
    }
    t.jscd = { screen: e, browser: a, browserVersion: l, browserMajorVersion: u, mobile: c, os: h, osVersion: "-", flashVersion: g };
})(this),
    jQuery_T4NT("html").addClass("t4s-browser-" + jscd.browser + " t4s-platform-" + jscd.os);
var jsBdThe4 = document.getElementsByTagName("HTML")[0],
    RtlThe4 = jsBdThe4.classList.contains("rtl_true"),
    LtrThe4 = !RtlThe4;
!(function (t, e) {
    "function" == typeof define && define.amd
        ? define("jQuery_T4NT-bridget/jQuery_T4NT-bridget", ["jQuery_T4NT"], function (i) {
              return e(t, i);
          })
        : "object" == typeof module && module.exports
        ? (module.exports = e(t, require("jQuery_T4NT")))
        : (t.jQuery_T4NTBridget = e(t, t.jQuery_T4NT));
})(window, function (t, e) {
    "use strict";
    function i(i, r, a) {
        (a = a || e || t.jQuery_T4NT) &&
            (r.prototype.option ||
                (r.prototype.option = function (t) {
                    a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
                }),
            (a.fn[i] = function (t) {
                return "string" == typeof t
                    ? (function (t, e, n) {
                          var o,
                              r = "$()." + i + '("' + e + '")';
                          return (
                              t.each(function (t, l) {
                                  var u = a.data(l, i);
                                  if (u) {
                                      var c = u[e];
                                      if (c && "_" != e.charAt(0)) {
                                          var h = c.apply(u, n);
                                          o = void 0 === o ? h : o;
                                      } else s(r + " is not a valid method");
                                  } else s(i + " not initialized. Cannot call methods, i.e. " + r);
                              }),
                              void 0 !== o ? o : t
                          );
                      })(this, t, o.call(arguments, 1))
                    : ((function (t, e) {
                          t.each(function (t, n) {
                              var o = a.data(n, i);
                              o ? (o.option(e), o._init()) : ((o = new r(n, e)), a.data(n, i, o));
                          });
                      })(this, t),
                      this);
            }),
            n(a));
    }
    function n(t) {
        !t || (t && t.bridget) || (t.bridget = i);
    }
    var o = Array.prototype.slice,
        r = t.console,
        s =
            void 0 === r
                ? function () {}
                : function (t) {
                      r.error(t);
                  };
    return n(e || t.jQuery_T4NT), i;
}),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
        function t() {}
        var e = t.prototype;
        return (
            (e.on = function (t, e) {
                if (t && e) {
                    var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                }
            }),
            (e.once = function (t, e) {
                if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }
            }),
            (e.off = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                }
            }),
            (e.emitEvent = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                        var r = i[o];
                        n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e);
                    }
                    return this;
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.getSize = e());
    })(window, function () {
        "use strict";
        function t(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e;
        }
        function e(t) {
            var e = getComputedStyle(t);
            return e || r("Style returned " + e + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), e;
        }
        function i() {
            if (!l) {
                l = !0;
                var i = document.createElement("div");
                (i.style.width = "200px"), (i.style.padding = "1px 2px 3px 4px"), (i.style.borderStyle = "solid"), (i.style.borderWidth = "1px 2px 3px 4px"), (i.style.boxSizing = "border-box");
                var r = document.body || document.documentElement;
                r.appendChild(i);
                var s = e(i);
                (o = 200 == Math.round(t(s.width))), (n.isBoxSizeOuter = o), r.removeChild(i);
            }
        }
        function n(n) {
            if ((i(), "string" == typeof n && (n = document.querySelector(n)), n && "object" == typeof n && n.nodeType)) {
                var r = e(n);
                if ("none" == r.display)
                    return (function () {
                        for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; e < a; e++) t[s[e]] = 0;
                        return t;
                    })();
                var l = {};
                (l.width = n.offsetWidth), (l.height = n.offsetHeight);
                for (var u = (l.isBorderBox = "border-box" == r.boxSizing), c = 0; c < a; c++) {
                    var h = s[c],
                        d = r[h],
                        f = parseFloat(d);
                    l[h] = isNaN(f) ? 0 : f;
                }
                var p = l.paddingLeft + l.paddingRight,
                    g = l.paddingTop + l.paddingBottom,
                    m = l.marginLeft + l.marginRight,
                    v = l.marginTop + l.marginBottom,
                    y = l.borderLeftWidth + l.borderRightWidth,
                    b = l.borderTopWidth + l.borderBottomWidth,
                    x = u && o,
                    S = t(r.width);
                !1 !== S && (l.width = S + (x ? 0 : p + y));
                var w = t(r.height);
                return !1 !== w && (l.height = w + (x ? 0 : g + b)), (l.innerWidth = l.width - (p + y)), (l.innerHeight = l.height - (g + b)), (l.outerWidth = l.width + m), (l.outerHeight = l.height + v), l;
            }
        }
        var o,
            r =
                "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                          console.error(t);
                      },
            s = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            a = s.length,
            l = !1;
        return n;
    }),
    (function (t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.matchesSelector = e());
    })(window, function () {
        "use strict";
        var t = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
            }
        })();
        return function (e, i) {
            return e[t](i);
        };
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("desandro-matches-selector")))
            : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
        var i = {
                extend: function (t, e) {
                    for (var i in e) t[i] = e[i];
                    return t;
                },
                modulo: function (t, e) {
                    return ((t % e) + e) % e;
                },
            },
            n = Array.prototype.slice;
        (i.makeArray = function (t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t];
        }),
            (i.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
            }),
            (i.getParent = function (t, i) {
                for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), e(t, i))) return t;
            }),
            (i.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
            }),
            (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (i.filterFindElements = function (t, n) {
                t = i.makeArray(t);
                var o = [];
                return (
                    t.forEach(function (t) {
                        if (t instanceof HTMLElement) {
                            if (!n) return void o.push(t);
                            e(t, n) && o.push(t);
                            for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r]);
                        }
                    }),
                    o
                );
            }),
            (i.debounceMethod = function (t, e, i) {
                i = i || 100;
                var n = t.prototype[e],
                    o = e + "Timeout";
                t.prototype[e] = function () {
                    var t = this[o];
                    clearTimeout(t);
                    var e = arguments,
                        r = this;
                    this[o] = setTimeout(function () {
                        n.apply(r, e), delete r[o];
                    }, i);
                };
            }),
            (i.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
            }),
            (i.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                    })
                    .toLowerCase();
            });
        var o = t.console;
        return (
            (i.htmlInit = function (e, n) {
                i.docReady(function () {
                    var r = i.toDashed(n),
                        s = "data-" + r,
                        a = document.querySelectorAll("[" + s + "]"),
                        l = document.querySelectorAll(".js-" + r),
                        u = i.makeArray(a).concat(i.makeArray(l)),
                        c = s + "-options",
                        h = t.jQuery_T4NT;
                    u.forEach(function (t) {
                        var i,
                            r = t.getAttribute(s) || t.getAttribute(c);
                        try {
                            i = r && JSON.parse(r);
                        } catch (e) {
                            return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + e));
                        }
                        var a = new e(t, i);
                        h && h.data(t, n, a);
                    });
                });
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("jquery-bridget/jquery-bridget", ["jquery"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("jquery")))
            : (t.jQuery_T4NTBridget = e(t, t.jQuery_T4NT));
    })(window, function (t, e) {
        "use strict";
        var i = Array.prototype.slice,
            n = t.console,
            o =
                void 0 === n
                    ? function () {}
                    : function (t) {
                          n.error(t);
                      };
        function r(n, r, a) {
            (a = a || e || t.jQuery_T4NT) &&
                (r.prototype.option ||
                    (r.prototype.option = function (t) {
                        a.isPlainObject(t) && (this.options = a.extend(!0, this.options, t));
                    }),
                (a.fn[n] = function (t) {
                    var e;
                    return "string" == typeof t
                        ? (function (t, e, i) {
                              var r,
                                  s = "$()." + n + '("' + e + '")';
                              return (
                                  t.each(function (t, l) {
                                      var u = a.data(l, n);
                                      if (u) {
                                          var c = u[e];
                                          if (c && "_" != e.charAt(0)) {
                                              var h = c.apply(u, i);
                                              r = void 0 === r ? h : r;
                                          } else o(s + " is not a valid method");
                                      } else o(n + " not initialized. Cannot call methods, i.e. " + s);
                                  }),
                                  void 0 !== r ? r : t
                              );
                          })(this, t, i.call(arguments, 1))
                        : ((e = t),
                          this.each(function (t, i) {
                              var o = a.data(i, n);
                              o ? (o.option(e), o._init()) : ((o = new r(i, e)), a.data(i, n, o));
                          }),
                          this);
                }),
                s(a));
        }
        function s(t) {
            !t || (t && t.bridget) || (t.bridget = r);
        }
        return s(e || t.jQuery_T4NT), r;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("ev-emitter/ev-emitter", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.EvEmitter = e());
    })("undefined" != typeof window ? window : this, function () {
        function t() {}
        var e = t.prototype;
        return (
            (e.on = function (t, e) {
                if (t && e) {
                    var i = (this._events = this._events || {}),
                        n = (i[t] = i[t] || []);
                    return -1 == n.indexOf(e) && n.push(e), this;
                }
            }),
            (e.once = function (t, e) {
                if (t && e) {
                    this.on(t, e);
                    var i = (this._onceEvents = this._onceEvents || {});
                    return ((i[t] = i[t] || {})[e] = !0), this;
                }
            }),
            (e.off = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    var n = i.indexOf(e);
                    return -1 != n && i.splice(n, 1), this;
                }
            }),
            (e.emitEvent = function (t, e) {
                var i = this._events && this._events[t];
                if (i && i.length) {
                    (i = i.slice(0)), (e = e || []);
                    for (var n = this._onceEvents && this._onceEvents[t], o = 0; o < i.length; o++) {
                        var r = i[o];
                        n && n[r] && (this.off(t, r), delete n[r]), r.apply(this, e);
                    }
                    return this;
                }
            }),
            (e.allOff = function () {
                delete this._events, delete this._onceEvents;
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("get-size/get-size", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.getSize = e());
    })(window, function () {
        "use strict";
        function t(t) {
            var e = parseFloat(t);
            return -1 == t.indexOf("%") && !isNaN(e) && e;
        }
        var e =
                "undefined" == typeof console
                    ? function () {}
                    : function (t) {
                          console.error(t);
                      },
            i = ["paddingLeft", "paddingRight", "paddingTop", "paddingBottom", "marginLeft", "marginRight", "marginTop", "marginBottom", "borderLeftWidth", "borderRightWidth", "borderTopWidth", "borderBottomWidth"],
            n = i.length;
        function o(t) {
            var i = getComputedStyle(t);
            return i || e("Style returned " + i + ". Are you running this code in a hidden iframe on Firefox? See https://bit.ly/getsizebug1"), i;
        }
        var r,
            s = !1;
        return function e(a) {
            if (
                ((function () {
                    if (!s) {
                        s = !0;
                        var i = document.createElement("div");
                        (i.style.width = "200px"), (i.style.padding = "1px 2px 3px 4px"), (i.style.borderStyle = "solid"), (i.style.borderWidth = "1px 2px 3px 4px"), (i.style.boxSizing = "border-box");
                        var n = document.body || document.documentElement;
                        n.appendChild(i);
                        var a = o(i);
                        (r = 200 == Math.round(t(a.width))), (e.isBoxSizeOuter = r), n.removeChild(i);
                    }
                })(),
                "string" == typeof a && (a = document.querySelector(a)),
                a && "object" == typeof a && a.nodeType)
            ) {
                var l = o(a);
                if ("none" == l.display)
                    return (function () {
                        for (var t = { width: 0, height: 0, innerWidth: 0, innerHeight: 0, outerWidth: 0, outerHeight: 0 }, e = 0; e < n; e++) t[i[e]] = 0;
                        return t;
                    })();
                var u = {};
                (u.width = a.offsetWidth), (u.height = a.offsetHeight);
                for (var c = (u.isBorderBox = "border-box" == l.boxSizing), h = 0; h < n; h++) {
                    var d = i[h],
                        f = l[d],
                        p = parseFloat(f);
                    u[d] = isNaN(p) ? 0 : p;
                }
                var g = u.paddingLeft + u.paddingRight,
                    m = u.paddingTop + u.paddingBottom,
                    v = u.marginLeft + u.marginRight,
                    y = u.marginTop + u.marginBottom,
                    b = u.borderLeftWidth + u.borderRightWidth,
                    x = u.borderTopWidth + u.borderBottomWidth,
                    S = c && r,
                    w = t(l.width);
                !1 !== w && (u.width = w + (S ? 0 : g + b));
                var T = t(l.height);
                return !1 !== T && (u.height = T + (S ? 0 : m + x)), (u.innerWidth = u.width - (g + b)), (u.innerHeight = u.height - (m + x)), (u.outerWidth = u.width + v), (u.outerHeight = u.height + y), u;
            }
        };
    }),
    (function (t, e) {
        "use strict";
        "function" == typeof define && define.amd ? define("desandro-matches-selector/matches-selector", e) : "object" == typeof module && module.exports ? (module.exports = e()) : (t.matchesSelector = e());
    })(window, function () {
        "use strict";
        var t = (function () {
            var t = window.Element.prototype;
            if (t.matches) return "matches";
            if (t.matchesSelector) return "matchesSelector";
            for (var e = ["webkit", "moz", "ms", "o"], i = 0; i < e.length; i++) {
                var n = e[i] + "MatchesSelector";
                if (t[n]) return n;
            }
        })();
        return function (e, i) {
            return e[t](i);
        };
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("fizzy-ui-utils/utils", ["desandro-matches-selector/matches-selector"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("desandro-matches-selector")))
            : (t.fizzyUIUtils = e(t, t.matchesSelector));
    })(window, function (t, e) {
        var i = {
                extend: function (t, e) {
                    for (var i in e) t[i] = e[i];
                    return t;
                },
                modulo: function (t, e) {
                    return ((t % e) + e) % e;
                },
            },
            n = Array.prototype.slice;
        (i.makeArray = function (t) {
            return Array.isArray(t) ? t : null == t ? [] : "object" == typeof t && "number" == typeof t.length ? n.call(t) : [t];
        }),
            (i.removeFrom = function (t, e) {
                var i = t.indexOf(e);
                -1 != i && t.splice(i, 1);
            }),
            (i.getParent = function (t, i) {
                for (; t.parentNode && t != document.body; ) if (((t = t.parentNode), e(t, i))) return t;
            }),
            (i.getQueryElement = function (t) {
                return "string" == typeof t ? document.querySelector(t) : t;
            }),
            (i.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (i.filterFindElements = function (t, n) {
                t = i.makeArray(t);
                var o = [];
                return (
                    t.forEach(function (t) {
                        if (t instanceof HTMLElement)
                            if (n) {
                                e(t, n) && o.push(t);
                                for (var i = t.querySelectorAll(n), r = 0; r < i.length; r++) o.push(i[r]);
                            } else o.push(t);
                    }),
                    o
                );
            }),
            (i.debounceMethod = function (t, e, i) {
                i = i || 100;
                var n = t.prototype[e],
                    o = e + "Timeout";
                t.prototype[e] = function () {
                    var t = this[o];
                    clearTimeout(t);
                    var e = arguments,
                        r = this;
                    this[o] = setTimeout(function () {
                        n.apply(r, e), delete r[o];
                    }, i);
                };
            }),
            (i.docReady = function (t) {
                var e = document.readyState;
                "complete" == e || "interactive" == e ? setTimeout(t) : document.addEventListener("DOMContentLoaded", t);
            }),
            (i.toDashed = function (t) {
                return t
                    .replace(/(.)([A-Z])/g, function (t, e, i) {
                        return e + "-" + i;
                    })
                    .toLowerCase();
            });
        var o = t.console;
        return (
            (i.htmlInit = function (e, n) {
                i.docReady(function () {
                    var r = i.toDashed(n),
                        s = "data-" + r,
                        a = document.querySelectorAll("[" + s + "]"),
                        l = document.querySelectorAll(".js-" + r),
                        u = i.makeArray(a).concat(i.makeArray(l)),
                        c = s + "-options",
                        h = t.jQuery_T4NT;
                    u.forEach(function (t) {
                        var i,
                            r = t.getAttribute(s) || t.getAttribute(c);
                        try {
                            i = r && JSON.parse(r);
                        } catch (e) {
                            return void (o && o.error("Error parsing " + s + " on " + t.className + ": " + e));
                        }
                        var a = new e(t, i);
                        h && h.data(t, n, a);
                    });
                });
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/cell", ["get-size/get-size"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("get-size")))
            : ((t.Flickityt4s = t.Flickityt4s || {}), (t.Flickityt4s.Cell = e(t, t.getSize)));
    })(window, function (t, e) {
        function i(t, e) {
            (this.element = t), (this.parent = e), this.create();
        }
        var n = i.prototype;
        return (
            (n.create = function () {
                (this.element.style.position = "absolute"), this.element.setAttribute("aria-hidden", "true"), (this.x = 0), (this.shift = 0), (this.element.style[this.parent.originSide] = 0);
            }),
            (n.destroy = function () {
                this.unselect(), (this.element.style.position = "");
                var t = this.parent.originSide;
                (this.element.style[t] = ""), (this.element.style.transform = ""), this.element.removeAttribute("aria-hidden");
            }),
            (n.getSize = function () {
                this.size = e(this.element);
            }),
            (n.setPosition = function (t) {
                (this.x = t), this.updateTarget(), this.renderPosition(t);
            }),
            (n.updateTarget = n.setDefaultTarget = function () {
                var t = "left" == this.parent.originSide ? "marginLeft" : "marginRight";
                this.target = this.x + this.size[t] + this.size.width * this.parent.cellAlign;
            }),
            (n.renderPosition = function (t) {
                var e = "left" === this.parent.originSide ? 1 : -1,
                    i = this.parent.options.percentPosition ? t * e * (this.parent.size.innerWidth / this.size.width) : t * e;
                this.element.style.transform = "translateX(" + this.parent.getPositionValue(i) + ")";
            }),
            (n.select = function () {
                this.element.classList.add("is-selected"), this.element.removeAttribute("aria-hidden");
            }),
            (n.unselect = function () {
                this.element.classList.remove("is-selected"), this.element.setAttribute("aria-hidden", "true");
            }),
            (n.wrapShift = function (t) {
                (this.shift = t), this.renderPosition(this.x + this.parent.slideableWidth * t);
            }),
            (n.remove = function () {
                this.element.parentNode.removeChild(this.element);
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd ? define("flickityt4s/js/slide", e) : "object" == typeof module && module.exports ? (module.exports = e()) : ((t.Flickityt4s = t.Flickityt4s || {}), (t.Flickityt4s.Slide = e()));
    })(window, function () {
        "use strict";
        function t(t) {
            (this.parent = t), (this.isOriginLeft = "left" == t.originSide), (this.cells = []), (this.outerWidth = 0), (this.height = 0);
        }
        var e = t.prototype;
        return (
            (e.addCell = function (t) {
                if ((this.cells.push(t), (this.outerWidth += t.size.outerWidth), (this.height = Math.max(t.size.outerHeight, this.height)), 1 == this.cells.length)) {
                    this.x = t.x;
                    var e = this.isOriginLeft ? "marginLeft" : "marginRight";
                    this.firstMargin = t.size[e];
                }
            }),
            (e.updateTarget = function () {
                var t = this.isOriginLeft ? "marginRight" : "marginLeft",
                    e = this.getLastCell(),
                    i = e ? e.size[t] : 0,
                    n = this.outerWidth - (this.firstMargin + i);
                this.target = this.x + this.firstMargin + n * this.parent.cellAlign;
            }),
            (e.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (e.select = function () {
                this.cells.forEach(function (t) {
                    t.select();
                });
            }),
            (e.unselect = function () {
                this.cells.forEach(function (t) {
                    t.unselect();
                });
            }),
            (e.getCellElements = function () {
                return this.cells.map(function (t) {
                    return t.element;
                });
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/animate", ["fizzy-ui-utils/utils"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("fizzy-ui-utils")))
            : ((t.Flickityt4s = t.Flickityt4s || {}), (t.Flickityt4s.animatePrototype = e(t, t.fizzyUIUtils)));
    })(window, function (t, e) {
        return {
            startAnimation: function () {
                this.isAnimating || ((this.isAnimating = !0), (this.restingFrames = 0), this.animate());
            },
            animate: function () {
                this.applyDragForce(), this.applySelectedAttraction();
                var t = this.x;
                if ((this.integratePhysics(), this.positionSlider(), this.settle(t), this.isAnimating)) {
                    var e = this;
                    requestAnimationFrame(function () {
                        e.animate();
                    });
                }
            },
            positionSlider: function () {
                var t = this.x;
                this.options.wrapAround && this.cells.length > 1 && ((t = e.modulo(t, this.slideableWidth)), (t -= this.slideableWidth), this.shiftWrapCells(t)), this.setTranslateX(t, this.isAnimating), this.dispatchScrollEvent();
            },
            setTranslateX: function (t, e) {
                (t += this.cursorPosition), (t = RtlThe4 ? -t : t);
                var i = this.getPositionValue(t);
                this.slider.style.transform = e ? "translate3d(" + i + ",0,0)" : "translateX(" + i + ")";
            },
            dispatchScrollEvent: function () {
                var t = this.slides[0];
                if (t) {
                    var e = -this.x - t.target,
                        i = e / this.slidesWidth;
                    this.dispatchEvent("scroll", null, [i, e]);
                }
            },
            positionSliderAtSelected: function () {
                this.cells.length && ((this.x = -this.selectedSlide.target), (this.velocity = 0), this.positionSlider());
            },
            getPositionValue: function (t) {
                return this.options.percentPosition ? 0.01 * Math.round((t / this.size.innerWidth) * 1e4) + "%" : Math.round(t) + "px";
            },
            settle: function (t) {
                !this.isPointerDown && Math.round(100 * this.x) == Math.round(100 * t) && this.restingFrames++,
                    this.restingFrames > 2 && ((this.isAnimating = !1), delete this.isFreeScrolling, this.positionSlider(), this.dispatchEvent("settle", null, [this.selectedIndex]));
            },
            shiftWrapCells: function (t) {
                var e = this.cursorPosition + t;
                this._shiftCells(this.beforeShiftCells, e, -1);
                var i = this.size.innerWidth - (t + this.slideableWidth + this.cursorPosition);
                this._shiftCells(this.afterShiftCells, i, 1);
            },
            _shiftCells: function (t, e, i) {
                for (var n = 0; n < t.length; n++) {
                    var o = t[n],
                        r = e > 0 ? i : 0;
                    o.wrapShift(r), (e -= o.size.outerWidth);
                }
                this._checkVisibility();
            },
            _unshiftCells: function (t) {
                if (t && t.length) for (var e = 0; e < t.length; e++) t[e].wrapShift(0);
            },
            integratePhysics: function () {
                (this.x += this.velocity), (this.velocity *= this.getFrictionFactor());
            },
            applyForce: function (t) {
                this.velocity += t;
            },
            getFrictionFactor: function () {
                return 1 - this.options[this.isFreeScrolling ? "freeScrollFriction" : "friction"];
            },
            getRestingPosition: function () {
                return this.x + this.velocity / (1 - this.getFrictionFactor());
            },
            applyDragForce: function () {
                if (this.isDraggable && this.isPointerDown) {
                    var t = this.dragX - this.x - this.velocity;
                    this.applyForce(t);
                }
            },
            applySelectedAttraction: function () {
                if ((!this.isDraggable || !this.isPointerDown) && !this.isFreeScrolling && this.slides.length) {
                    var t = (-1 * this.selectedSlide.target - this.x) * this.options.selectedAttraction;
                    this.applyForce(t);
                }
            },
        };
    }),
    (function (t, e) {
        if ("function" == typeof define && define.amd)
            define("flickityt4s/js/flickityt4s", ["ev-emitter/ev-emitter", "get-size/get-size", "fizzy-ui-utils/utils", "./cell", "./slide", "./animate"], function (i, n, o, r, s, a) {
                return e(t, i, n, o, r, s, a);
            });
        else if ("object" == typeof module && module.exports) module.exports = e(t, require("ev-emitter"), require("get-size"), require("fizzy-ui-utils"), require("./cell"), require("./slide"), require("./animate"));
        else {
            var i = t.Flickityt4s;
            t.Flickityt4s = e(t, t.EvEmitter, t.getSize, t.fizzyUIUtils, i.Cell, i.Slide, i.animatePrototype);
        }
    })(window, function (t, e, i, n, o, r, s) {
        var a = t.jQuery_T4NT,
            l = t.getComputedStyle,
            u = t.console;
        function c(t, e) {
            for (t = n.makeArray(t); t.length; ) e.appendChild(t.shift());
        }
        var h = 0,
            d = {};
        function f(t, e) {
            var i = n.getQueryElement(t);
            if (i) {
                if (((this.element = i), this.element.flickityt4sGUID)) {
                    var o = d[this.element.flickityt4sGUID];
                    return o && o.option(e), o;
                }
                switch (
                    (a && (this.$element = a(this.element)),
                    (this.options = n.extend({}, this.constructor.defaults)),
                    (e.originwrapAround = e.wrapAround),
                    (e.rightToLeft = "rtl" == document.documentElement.getAttribute("dir")),
                    e.arrowIcon)
                ) {
                    case "1":
                        e.arrowShape = "M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z";
                        break;
                    case "2":
                        e.arrowShape = "M 10,50 L 60,100 L 65,95 L 20,50  L 65,5 L 60,0 Z";
                        break;
                    case "3":
                        e.arrowShape = "M 0,50 L 60,00 L 50,30 L 80,30 L 80,70 L 50,70 L 60,100 Z";
                }
                this.option(e), this._create();
            } else u && u.error("Bad element for Flickityt4s: " + (i || t));
        }
        (f.defaults = {
            accessibility: !0,
            cellAlign: "center",
            freeScrollFriction: 0.075,
            friction: 0.28,
            namespaceJQueryEvents: !0,
            percentPosition: !0,
            resize: !0,
            selectedAttraction: 0.025,
            setGallerySize: !0,
            setPrevNextButtons: !1,
            checkVisibility: !1,
            sync: !1,
        }),
            (f.createMethods = []);
        var p = f.prototype;
        n.extend(p, e.prototype),
            (p._create = function () {
                var e = (this.guid = ++h);
                for (var i in ((this.element.flickityt4sGUID = e),
                (d[e] = this),
                (this.selectedIndex = 0),
                (this.restingFrames = 0),
                (this.x = 0),
                (this.velocity = 0),
                (this.originSide = RtlThe4 ? "right" : "left"),
                (this.viewport = document.createElement("div")),
                (this.viewport.className = "flickityt4s-viewport"),
                this._createSlider(),
                (this.options.resize || this.options.watchCSS) && t.addEventListener("resize", this),
                this.options.on)) {
                    var n = this.options.on[i];
                    this.on(i, n);
                }
                f.createMethods.forEach(function (t) {
                    this[t]();
                }, this),
                    this.options.watchCSS ? this.watchCSS() : this.activate();
            }),
            (p.option = function (t) {
                n.extend(this.options, t);
            }),
            (p.activate = function () {
                this.isActive ||
                    ((this.isActive = !0),
                    this.element.classList.add("flickityt4s-enabled"),
                    RtlThe4 && this.element.classList.add("flickityt4s-rtl"),
                    this.getSize(),
                    c(this._filterFindCellElements(this.element.children), this.slider),
                    this.viewport.appendChild(this.slider),
                    this.element.appendChild(this.viewport),
                    this.reloadCells(),
                    this.options.accessibility && ((this.element.tabIndex = 0), this.element.addEventListener("keydown", this)),
                    this.emitEvent("activate"),
                    this.selectInitialIndex(),
                    (this.isInitActivated = !0),
                    this.dispatchEvent("ready"));
            }),
            (p._createSlider = function () {
                var t = document.createElement("div");
                (t.className = "flickityt4s-slider"), (t.style[this.originSide] = 0), (this.slider = t);
            }),
            (p._filterFindCellElements = function (t) {
                return n.filterFindElements(t, this.options.cellSelector);
            }),
            (p.reloadCells = function () {
                (this.cells = this._makeCells(this.slider.children)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.setPrevNextButtons();
            }),
            (p._makeCells = function (t) {
                return this._filterFindCellElements(t).map(function (t) {
                    return new o(t, this);
                }, this);
            }),
            (p.getLastCell = function () {
                return this.cells[this.cells.length - 1];
            }),
            (p.getLastSlide = function () {
                return this.slides[this.slides.length - 1];
            }),
            (p.positionCells = function () {
                this._sizeCells(this.cells), this._positionCells(0);
            }),
            (p._positionCells = function (t) {
                (t = t || 0), (this.maxCellHeight = (t && this.maxCellHeight) || 0);
                var e = 0;
                if (t > 0) {
                    var i = this.cells[t - 1];
                    e = i.x + i.size.outerWidth;
                }
                for (var n = this.cells.length, o = t; o < n; o++) {
                    var r = this.cells[o];
                    r.setPosition(e), (e += r.size.outerWidth), (this.maxCellHeight = Math.max(r.size.outerHeight, this.maxCellHeight));
                }
                (this.slideableWidth = e), this.updateSlides(), this._containSlides(), (this.slidesWidth = n ? this.getLastSlide().target - this.slides[0].target : 0), (this.maxVisibilityHeight = 0);
            }),
            (p._sizeCells = function (t) {
                t.forEach(function (t) {
                    t.getSize();
                });
            }),
            (p.updateSlides = function () {
                if (((this.slides = []), this.cells.length)) {
                    var t = new r(this);
                    this.slides.push(t);
                    var e = "left" == this.originSide ? "marginRight" : "marginLeft",
                        i = this._getCanCellFit();
                    this.cells.forEach(function (n, o) {
                        if (t.cells.length) {
                            var s = t.outerWidth - t.firstMargin + (n.size.outerWidth - n.size[e]);
                            i.call(this, o, s) ? t.addCell(n) : (t.updateTarget(), (t = new r(this)), this.slides.push(t), t.addCell(n));
                        } else t.addCell(n);
                    }, this),
                        t.updateTarget(),
                        this.updateSelectedSlide();
                }
            }),
            (p._getCanCellFit = function () {
                var t = this.options.groupCells;
                if (!t)
                    return function () {
                        return !1;
                    };
                if ("number" == typeof t) {
                    var e = parseInt(t, 10);
                    return function (t) {
                        return t % e != 0;
                    };
                }
                var i = "string" == typeof t && t.match(/^(\d+)%$/),
                    n = i ? parseInt(i[1], 10) / 100 : 1;
                return function (t, e) {
                    return e <= (this.size.innerWidth + 1) * n;
                };
            }),
            (p._init = p.reposition = function () {
                this.positionCells(), this.positionSliderAtSelected();
            }),
            (p.getSize = function () {
                (this.size = i(this.element)), this.setCellAlign(), (this.cursorPosition = this.size.innerWidth * this.cellAlign);
            });
        var g = { center: { left: 0.5, right: 0.5 }, left: { left: 0, right: 1 }, right: { right: 0, left: 1 } };
        return (
            (p.setCellAlign = function () {
                var t = g[this.options.cellAlign];
                this.cellAlign = t ? t[this.originSide] : this.options.cellAlign;
            }),
            (p.setGallerySize = function () {
                if (this.options.setGallerySize) {
                    var t = this.options.adaptiveHeight && this.selectedSlide ? this.selectedSlide.height : this.maxCellHeight;
                    (t = this.maxVisibilityHeight && this.maxVisibilityHeight > t ? this.maxVisibilityHeight : t), (this.viewport.style.height = t + "px");
                }
            }),
            (p.setPrevNextButtons = function () {
                if (this.options.setPrevNextButtons) {
                    var t = this.viewport.querySelector(".is-selected [data-cacl-slide]");
                    if (null !== t) {
                        var e = t.offsetHeight / 2;
                        this.element.style.setProperty("--prev-next-top", e + "px");
                    }
                }
            }),
            (p._checkVisibility = function () {
                if (this.options.checkVisibility && this.options.adaptiveHeight)
                    for (var t = this.viewport.getBoundingClientRect().x, e = this.viewport.offsetWidth, i = this.cells.length, n = 0; n < i; n++) {
                        var o = this.cells[n],
                            r = o.element.getBoundingClientRect().x - t;
                        (r + o.size.innerWidth > t && r + o.size.innerWidth < e) || (r > t && r < e)
                            ? ((this.maxVisibilityHeight = Math.max(o.size.outerHeight, this.maxVisibilityHeight)), o.element.classList.add("is-t4s-visible"), o.element.removeAttribute("aria-hidden"))
                            : (o.element.classList.remove("is-t4s-visible"), o.element.setAttribute("aria-hidden", !0));
                    }
            }),
            (p._getWrapShiftCells = function () {
                if (this.options.originwrapAround)
                    if (this.slides.length < 2) this.options.wrapAround = !1;
                    else {
                        (this.options.wrapAround = !0), this._unshiftCells(this.beforeShiftCells), this._unshiftCells(this.afterShiftCells);
                        var t = this.cursorPosition,
                            e = this.cells.length - 1;
                        (this.beforeShiftCells = this._getGapCells(t, e, -1)), (t = this.size.innerWidth - this.cursorPosition), (this.afterShiftCells = this._getGapCells(t, 0, 1));
                    }
            }),
            (p._getGapCells = function (t, e, i) {
                for (var n = []; t > 0; ) {
                    var o = this.cells[e];
                    if (!o) break;
                    n.push(o), (e += i), (t -= o.size.outerWidth);
                }
                return n;
            }),
            (p._containSlides = function () {
                if (this.options.contain && !this.options.wrapAround && this.cells.length) {
                    var t = RtlThe4 ? "marginRight" : "marginLeft",
                        e = RtlThe4 ? "marginLeft" : "marginRight",
                        i = this.slideableWidth - this.getLastCell().size[e],
                        n = i < this.size.innerWidth,
                        o = this.cursorPosition + this.cells[0].size[t],
                        r = i - this.size.innerWidth * (1 - this.cellAlign);
                    this.slides.forEach(function (t) {
                        n ? (t.target = i * this.cellAlign) : ((t.target = Math.max(t.target, o)), (t.target = Math.min(t.target, r)));
                    }, this);
                }
            }),
            (p.dispatchEvent = function (t, e, i) {
                var n = e ? [e].concat(i) : i;
                if ((this.emitEvent(t, n), a && this.$element)) {
                    var o = (t += this.options.namespaceJQueryEvents ? ".flickityt4s" : "");
                    if (e) {
                        var r = new a.Event(e);
                        (r.type = t), (o = r);
                    }
                    this.$element.trigger(o, i);
                }
            }),
            (p.select = function (t, e, i) {
                if (this.isActive && ((t = parseInt(t, 10)), this._wrapSelect(t), (this.options.wrapAround || e) && (t = n.modulo(t, this.slides.length)), this.slides[t])) {
                    var o = this.selectedIndex;
                    (this.selectedIndex = t),
                        this.updateSelectedSlide(),
                        i ? this.positionSliderAtSelected() : this.startAnimation(),
                        this.options.adaptiveHeight && this.setGallerySize(),
                        this.setPrevNextButtons(),
                        this.dispatchEvent("select", null, [t]),
                        t != o && this.dispatchEvent("change", null, [t]),
                        this.dispatchEvent("cellSelect");
                }
            }),
            (p._wrapSelect = function (t) {
                var e = this.slides.length;
                if (!(this.options.wrapAround && e > 1)) return t;
                var i = n.modulo(t, e),
                    o = Math.abs(i - this.selectedIndex),
                    r = Math.abs(i + e - this.selectedIndex),
                    s = Math.abs(i - e - this.selectedIndex);
                !this.isDragSelect && r < o ? (t += e) : !this.isDragSelect && s < o && (t -= e), t < 0 ? (this.x -= this.slideableWidth) : t >= e && (this.x += this.slideableWidth);
            }),
            (p.previous = function (t, e) {
                this.select(this.selectedIndex - 1, t, e);
            }),
            (p.next = function (t, e) {
                this.select(this.selectedIndex + 1, t, e);
            }),
            (p.updateSelectedSlide = function () {
                var t = this.slides[this.selectedIndex];
                t &&
                    (this.unselectSelectedSlide(),
                    (this.selectedSlide = t),
                    t.select(),
                    (this.selectedCells = t.cells),
                    (this.selectedElements = t.getCellElements()),
                    (this.selectedCell = t.cells[0]),
                    (this.selectedElement = this.selectedElements[0]));
            }),
            (p.unselectSelectedSlide = function () {
                this.selectedSlide && this.selectedSlide.unselect();
            }),
            (p.selectInitialIndex = function () {
                var t = this.options.initialIndex;
                if (this.isInitActivated) this.select(this.selectedIndex, !1, !0);
                else {
                    if (t && "string" == typeof t && this.queryCell(t)) return void this.selectCell(t, !1, !0);
                    var e = 0;
                    t && this.slides[t] && (e = t), this.select(e, !1, !0);
                }
            }),
            (p.selectCell = function (t, e, i) {
                var n = this.queryCell(t);
                if (n) {
                    var o = this.getCellSlideIndex(n);
                    this.select(o, e, i);
                }
            }),
            (p.getCellSlideIndex = function (t) {
                for (var e = 0; e < this.slides.length; e++) if (-1 != this.slides[e].cells.indexOf(t)) return e;
            }),
            (p.getCell = function (t) {
                for (var e = 0; e < this.cells.length; e++) {
                    var i = this.cells[e];
                    if (i.element == t) return i;
                }
            }),
            (p.getCells = function (t) {
                t = n.makeArray(t);
                var e = [];
                return (
                    t.forEach(function (t) {
                        var i = this.getCell(t);
                        i && e.push(i);
                    }, this),
                    e
                );
            }),
            (p.getCellElements = function () {
                return this.cells.map(function (t) {
                    return t.element;
                });
            }),
            (p.getParentCell = function (t) {
                return this.getCell(t) || ((t = n.getParent(t, ".flickityt4s-slider > *")), this.getCell(t));
            }),
            (p.getAdjacentCellElements = function (t, e) {
                if (!t) return this.selectedSlide.getCellElements();
                e = void 0 === e ? this.selectedIndex : e;
                var i = this.slides.length;
                if (1 + 2 * t >= i) return this.getCellElements();
                for (var o = [], r = e - t; r <= e + t; r++) {
                    var s = this.options.wrapAround ? n.modulo(r, i) : r,
                        a = this.slides[s];
                    a && (o = o.concat(a.getCellElements()));
                }
                return o;
            }),
            (p.queryCell = function (t) {
                if ("number" == typeof t) return this.cells[t];
                if ("string" == typeof t) {
                    if (t.match(/^[#.]?[\d/]/)) return;
                    t = this.element.querySelector(t);
                }
                return this.getCell(t);
            }),
            (p.uiChange = function () {
                this.emitEvent("uiChange");
            }),
            (p.childUIPointerDown = function (t) {
                "touchstart" != t.type && t.preventDefault(), this.focus();
            }),
            (p.onresize = function () {
                this.watchCSS(), this.resize();
            }),
            n.debounceMethod(f, "onresize", 150),
            (p.resize = function () {
                if (this.isActive && !this.isAnimating && !this.isDragging) {
                    this.getSize(), this.options.wrapAround && (this.x = n.modulo(this.x, this.slideableWidth)), this.positionCells(), this._getWrapShiftCells(), this.setGallerySize(), this.setPrevNextButtons(), this.emitEvent("resize");
                    var t = this.selectedElements && this.selectedElements[0];
                    this.selectCell(t, !1, !0);
                }
            }),
            (p.watchCSS = function () {
                this.options.watchCSS && (-1 != l(this.element, ":after").content.indexOf("flickityt4s") ? this.activate() : this.deactivate());
            }),
            (p.onkeydown = function (t) {
                var e = document.activeElement && document.activeElement != this.element;
                if (this.options.accessibility && !e) {
                    var i = f.keyboardHandlers[t.keyCode];
                    i && i.call(this);
                }
            }),
            (f.keyboardHandlers = {
                37: function () {
                    var t = RtlThe4 ? "next" : "previous";
                    this.uiChange(), this[t]();
                },
                39: function () {
                    var t = RtlThe4 ? "previous" : "next";
                    this.uiChange(), this[t]();
                },
            }),
            (p.focus = function () {
                var e = t.pageYOffset;
                this.element.focus({ preventScroll: !0 }), t.pageYOffset != e && t.scrollTo(t.pageXOffset, e);
            }),
            (p.deactivate = function () {
                this.isActive &&
                    (this.element.classList.remove("flickityt4s-enabled"),
                    this.element.classList.remove("flickityt4s-rtl"),
                    this.unselectSelectedSlide(),
                    this.cells.forEach(function (t) {
                        t.destroy();
                    }),
                    this.element.removeChild(this.viewport),
                    c(this.slider.children, this.element),
                    this.options.accessibility && (this.element.removeAttribute("tabIndex"), this.element.removeEventListener("keydown", this)),
                    (this.isActive = !1),
                    this.emitEvent("deactivate"));
            }),
            (p.destroy = function () {
                this.deactivate(), t.removeEventListener("resize", this), this.allOff(), this.emitEvent("destroy"), a && this.$element && a.removeData(this.element, "flickityt4s"), delete this.element.flickityt4sGUID, delete d[this.guid];
            }),
            n.extend(p, s),
            (f.data = function (t) {
                var e = (t = n.getQueryElement(t)) && t.flickityt4sGUID;
                return e && d[e];
            }),
            n.htmlInit(f, "flickityt4s"),
            a && a.bridget && a.bridget("flickityt4s", f),
            (f.setJQuery = function (t) {
                a = t;
            }),
            (f.Cell = o),
            (f.Slide = r),
            f
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("unipointer/unipointer", ["ev-emitter/ev-emitter"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("ev-emitter")))
            : (t.Unipointer = e(t, t.EvEmitter));
    })(window, function (t, e) {
        function i() {}
        var n = (i.prototype = Object.create(e.prototype));
        (n.bindStartEvent = function (t) {
            this._bindStartEvent(t, !0);
        }),
            (n.unbindStartEvent = function (t) {
                this._bindStartEvent(t, !1);
            }),
            (n._bindStartEvent = function (e, i) {
                var n = (i = void 0 === i || i) ? "addEventListener" : "removeEventListener",
                    o = "mousedown";
                "ontouchstart" in t ? (o = "touchstart") : t.PointerEvent && (o = "pointerdown"), e[n](o, this);
            }),
            (n.handleEvent = function (t) {
                var e = "on" + t.type;
                this[e] && this[e](t);
            }),
            (n.getTouch = function (t) {
                for (var e = 0; e < t.length; e++) {
                    var i = t[e];
                    if (i.identifier == this.pointerIdentifier) return i;
                }
            }),
            (n.onmousedown = function (t) {
                var e = t.button;
                (e && 0 !== e && 1 !== e) || this._pointerDown(t, t);
            }),
            (n.ontouchstart = function (t) {
                this._pointerDown(t, t.changedTouches[0]);
            }),
            (n.onpointerdown = function (t) {
                this._pointerDown(t, t);
            }),
            (n._pointerDown = function (t, e) {
                t.button || this.isPointerDown || ((this.isPointerDown = !0), (this.pointerIdentifier = void 0 !== e.pointerId ? e.pointerId : e.identifier), this.pointerDown(t, e));
            }),
            (n.pointerDown = function (t, e) {
                this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]);
            });
        var o = { mousedown: ["mousemove", "mouseup"], touchstart: ["touchmove", "touchend", "touchcancel"], pointerdown: ["pointermove", "pointerup", "pointercancel"] };
        return (
            (n._bindPostStartEvents = function (e) {
                if (e) {
                    var i = o[e.type];
                    i.forEach(function (e) {
                        t.addEventListener(e, this);
                    }, this),
                        (this._boundPointerEvents = i);
                }
            }),
            (n._unbindPostStartEvents = function () {
                this._boundPointerEvents &&
                    (this._boundPointerEvents.forEach(function (e) {
                        t.removeEventListener(e, this);
                    }, this),
                    delete this._boundPointerEvents);
            }),
            (n.onmousemove = function (t) {
                this._pointerMove(t, t);
            }),
            (n.onpointermove = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerMove(t, t);
            }),
            (n.ontouchmove = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerMove(t, e);
            }),
            (n._pointerMove = function (t, e) {
                this.pointerMove(t, e);
            }),
            (n.pointerMove = function (t, e) {
                this.emitEvent("pointerMove", [t, e]);
            }),
            (n.onmouseup = function (t) {
                this._pointerUp(t, t);
            }),
            (n.onpointerup = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerUp(t, t);
            }),
            (n.ontouchend = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerUp(t, e);
            }),
            (n._pointerUp = function (t, e) {
                this._pointerDone(), this.pointerUp(t, e);
            }),
            (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]);
            }),
            (n._pointerDone = function () {
                this._pointerReset(), this._unbindPostStartEvents(), this.pointerDone();
            }),
            (n._pointerReset = function () {
                (this.isPointerDown = !1), delete this.pointerIdentifier;
            }),
            (n.pointerDone = function () {}),
            (n.onpointercancel = function (t) {
                t.pointerId == this.pointerIdentifier && this._pointerCancel(t, t);
            }),
            (n.ontouchcancel = function (t) {
                var e = this.getTouch(t.changedTouches);
                e && this._pointerCancel(t, e);
            }),
            (n._pointerCancel = function (t, e) {
                this._pointerDone(), this.pointerCancel(t, e);
            }),
            (n.pointerCancel = function (t, e) {
                this.emitEvent("pointerCancel", [t, e]);
            }),
            (i.getPointerPoint = function (t) {
                return { x: t.pageX, y: t.pageY };
            }),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("unidragger/unidragger", ["unipointer/unipointer"], function (i) {
                  return e(t, i);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("unipointer")))
            : (t.Unidragger = e(t, t.Unipointer));
    })(window, function (t, e) {
        function i() {}
        var n = (i.prototype = Object.create(e.prototype));
        (n.bindHandles = function () {
            this._bindHandles(!0);
        }),
            (n.unbindHandles = function () {
                this._bindHandles(!1);
            }),
            (n._bindHandles = function (e) {
                for (var i = (e = void 0 === e || e) ? "addEventListener" : "removeEventListener", n = e ? this._touchActionValue : "", o = 0; o < this.handles.length; o++) {
                    var r = this.handles[o];
                    this._bindStartEvent(r, e), r[i]("click", this), t.PointerEvent && (r.style.touchAction = n);
                }
            }),
            (n._touchActionValue = "none"),
            (n.pointerDown = function (t, e) {
                this.okayPointerDown(t) && ((this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }), t.preventDefault(), this.pointerDownBlur(), this._bindPostStartEvents(t), this.emitEvent("pointerDown", [t, e]));
            });
        var o = { TEXTAREA: !0, INPUT: !0, SELECT: !0, OPTION: !0 },
            r = { radio: !0, checkbox: !0, button: !0, submit: !0, image: !0, file: !0 };
        return (
            (n.okayPointerDown = function (t) {
                var e = o[t.target.nodeName],
                    i = r[t.target.type],
                    n = !e || i;
                return n || this._pointerReset(), n;
            }),
            (n.pointerDownBlur = function () {
                var t = document.activeElement;
                t && t.blur && t != document.body && t.blur();
            }),
            (n.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.emitEvent("pointerMove", [t, e, i]), this._dragMove(t, e, i);
            }),
            (n._dragPointerMove = function (t, e) {
                var i = { x: e.pageX - this.pointerDownPointer.pageX, y: e.pageY - this.pointerDownPointer.pageY };
                return !this.isDragging && this.hasDragStarted(i) && this._dragStart(t, e), i;
            }),
            (n.hasDragStarted = function (t) {
                return Math.abs(t.x) > 3 || Math.abs(t.y) > 3;
            }),
            (n.pointerUp = function (t, e) {
                this.emitEvent("pointerUp", [t, e]), this._dragPointerUp(t, e);
            }),
            (n._dragPointerUp = function (t, e) {
                this.isDragging ? this._dragEnd(t, e) : this._staticClick(t, e);
            }),
            (n._dragStart = function (t, e) {
                (this.isDragging = !0), (this.isPreventingClicks = !0), this.dragStart(t, e);
            }),
            (n.dragStart = function (t, e) {
                this.emitEvent("dragStart", [t, e]);
            }),
            (n._dragMove = function (t, e, i) {
                this.isDragging && this.dragMove(t, e, i);
            }),
            (n.dragMove = function (t, e, i) {
                t.preventDefault(), this.emitEvent("dragMove", [t, e, i]);
            }),
            (n._dragEnd = function (t, e) {
                (this.isDragging = !1),
                    setTimeout(
                        function () {
                            delete this.isPreventingClicks;
                        }.bind(this)
                    ),
                    this.dragEnd(t, e);
            }),
            (n.dragEnd = function (t, e) {
                this.emitEvent("dragEnd", [t, e]);
            }),
            (n.onclick = function (t) {
                this.isPreventingClicks && t.preventDefault();
            }),
            (n._staticClick = function (t, e) {
                (this.isIgnoringMouseUp && "mouseup" == t.type) ||
                    (this.staticClick(t, e),
                    "mouseup" != t.type &&
                        ((this.isIgnoringMouseUp = !0),
                        setTimeout(
                            function () {
                                delete this.isIgnoringMouseUp;
                            }.bind(this),
                            400
                        )));
            }),
            (n.staticClick = function (t, e) {
                this.emitEvent("staticClick", [t, e]);
            }),
            (i.getPointerPoint = e.getPointerPoint),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/drag", ["./flickityt4s", "unidragger/unidragger", "fizzy-ui-utils/utils"], function (i, n, o) {
                  return e(t, i, n, o);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("./flickityt4s"), require("unidragger"), require("fizzy-ui-utils")))
            : (t.Flickityt4s = e(t, t.Flickityt4s, t.Unidragger, t.fizzyUIUtils));
    })(window, function (t, e, i, n) {
        n.extend(e.defaults, { draggable: ">1", dragThreshold: 3 }), e.createMethods.push("_createDrag");
        var o = e.prototype;
        n.extend(o, i.prototype),
            (o._touchActionValue = "pan-y"),
            (o._createDrag = function () {
                this.on("activate", this.onActivateDrag), this.on("uiChange", this._uiChangeDrag), this.on("deactivate", this.onDeactivateDrag), this.on("cellChange", this.updateDraggable);
            }),
            (o.onActivateDrag = function () {
                (this.handles = [this.viewport]), this.bindHandles(), this.updateDraggable();
            }),
            (o.onDeactivateDrag = function () {
                this.unbindHandles(), this.element.classList.remove("is-draggable");
            }),
            (o.updateDraggable = function () {
                ">1" == this.options.draggable
                    ? (this.isDraggable = this.slides.length > 1)
                    : "smart" == this.options.draggable
                    ? (this.viewport, (this.isDraggable = this.viewport.scrollWidth > this.viewport.offsetWidth))
                    : (this.isDraggable = this.options.draggable),
                    this.isDraggable ? this.element.classList.add("is-draggable") : this.element.classList.remove("is-draggable");
            }),
            (o.bindDrag = function () {
                (this.options.draggable = !0), this.updateDraggable();
            }),
            (o.unbindDrag = function () {
                (this.options.draggable = !1), this.updateDraggable();
            }),
            (o._uiChangeDrag = function () {
                delete this.isFreeScrolling;
            }),
            (o.pointerDown = function (e, i) {
                this.isDraggable
                    ? this.okayPointerDown(e) &&
                      (this._pointerDownPreventDefault(e),
                      this.pointerDownFocus(e),
                      document.activeElement != this.element && this.pointerDownBlur(),
                      (this.dragX = this.x),
                      this.viewport.classList.add("is-pointer-down"),
                      (this.pointerDownScroll = s()),
                      t.addEventListener("scroll", this),
                      this._pointerDownDefault(e, i))
                    : this._pointerDownDefault(e, i);
            }),
            (o._pointerDownDefault = function (t, e) {
                (this.pointerDownPointer = { pageX: e.pageX, pageY: e.pageY }), this._bindPostStartEvents(t), this.dispatchEvent("pointerDown", t, [e]);
            });
        var r = { INPUT: !0, TEXTAREA: !0, SELECT: !0 };
        function s() {
            return { x: t.pageXOffset, y: t.pageYOffset };
        }
        return (
            (o.pointerDownFocus = function (t) {
                r[t.target.nodeName] || this.focus();
            }),
            (o._pointerDownPreventDefault = function (t) {
                var e = "touchstart" == t.type,
                    i = "touch" == t.pointerType,
                    n = r[t.target.nodeName];
                e || i || n || t.preventDefault();
            }),
            (o.hasDragStarted = function (t) {
                return Math.abs(t.x) > this.options.dragThreshold;
            }),
            (o.pointerUp = function (t, e) {
                delete this.isTouchScrolling, this.viewport.classList.remove("is-pointer-down"), this.dispatchEvent("pointerUp", t, [e]), this._dragPointerUp(t, e);
            }),
            (o.pointerDone = function () {
                t.removeEventListener("scroll", this), delete this.pointerDownScroll;
            }),
            (o.dragStart = function (e, i) {
                this.isDraggable && ((this.dragStartPosition = this.x), this.startAnimation(), t.removeEventListener("scroll", this), this.dispatchEvent("dragStart", e, [i]));
            }),
            (o.pointerMove = function (t, e) {
                var i = this._dragPointerMove(t, e);
                this.dispatchEvent("pointerMove", t, [e, i]), this._dragMove(t, e, i);
            }),
            (o.dragMove = function (t, e, i) {
                if (this.isDraggable) {
                    t.preventDefault(), (this.previousDragX = this.dragX);
                    var n = RtlThe4 ? -1 : 1;
                    this.options.wrapAround && (i.x %= this.slideableWidth);
                    var o = this.dragStartPosition + i.x * n;
                    if (!this.options.wrapAround && this.slides.length) {
                        var r = Math.max(-this.slides[0].target, this.dragStartPosition);
                        o = o > r ? 0.5 * (o + r) : o;
                        var s = Math.min(-this.getLastSlide().target, this.dragStartPosition);
                        o = o < s ? 0.5 * (o + s) : o;
                    }
                    (this.dragX = o), (this.dragMoveTime = new Date()), this.dispatchEvent("dragMove", t, [e, i]);
                }
            }),
            (o.dragEnd = function (t, e) {
                if (this.isDraggable) {
                    this.options.freeScroll && (this.isFreeScrolling = !0);
                    var i = this.dragEndRestingSelect();
                    if (this.options.freeScroll && !this.options.wrapAround) {
                        var n = this.getRestingPosition();
                        this.isFreeScrolling = -n > this.slides[0].target && -n < this.getLastSlide().target;
                    } else this.options.freeScroll || i != this.selectedIndex || (i += this.dragEndBoostSelect());
                    delete this.previousDragX, (this.isDragSelect = this.options.wrapAround), this.select(i), delete this.isDragSelect, this.dispatchEvent("dragEnd", t, [e]);
                }
            }),
            (o.dragEndRestingSelect = function () {
                var t = this.getRestingPosition(),
                    e = Math.abs(this.getSlideDistance(-t, this.selectedIndex)),
                    i = this._getClosestResting(t, e, 1),
                    n = this._getClosestResting(t, e, -1);
                return i.distance < n.distance ? i.index : n.index;
            }),
            (o._getClosestResting = function (t, e, i) {
                for (
                    var n = this.selectedIndex,
                        o = 1 / 0,
                        r =
                            this.options.contain && !this.options.wrapAround
                                ? function (t, e) {
                                      return t <= e;
                                  }
                                : function (t, e) {
                                      return t < e;
                                  };
                    r(e, o) && ((n += i), (o = e), null !== (e = this.getSlideDistance(-t, n)));

                )
                    e = Math.abs(e);
                return { distance: o, index: n - i };
            }),
            (o.getSlideDistance = function (t, e) {
                var i = this.slides.length,
                    o = this.options.wrapAround && i > 1,
                    r = o ? n.modulo(e, i) : e,
                    s = this.slides[r];
                if (!s) return null;
                var a = o ? this.slideableWidth * Math.floor(e / i) : 0;
                return t - (s.target + a);
            }),
            (o.dragEndBoostSelect = function () {
                if (void 0 === this.previousDragX || !this.dragMoveTime || new Date() - this.dragMoveTime > 100) return 0;
                var t = this.getSlideDistance(-this.dragX, this.selectedIndex),
                    e = this.previousDragX - this.dragX;
                return t > 0 && e > 0 ? 1 : t < 0 && e < 0 ? -1 : 0;
            }),
            (o.staticClick = function (t, e) {
                var i = this.getParentCell(t.target),
                    n = i && i.element,
                    o = i && this.cells.indexOf(i);
                this.dispatchEvent("staticClick", t, [e, n, o]);
            }),
            (o.onscroll = function () {
                var t = s(),
                    e = this.pointerDownScroll.x - t.x,
                    i = this.pointerDownScroll.y - t.y;
                (Math.abs(e) > 3 || Math.abs(i) > 3) && this._pointerDone();
            }),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/prev-next-button", ["./flickityt4s", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (i, n, o) {
                  return e(t, i, n, o);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("./flickityt4s"), require("unipointer"), require("fizzy-ui-utils")))
            : e(t, t.Flickityt4s, t.Unipointer, t.fizzyUIUtils);
    })(window, function (t, e, i, n) {
        "use strict";
        var o = "http://www.w3.org/2000/svg";
        function r(t, e) {
            (this.direction = t), (this.parent = e), this._create();
        }
        (r.prototype = Object.create(i.prototype)),
            (r.prototype._create = function () {
                (this.isEnabled = !0), (this.isPrevious = -1 == this.direction);
                var t = this.parent.options.rightToLeft ? 1 : -1;
                this.isLeft = this.direction == t;
                var e = (this.element = document.createElement("button"));
                (e.className = "flickityt4s-button flickityt4s-prev-next-button"),
                    (e.className += this.isPrevious ? " previous" : " next"),
                    e.setAttribute("type", "button"),
                    this.disable(),
                    e.setAttribute("aria-label", this.isPrevious ? "Previous" : "Next");
                var i = this.createSVG();
                e.appendChild(i), this.parent.on("select", this.update.bind(this)), this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (r.prototype.activate = function () {
                this.bindStartEvent(this.element), this.element.addEventListener("click", this), this.parent.element.appendChild(this.element);
            }),
            (r.prototype.deactivate = function () {
                this.parent.element.removeChild(this.element), this.unbindStartEvent(this.element), this.element.removeEventListener("click", this);
            }),
            (r.prototype.createSVG = function () {
                var t = document.createElementNS(o, "svg");
                t.setAttribute("class", "flickityt4s-button-icon"), t.setAttribute("viewBox", "0 0 100 100");
                var e = document.createElementNS(o, "path"),
                    i = (function (t) {
                        return "string" == typeof t ? t : "M " + t.x0 + ",50 L " + t.x1 + "," + (t.y1 + 50) + " L " + t.x2 + "," + (t.y2 + 50) + " L " + t.x3 + ",50  L " + t.x2 + "," + (50 - t.y2) + " L " + t.x1 + "," + (50 - t.y1) + " Z";
                    })(this.parent.options.arrowShape);
                return e.setAttribute("d", i), e.setAttribute("class", "arrow"), this.isLeft || e.setAttribute("transform", "translate(100, 100) rotate(180) "), t.appendChild(e), t;
            }),
            (r.prototype.handleEvent = n.handleEvent),
            (r.prototype.onclick = function () {
                if (this.isEnabled) {
                    this.parent.uiChange();
                    var t = this.isPrevious ? "previous" : "next";
                    this.parent[t]();
                }
            }),
            (r.prototype.enable = function () {
                this.isEnabled || ((this.element.disabled = !1), (this.isEnabled = !0));
            }),
            (r.prototype.disable = function () {
                this.isEnabled && ((this.element.disabled = !0), (this.isEnabled = !1));
            }),
            (r.prototype.update = function () {
                var t = this.isPrevious ? "prev_" : "next_";
                this.parent.element.classList.remove("flickityt4s_" + t + "disable", "flickityt4s_" + t + "enable");
                var e = this.parent.slides;
                if (this.parent.options.wrapAround && e.length > 1) this.enable();
                else {
                    var i = e.length ? e.length - 1 : 0,
                        n = this.isPrevious ? 0 : i,
                        o = this.parent.selectedIndex == n ? "disable" : "enable";
                    this[o](), this.parent.element.classList.add("flickityt4s_" + t + o);
                }
            }),
            (r.prototype.destroy = function () {
                this.deactivate(), this.allOff();
            }),
            n.extend(e.defaults, { prevNextButtons: !0, arrowShape: { x0: 10, x1: 60, y1: 50, x2: 70, y2: 40, x3: 30 } }),
            e.createMethods.push("_createPrevNextButtons");
        var s = e.prototype;
        return (
            (s._createPrevNextButtons = function () {
                this.options.prevNextButtons && ((this.prevButton = new r(-1, this)), (this.nextButton = new r(1, this)), this.on("activate", this.activatePrevNextButtons));
            }),
            (s.activatePrevNextButtons = function () {
                this.prevButton.activate(), this.nextButton.activate(), this.on("deactivate", this.deactivatePrevNextButtons);
            }),
            (s.deactivatePrevNextButtons = function () {
                this.prevButton.deactivate(), this.nextButton.deactivate(), this.off("deactivate", this.deactivatePrevNextButtons);
            }),
            (e.PrevNextButton = r),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/page-dots", ["./flickityt4s", "unipointer/unipointer", "fizzy-ui-utils/utils"], function (i, n, o) {
                  return e(t, i, n, o);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("./flickityt4s"), require("unipointer"), require("fizzy-ui-utils")))
            : e(t, t.Flickityt4s, t.Unipointer, t.fizzyUIUtils);
    })(window, function (t, e, i, n) {
        function o(t) {
            (this.parent = t), this._create();
        }
        (o.prototype = Object.create(i.prototype)),
            (o.prototype._create = function () {
                (this.holder = document.createElement("ol")),
                    (this.holder.className = "flickityt4s-page-dots"),
                    (this.dots = []),
                    (this.handleClick = this.onClick.bind(this)),
                    this.on("pointerDown", this.parent.childUIPointerDown.bind(this.parent));
            }),
            (o.prototype.activate = function () {
                this.setDots(), this.holder.addEventListener("click", this.handleClick), this.bindStartEvent(this.holder), this.parent.element.appendChild(this.holder);
            }),
            (o.prototype.deactivate = function () {
                this.holder.removeEventListener("click", this.handleClick), this.unbindStartEvent(this.holder), this.parent.element.removeChild(this.holder);
            }),
            (o.prototype.setDots = function () {
                var t = this.parent.slides.length - this.dots.length;
                t > 0 ? this.addDots(t) : t < 0 && this.removeDots(-t);
            }),
            (o.prototype.addDots = function (t) {
                for (var e = document.createDocumentFragment(), i = [], n = this.dots.length, o = n + t, r = n; r < o; r++) {
                    var s = document.createElement("li");
                    (s.className = "dot"), s.setAttribute("aria-label", "Page dot " + (r + 1)), e.appendChild(s), i.push(s);
                }
                this.holder.appendChild(e), (this.dots = this.dots.concat(i));
            }),
            (o.prototype.removeDots = function (t) {
                this.dots.splice(this.dots.length - t, t).forEach(function (t) {
                    this.holder.removeChild(t);
                }, this);
            }),
            (o.prototype.updateSelected = function () {
                this.selectedDot && ((this.selectedDot.className = "dot"), this.selectedDot.removeAttribute("aria-current")),
                    this.dots.length && ((this.selectedDot = this.dots[this.parent.selectedIndex]), (this.selectedDot.className = "dot is-selected"), this.selectedDot.setAttribute("aria-current", "step"));
            }),
            (o.prototype.onTap = o.prototype.onClick = function (t) {
                var e = t.target;
                if ("LI" == e.nodeName) {
                    this.parent.uiChange();
                    var i = this.dots.indexOf(e);
                    this.parent.select(i);
                }
            }),
            (o.prototype.destroy = function () {
                this.deactivate(), this.allOff();
            }),
            (e.PageDots = o),
            n.extend(e.defaults, { pageDots: !0 }),
            e.createMethods.push("_createPageDots");
        var r = e.prototype;
        return (
            (r._createPageDots = function () {
                this.options.pageDots &&
                    ((this.pageDots = new o(this)),
                    this.on("activate", this.activatePageDots),
                    this.on("select", this.updateSelectedPageDots),
                    this.on("cellChange", this.updatePageDots),
                    this.on("resize", this.updatePageDots),
                    this.on("deactivate", this.deactivatePageDots));
            }),
            (r.activatePageDots = function () {
                this.pageDots.activate();
            }),
            (r.updateSelectedPageDots = function () {
                this.pageDots.updateSelected();
            }),
            (r.updatePageDots = function () {
                this.pageDots.setDots();
            }),
            (r.deactivatePageDots = function () {
                this.pageDots.deactivate();
            }),
            (e.PageDots = o),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/player", ["ev-emitter/ev-emitter", "fizzy-ui-utils/utils", "./flickityt4s"], function (t, i, n) {
                  return e(t, i, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("ev-emitter"), require("fizzy-ui-utils"), require("./flickityt4s")))
            : e(t.EvEmitter, t.fizzyUIUtils, t.Flickityt4s);
    })(window, function (t, e, i) {
        function n(t) {
            (this.parent = t), (this.state = "stopped"), (this.onVisibilityChange = this.visibilityChange.bind(this)), (this.onVisibilityPlay = this.visibilityPlay.bind(this));
        }
        (n.prototype = Object.create(t.prototype)),
            (n.prototype.play = function () {
                "playing" != this.state &&
                    (document.hidden ? document.addEventListener("visibilitychange", this.onVisibilityPlay) : ((this.state = "playing"), document.addEventListener("visibilitychange", this.onVisibilityChange), this.tick()));
            }),
            (n.prototype.tick = function () {
                if ("playing" == this.state) {
                    var t = this.parent.options.autoPlay;
                    t = "number" == typeof t ? t : 3e3;
                    var e = this;
                    this.clear(),
                        (this.timeout = setTimeout(function () {
                            e.parent.next(!0), e.tick();
                        }, t));
                }
            }),
            (n.prototype.stop = function () {
                (this.state = "stopped"), this.clear(), document.removeEventListener("visibilitychange", this.onVisibilityChange);
            }),
            (n.prototype.clear = function () {
                clearTimeout(this.timeout);
            }),
            (n.prototype.pause = function () {
                "playing" == this.state && ((this.state = "paused"), this.clear());
            }),
            (n.prototype.unpause = function () {
                "paused" == this.state && this.play();
            }),
            (n.prototype.visibilityChange = function () {
                this[document.hidden ? "pause" : "unpause"]();
            }),
            (n.prototype.visibilityPlay = function () {
                this.play(), document.removeEventListener("visibilitychange", this.onVisibilityPlay);
            }),
            e.extend(i.defaults, { pauseAutoPlayOnHover: !0 }),
            i.createMethods.push("_createPlayer");
        var o = i.prototype;
        return (
            (o._createPlayer = function () {
                (this.player = new n(this)), this.on("activate", this.activatePlayer), this.on("uiChange", this.stopPlayer), this.on("pointerDown", this.stopPlayer), this.on("deactivate", this.deactivatePlayer);
            }),
            (o.activatePlayer = function () {
                this.options.autoPlay && (this.player.play(), this.element.addEventListener("mouseenter", this));
            }),
            (o.playPlayer = function () {
                this.player.play();
            }),
            (o.stopPlayer = function () {
                this.player.stop();
            }),
            (o.pausePlayer = function () {
                this.player.pause();
            }),
            (o.unpausePlayer = function () {
                this.player.unpause();
            }),
            (o.deactivatePlayer = function () {
                this.player.stop(), this.element.removeEventListener("mouseenter", this);
            }),
            (o.onmouseenter = function () {
                this.options.pauseAutoPlayOnHover && (this.player.pause(), this.element.addEventListener("mouseleave", this));
            }),
            (o.onmouseleave = function () {
                this.player.unpause(), this.element.removeEventListener("mouseleave", this);
            }),
            (i.Player = n),
            i
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/add-remove-cell", ["./flickityt4s", "fizzy-ui-utils/utils"], function (i, n) {
                  return e(t, i, n);
              })
            : "object" == typeof module && module.exports
            ? (module.exports = e(t, require("./flickityt4s"), require("fizzy-ui-utils")))
            : e(t, t.Flickityt4s, t.fizzyUIUtils);
    })(window, function (t, e, i) {
        var n = e.prototype;
        return (
            (n.insert = function (t, e) {
                var i = this._makeCells(t);
                if (i && i.length) {
                    var n = this.cells.length;
                    e = void 0 === e ? n : e;
                    var o = (function (t) {
                            var e = document.createDocumentFragment();
                            return (
                                t.forEach(function (t) {
                                    e.appendChild(t.element);
                                }),
                                e
                            );
                        })(i),
                        r = e == n;
                    if (r) this.slider.appendChild(o);
                    else {
                        var s = this.cells[e].element;
                        this.slider.insertBefore(o, s);
                    }
                    if (0 === e) this.cells = i.concat(this.cells);
                    else if (r) this.cells = this.cells.concat(i);
                    else {
                        var a = this.cells.splice(e, n - e);
                        this.cells = this.cells.concat(i).concat(a);
                    }
                    this._sizeCells(i), this.cellChange(e, !0);
                }
            }),
            (n.append = function (t) {
                this.insert(t, this.cells.length);
            }),
            (n.prepend = function (t) {
                this.insert(t, 0);
            }),
            (n.remove = function (t) {
                var e = this.getCells(t);
                if (e && e.length) {
                    var n = this.cells.length - 1;
                    e.forEach(function (t) {
                        t.remove();
                        var e = this.cells.indexOf(t);
                        (n = Math.min(e, n)), i.removeFrom(this.cells, t);
                    }, this),
                        this.cellChange(n, !0);
                }
            }),
            (n.cellSizeChange = function (t) {
                var e = this.getCell(t);
                if (e) {
                    e.getSize();
                    var i = this.cells.indexOf(e);
                    this.cellChange(i);
                }
            }),
            (n.cellChange = function (t, e) {
                var i = this.selectedElement;
                this._positionCells(t), this._getWrapShiftCells(), this.setGallerySize(), this.setPrevNextButtons();
                var n = this.getCell(i);
                n && (this.selectedIndex = this.getCellSlideIndex(n)),
                    (this.selectedIndex = Math.min(this.slides.length - 1, this.selectedIndex)),
                    this.emitEvent("cellChange", [t]),
                    this.select(this.selectedIndex),
                    e && this.positionSliderAtSelected();
            }),
            e
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s/js/index", ["./flickityt4s", "./drag", "./prev-next-button", "./page-dots", "./player", "./add-remove-cell", "./lazyload"], e)
            : "object" == typeof module &&
              module.exports &&
              (module.exports = e(require("./flickityt4s"), require("./drag"), require("./prev-next-button"), require("./page-dots"), require("./player"), require("./add-remove-cell"), require("./lazyload")));
    })(window, function (t) {
        return t;
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define("flickityt4s-as-nav-for/as-nav-for", ["flickityt4s/js/index", "fizzy-ui-utils/utils"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
            : (t.Flickityt4s = e(t.Flickityt4s, t.fizzyUIUtils));
    })(window, function (t, e) {
        t.createMethods.push("_createAsNavFor");
        var i = t.prototype;
        return (
            (i._createAsNavFor = function () {
                this.on("activate", this.activateAsNavFor), this.on("deactivate", this.deactivateAsNavFor), this.on("destroy", this.destroyAsNavFor);
                var t = this.options.asNavFor;
                if (t) {
                    var e = this;
                    setTimeout(function () {
                        e.setNavCompanion(t);
                    });
                }
            }),
            (i.setNavCompanion = function (i) {
                i = e.getQueryElement(i);
                var n = t.data(i);
                if (n && n != this) {
                    this.navCompanion = n;
                    var o = this;
                    (this.onNavCompanionSelect = function () {
                        o.navCompanionSelect();
                    }),
                        n.on("select", this.onNavCompanionSelect),
                        this.on("staticClick", this.onNavStaticClick),
                        this.navCompanionSelect(!0);
                }
            }),
            (i.navCompanionSelect = function (t) {
                var e = this.navCompanion && this.navCompanion.selectedCells;
                if (e) {
                    var i,
                        n = e[0],
                        o = this.navCompanion.cells.indexOf(n),
                        r = o + e.length - 1,
                        s = Math.floor((r - (i = o)) * this.navCompanion.cellAlign + i);
                    if ((this.selectCell(s, !1, t), this.removeNavSelectedElements(), !(s >= this.cells.length))) {
                        var a = this.cells.slice(o, r + 1);
                        (this.navSelectedElements = a.map(function (t) {
                            return t.element;
                        })),
                            this.changeNavSelectedClass("add");
                    }
                }
            }),
            (i.changeNavSelectedClass = function (t) {
                this.navSelectedElements.forEach(function (e) {
                    e.classList[t]("is-nav-selected");
                });
            }),
            (i.activateAsNavFor = function () {
                this.navCompanionSelect(!0);
            }),
            (i.removeNavSelectedElements = function () {
                this.navSelectedElements && (this.changeNavSelectedClass("remove"), delete this.navSelectedElements);
            }),
            (i.onNavStaticClick = function (t, e, i, n) {
                "number" == typeof n && this.navCompanion.selectCell(n);
            }),
            (i.deactivateAsNavFor = function () {
                this.removeNavSelectedElements();
            }),
            (i.destroyAsNavFor = function () {
                this.navCompanion && (this.navCompanion.off("select", this.onNavCompanionSelect), this.off("staticClick", this.onNavStaticClick), delete this.navCompanion);
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(["flickityt4s/js/index", "fizzy-ui-utils/utils"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
            : e(t.Flickityt4s, t.fizzyUIUtils);
    })(this, function (t, e) {
        var i = t.Slide,
            n = i.prototype.updateTarget;
        (i.prototype.updateTarget = function () {
            if ((n.apply(this, arguments), this.parent.options.fade)) {
                var t = this.target - this.x,
                    e = this.cells[0].x;
                this.cells.forEach(function (i) {
                    var n = i.x - e - t;
                    i.renderPosition(n);
                });
            }
        }),
            (i.prototype.setOpacity = function (t) {
                this.cells.forEach(function (e) {
                    e.element.style.opacity = t;
                });
            });
        var o = t.prototype;
        t.createMethods.push("_createFade"),
            (o._createFade = function () {
                (this.fadeIndex = this.selectedIndex),
                    (this.prevSelectedIndex = this.selectedIndex),
                    this.on("select", this.onSelectFade),
                    this.on("dragEnd", this.onDragEndFade),
                    this.on("settle", this.onSettleFade),
                    this.on("activate", this.onActivateFade),
                    this.on("deactivate", this.onDeactivateFade);
            });
        var r = o.updateSlides;
        (o.updateSlides = function () {
            r.apply(this, arguments), this.options.fade;
        }),
            (o.onSelectFade = function () {
                (this.fadeIndex = Math.min(this.prevSelectedIndex, this.slides.length - 1)), (this.prevSelectedIndex = this.selectedIndex);
            }),
            (o.onSettleFade = function () {
                delete this.didDragEnd, this.options.fade;
            }),
            (o.onDragEndFade = function () {
                this.didDragEnd = !0;
            }),
            (o.onActivateFade = function () {
                this.options.fade && this.element.classList.add("is-fade");
            }),
            (o.onDeactivateFade = function () {
                this.options.fade &&
                    (this.element.classList.remove("is-fade"),
                    this.slides.forEach(function (t) {
                        t.setOpacity("");
                    }));
            });
        var s = o.positionSlider;
        o.positionSlider = function () {
            this.options.fade ? (this.fadeSlides(), this.dispatchScrollEvent()) : s.apply(this, arguments);
        };
        var a = o.positionSliderAtSelected;
        (o.positionSliderAtSelected = function () {
            this.options.fade && this.setTranslateX(0), a.apply(this, arguments);
        }),
            (o.fadeSlides = function () {
                this.slides.length;
            }),
            (o.getFadeIndexes = function () {
                return this.isDragging || this.didDragEnd ? (this.options.wrapAround ? this.getFadeDragWrapIndexes() : this.getFadeDragLimitIndexes()) : { a: this.fadeIndex, b: this.selectedIndex };
            }),
            (o.getFadeDragWrapIndexes = function () {
                var t = this.slides.map(function (t, e) {
                        return this.getSlideDistance(-this.x, e);
                    }, this),
                    i = t.map(function (t) {
                        return Math.abs(t);
                    }),
                    n = Math.min.apply(Math, i),
                    o = i.indexOf(n),
                    r = t[o],
                    s = this.slides.length,
                    a = r >= 0 ? 1 : -1;
                return { a: o, b: e.modulo(o + a, s) };
            }),
            (o.getFadeDragLimitIndexes = function () {
                for (var t = 0, e = 0; e < this.slides.length - 1; e++) {
                    var i = this.slides[e];
                    if (-this.x < i.target) break;
                    t = e;
                }
                return { a: t, b: t + 1 };
            }),
            (o.wrapDifference = function (t, e) {
                var i = e - t;
                if (!this.options.wrapAround) return i;
                var n = i + this.slideableWidth,
                    o = i - this.slideableWidth;
                return Math.abs(n) < Math.abs(i) && (i = n), Math.abs(o) < Math.abs(i) && (i = o), i;
            });
        var l = o._getWrapShiftCells;
        o._getWrapShiftCells = function () {
            this.options.fade || l.apply(this, arguments);
        };
        var u = o.shiftWrapCells;
        return (
            (o.shiftWrapCells = function () {
                this.options.fade || u.apply(this, arguments);
            }),
            t
        );
    }),
    (function (t, e) {
        "function" == typeof define && define.amd
            ? define(["flickityt4s/js/index", "fizzy-ui-utils/utils"], e)
            : "object" == typeof module && module.exports
            ? (module.exports = e(require("flickityt4s"), require("fizzy-ui-utils")))
            : (t.Flickityt4s = e(t.Flickityt4s, t.fizzyUIUtils));
    })(window, function (t, e) {
        "use strict";
        return (
            t.createMethods.push("_createSync"),
            (t.prototype._createSync = function () {
                this.syncers = {};
                var t = this.options.sync;
                if ((this.on("destroy", this.unsyncAll), t)) {
                    var e = this;
                    setTimeout(function () {
                        e.sync(t);
                    });
                }
            }),
            (t.prototype.sync = function (i) {
                i = e.getQueryElement(i);
                var n = t.data(i);
                n && (this._syncCompanion(n), n._syncCompanion(this));
            }),
            (t.prototype._syncCompanion = function (t) {
                var e = this;
                function i() {
                    var i = e.selectedIndex;
                    t.selectedIndex != i && t.select(i);
                }
                this.on("select", i), (this.syncers[t.guid] = { flickityt4s: t, listener: i });
            }),
            (t.prototype.unsync = function (i) {
                i = e.getQueryElement(i);
                var n = t.data(i);
                this._unsync(n);
            }),
            (t.prototype._unsync = function (t) {
                t && (this._unsyncCompanion(t), t._unsyncCompanion(this));
            }),
            (t.prototype._unsyncCompanion = function (t) {
                var e = t.guid,
                    i = this.syncers[e];
                this.off("select", i.listener), delete this.syncers[e];
            }),
            (t.prototype.unsyncAll = function () {
                for (var t in this.syncers) {
                    var e = this.syncers[t];
                    this._unsync(e.flickityt4s);
                }
            }),
            t
        );
    }),
    (function (t, e) {
        "undefined" != typeof module && module.exports ? (module.exports = e()) : "function" == typeof define && define.amd ? define(e) : (this.$script = e());
    })(0, function () {
        function t(t, e) {
            for (var i = 0, n = t.length; i < n; ++i) if (!e(t[i])) return l;
            return 1;
        }
        function e(e, i) {
            t(e, function (t) {
                return i(t), 1;
            });
        }
        function i(r, s, a) {
            function l(t) {
                return t.call ? t() : d[t];
            }
            function c() {
                if (!--y) for (var i in ((d[v] = 1), m && m(), p)) t(i.split("|"), l) && !e(p[i], l) && (p[i] = []);
            }
            r = r[u] ? r : [r];
            var h = s && s.call,
                m = h ? s : a,
                v = h ? r.join("") : s,
                y = r.length;
            return (
                setTimeout(function () {
                    e(r, function t(e, i) {
                        return null === e
                            ? c()
                            : (!i && !/^https?:\/\//.test(e) && o && (e = -1 === e.indexOf(".js") ? o + e + ".js" : o + e),
                              g[e]
                                  ? (v && (f[v] = 1),
                                    2 == g[e]
                                        ? c()
                                        : setTimeout(function () {
                                              t(e, !0);
                                          }, 0))
                                  : ((g[e] = 1), v && (f[v] = 1), void n(e, c)));
                    });
                }, 0),
                i
            );
        }
        function n(t, e) {
            var i,
                n = s.createElement("script");
            (n.onload = n.onerror = n[h] = function () {
                (n[c] && !/^c|loade/.test(n[c])) || i || ((n.onload = n[h] = null), (i = 1), (g[t] = 2), e());
            }),
                (n.async = 1),
                (n.src = r ? t + (-1 === t.indexOf("?") ? "?" : "&") + r : t),
                a.insertBefore(n, a.lastChild);
        }
        var o,
            r,
            s = document,
            a = s.getElementsByTagName("head")[0],
            l = !1,
            u = "push",
            c = "readyState",
            h = "onreadystatechange",
            d = {},
            f = {},
            p = {},
            g = {};
        return (
            (i.get = n),
            (i.order = function (t, e, n) {
                !(function o(r) {
                    (r = t.shift()), t.length ? i(r, o) : i(r, e, n);
                })();
            }),
            (i.path = function (t) {
                o = t;
            }),
            (i.urlArgs = function (t) {
                r = t;
            }),
            (i.ready = function (n, o, r) {
                n = n[u] ? n : [n];
                var s = [];
                return (
                    !e(n, function (t) {
                        d[t] || s[u](t);
                    }) &&
                    t(n, function (t) {
                        return d[t];
                    })
                        ? o()
                        : (function (t) {
                              (p[t] = p[t] || []), p[t][u](o), r && r(s);
                          })(n.join("|")),
                    i
                );
            }),
            (i.done = function (t) {
                i([null], t);
            }),
            i
        );
    }),
    (function (t, e) {
        var i, n;
        "object" == typeof exports && "undefined" != typeof module
            ? (module.exports = e())
            : "function" == typeof define && define.amd
            ? define(e)
            : ((t = t || self),
              (i = t.Cookies),
              ((n = t.Cookies = e()).noConflict = function () {
                  return (t.Cookies = i), n;
              }));
    })(this, function () {
        "use strict";
        function t(t) {
            for (var e = 1; e < arguments.length; e++) {
                var i = arguments[e];
                for (var n in i) t[n] = i[n];
            }
            return t;
        }
        return (function e(i, n) {
            function o(e, o, r) {
                if ("undefined" != typeof document) {
                    "number" == typeof (r = t({}, n, r)).expires && (r.expires = new Date(Date.now() + 864e5 * r.expires)),
                        r.expires && (r.expires = r.expires.toUTCString()),
                        (e = encodeURIComponent(e)
                            .replace(/%(2[346B]|5E|60|7C)/g, decodeURIComponent)
                            .replace(/[()]/g, escape));
                    var s = "";
                    for (var a in r) r[a] && ((s += "; " + a), !0 !== r[a] && (s += "=" + r[a].split(";")[0]));
                    return (document.cookie = e + "=" + i.write(o, e) + s);
                }
            }
            return Object.create(
                {
                    set: o,
                    get: function (t) {
                        if ("undefined" != typeof document && (!arguments.length || t)) {
                            for (var e = document.cookie ? document.cookie.split("; ") : [], n = {}, o = 0; o < e.length; o++) {
                                var r = e[o].split("="),
                                    s = r.slice(1).join("=");
                                try {
                                    var a = decodeURIComponent(r[0]);
                                    if (((n[a] = i.read(s, a)), t === a)) break;
                                } catch (t) {}
                            }
                            return t ? n[t] : n;
                        }
                    },
                    remove: function (e, i) {
                        o(e, "", t({}, i, { expires: -1 }));
                    },
                    withAttributes: function (i) {
                        return e(this.converter, t({}, this.attributes, i));
                    },
                    withConverter: function (i) {
                        return e(t({}, this.converter, i), this.attributes);
                    },
                },
                { attributes: { value: Object.freeze(n) }, converter: { value: Object.freeze(i) } }
            );
        })(
            {
                read: function (t) {
                    return '"' === t[0] && (t = t.slice(1, -1)), t.replace(/(%[\dA-F]{2})+/gi, decodeURIComponent);
                },
                write: function (t) {
                    return encodeURIComponent(t).replace(/%(2[346BF]|3[AC-F]|40|5[BDE]|60|7[BCD])/g, decodeURIComponent);
                },
            },
            { path: "/" }
        );
    });
var CookiesT4 = Cookies.noConflict();
!(function (t) {
    "use strict";
    var e,
        i,
        n = t(window),
        o = (t(document), t("body")),
        r = n.width() < 768;
    function s(t, e = !0) {
        if (IsDesignMode && e) return !1;
        var i = "session" === t ? window.sessionStorage : window.localStorage;
        try {
            return i.setItem("t4s", "test"), i.removeItem("t4s"), !0;
        } catch (t) {
            return !1;
        }
    }
    (isStorageSpSession = s("session")),
        (isStorageSpSessionAll = s("session", !1)),
        (isStorageSpdLocal = s("local")),
        (isStorageSpdLocalAll = s("local", !1)),
        (T4SThemeSP.$appendComponent = t("#t4s-append-component")),
        void 0 === window.Shopify && (window.Shopify = {}),
        (Shopify.bind = function (t, e) {
            return function () {
                return t.apply(e, arguments);
            };
        }),
        (Shopify.setSelectorByValue = function (t, e) {
            for (var i = 0, n = t.options.length; i < n; i++) {
                var o = t.options[i];
                if (e == o.value || e == o.innerHTML) return (t.selectedIndex = i), i;
            }
        }),
        (Shopify.addListener = function (t, e, i) {
            t.addEventListener ? t.addEventListener(e, i, !1) : t.attachEvent("on" + e, i);
        }),
        (Shopify.postLink = function (t, e) {
            var i = (e = e || {}).method || "post",
                n = e.parameters || {},
                o = document.createElement("form");
            for (var r in (o.setAttribute("method", i), o.setAttribute("action", t), n)) {
                var s = document.createElement("input");
                s.setAttribute("type", "hidden"), s.setAttribute("name", r), s.setAttribute("value", n[r]), o.appendChild(s);
            }
            document.body.appendChild(o), o.submit(), document.body.removeChild(o);
        }),
        (Shopify.CountryProvinceSelector = function (t, e, i) {
            (this.countryEl = document.getElementById(t)),
                (this.provinceEl = document.getElementById(e)),
                (this.provinceContainer = document.getElementById(i.hideElement || e)),
                Shopify.addListener(this.countryEl, "change", Shopify.bind(this.countryHandler, this)),
                this.initCountry(),
                this.initProvince();
        }),
        (Shopify.CountryProvinceSelector.prototype = {
            initCountry: function () {
                var t = this.countryEl.getAttribute("data-default");
                Shopify.setSelectorByValue(this.countryEl, t), this.countryHandler();
            },
            initProvince: function () {
                var t = this.provinceEl.getAttribute("data-default");
                t && this.provinceEl.options.length > 0 && Shopify.setSelectorByValue(this.provinceEl, t);
            },
            countryHandler: function (t) {
                var e = (o = this.countryEl.options[this.countryEl.selectedIndex]).getAttribute("data-provinces"),
                    i = JSON.parse(e);
                if ((this.clearOptions(this.provinceEl), i && 0 == i.length)) this.provinceContainer.style.display = "none";
                else {
                    for (var n = 0; n < i.length; n++) {
                        var o;
                        ((o = document.createElement("option")).value = i[n][0]), (o.innerHTML = i[n][1]), this.provinceEl.appendChild(o);
                    }
                    this.provinceContainer.style.display = "";
                }
            },
            clearOptions: function (t) {
                for (; t.firstChild; ) t.removeChild(t.firstChild);
            },
            setOptions: function (t, e) {
                var i = 0;
                for (e.length; i < e.length; i++) {
                    var n = document.createElement("option");
                    (n.value = e[i]), (n.innerHTML = e[i]), t.appendChild(n);
                }
            },
        }),
        (T4SThemeSP.root_url = "/" != T4Sroutes.root_url ? T4Sroutes.root_url + "/" : "/"),
        (T4SThemeSP.resizeEventT4 = function (t, e, i) {
            try {
                window.dispatchEvent(new Event("resize"));
            } catch (t) {
                var n = window.document.createEvent("UIEvents");
                n.initUIEvent("resize", !0, !1, window, 0), window.dispatchEvent(n);
            }
        }),
        (T4SThemeSP.debounce = function (t, e, i) {
            var n;
            return function () {
                var o = this,
                    r = arguments,
                    s = i && !n;
                clearTimeout(n),
                    (n = setTimeout(function () {
                        (n = null), i || e.apply(o, r);
                    }, t)),
                    s && e.apply(o, r);
            };
        }),
        (T4SThemeSP.storageCurrency = function () {
            return isStorageSpdLocal ? localStorage.getItem("T4Currency") : null;
        }),
        (T4SThemeSP.fullHeightFirtSe = function () {
            var e,
                i,
                o,
                r = t("#MainContent >.t4s-section:first").find(".t4s_ratio_fh");
            0 != r.length && ((e = n.height()), (i = r.offset().top) < e && ((o = 100 - i / (e / 100)), r.css("--t4s-aspect-ratio", o + "vh")));
        }),
        (T4SThemeSP.handle = function (t) {
            var e = (t = (t + "").toLowerCase())
                .replace(/'|"|\(|\)|\[|\]/g, "")
                .replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g, "-")
                .replace(/\W+/g, "-")
                .replace(/^-+|-+$/g, "");
            return "" == e ? t : e;
        }),
        (T4SThemeSP._handle = function (t) {
            var e = (t = (t + "").toLowerCase())
                .replace(/'|"|\(|\)|\[|\]/g, "")
                .replace(/[\s\x21-\x2f\x3a-\x40\x7b-\x7f^`\\[\]]+/g, "_")
                .replace(/\W+/g, "_")
                .replace(/^-+|-+$/g, "");
            return "" == e ? t : e;
        }),
        (T4SThemeSP.escapeHtml = function (t) {
            return t.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
        }),
        (T4SThemeSP.descapeHtml = function (t) {
            return t
                .replace(/&lt;/g, "<")
                .replace(/&gt;/g, ">")
                .replace(/&quot;/g, '"')
                .replace(/&#39;/g, "'")
                .replace(/&amp;/g, "&");
        }),
        (T4SThemeSP.Images = (function () {
            return {
                preloadImages: function (e) {
                    t(e).each(function () {
                        t("<img/>")[0].src = this;
                    });
                },
                getNewImageUrl: function (t, e = 0, i = 0) {
                    return e || i ? (e && (t = t + "&width=" + e), i && (t = t + "&height=" + i), this.removeProtocol(t)) : null;
                },
                removeProtocol: function (t) {
                    return t.replace(/http(s)?:/, "");
                },
                lazyloadImagePath: function (t) {
                    return this.removeProtocol(t + "&width=1");
                },
            };
        })()),
        (T4SThemeSP.getUID = function (t) {
            do {
                t += ~~(1e6 * Math.random());
            } while (document.getElementById(t));
            return t;
        }),
        (T4SThemeSP.Carousel = (function () {
            var e,
                i = "is--paused",
                o = "is--active",
                s = "is-nav-selected",
                a = "is-shopify-xr__showing",
                l = "t4s-carousel__nav-item",
                u = "is-selected",
                c = {
                    currentSlide: `.${u}`,
                    wrapper: ".t4s-carousel-wrapper",
                    pauseButton: ".t4s-carousel__pause",
                    productMediaWrapper: "[data-product-single-media-wrapper]",
                    mediaGroup: "[data-product-single-media-group]",
                    dataMediaPlay: "data-is-mediaPlay",
                    productMediaPlay: "[data-is-mediaPlay]",
                },
                h = {
                    adaptiveHeight: !1,
                    autoPlay: !1,
                    avoidReflow: !1,
                    thumbNav: !1,
                    thumbVertical: !1,
                    navUI: !1,
                    dotUI: !1,
                    parallax: !1,
                    status: !1,
                    isMedia: !1,
                    t4sid: "19041994",
                    selectWithSelector: !1,
                    isSimple: !1,
                    dragThreshold: 7,
                    fade: !1,
                    friction: 0.8,
                    initialIndex: 0,
                    pageDots: !1,
                    pauseAutoPlayOnHover: !1,
                    prevNextButtons: !1,
                    selectedAttraction: 0.14,
                },
                d = "select.carousel",
                f = "click.navt4s",
                p = "click.dott4s",
                g = "click.thumbt4s",
                m = {
                    video: '<svg viewBox="0 0 384 512"><use href="#icon-thumb-video"/></svg>',
                    external_videoyoutube: '<svg viewBox="0 0 576 512"><use href="#icon-external-youtube"/></svg>',
                    external_videovimeo: '<svg viewBox="0 0 448 512"><use href="#icon-external-vimeo"/></svg>',
                    model: '<svg viewBox="0 0 512 512"><use href="#icon-thumb-model"/></svg>',
                    360: '<svg viewBox="0 0 640 512"><use href="#icon-thumb-360"/></svg>',
                },
                v = "destroy.t4s",
                y = "",
                b = "{}",
                x = !1,
                S = window.CSS.supports("scroll-behavior", "smooth");
            function w(i) {
                (this.el = i),
                    (this.$el = t(i)),
                    (this.UID = T4SThemeSP.getUID()),
                    (e = "resize.carousel" + this.UID),
                    (b = JSON.parse(this.$el.attr("data-flickityt4s-js") || b)),
                    (this.args = Object.assign({}, h, b)),
                    (this.IdSlider = this.args.t4sid),
                    (this.args.fade = this.$el.hasClass("t4s-slide-eff-fade") || this.args.fade),
                    (this.args.rightToLeft = isThemeRTL),
                    (this.$deferredMedia = this.$el.find(c.productMediaWrapper)),
                    this.args.isMedia &&
                        ((this.isMedia = this.$el.find("[data-deferred-media]").length > 0 || this.$el.find('[data-media-type="360"]').length > 0),
                        this.isMedia && ((this.$groupBtn = t(`[ data-t4s-group-btns="${this.args.t4sid}"]`)), (this.$mediaGroup = this.$el.closest(c.mediaGroup)))),
                    (this.args.on = { ready: this.init.bind(this), change: this.slideChange.bind(this), settle: this.afterChange.bind(this) }),
                    this.args.thumbNav && this._initCarouselNav(),
                    this.args.avoidReflow &&
                        (function (t) {
                            if (!t.id) return;
                            var e = t.firstChild;
                            for (; null != e && 3 == e.nodeType; ) e = e.nextSibling;
                            var i = document.createElement("style");
                            (i.innerHTML = `#${t.id} .flickity-viewport{height:${e.offsetHeight}px}`), document.head.appendChild(i);
                        })(i),
                    (this.$carousel = this.$el.flickityt4s(this.args)),
                    (this.flkty = this.$carousel.data("flickityt4s")),
                    (this.selectedIndex = this.flkty.selectedIndex);
                var o = this;
                setTimeout(function () {
                    o.$el.addClass("t4s-enabled"), o.args.isSimple && o.actionsAPI("resize");
                }, 100),
                    this._selectChange();
                var r = this.$el.closest(c.wrapper);
                this.args.autoPlay && r.length && ((this.pauseBtn = r[0].querySelector(c.pauseButton)), this.pauseBtn && this.pauseBtn.addEventListener("click", this._togglePause.bind(this))),
                    this.args.navUI && this._customNavUI(),
                    this.args.dotUI && this._customDotUI(),
                    this.args.parallax && this._parallaxEffect(),
                    this.args.status && this._status(),
                    this.args.isFilter && this._updateCarousel(),
                    this.args.selectWithSelector && this._selectWithSelector();
                var s = this.args.thumbVertical;
                n.width() < 1025 && s && (this.args.thumbVertical = !1),
                    n.on(
                        e,
                        T4SThemeSP.debounce(
                            300,
                            function () {
                                o.actionsAPI("resize"), n.width() < 1025 && s ? (o.args.thumbVertical = !1) : n.width() > 1024 && s && (o.args.thumbVertical = !0);
                            }.bind(this)
                        )
                    ),
                    o.$el.on(v, o.destroy.bind(o));
            }
            return (
                (w.prototype = Object.assign({}, w.prototype, {
                    init: function (t) {
                        (this.currentSlide = this.el.querySelector(c.currentSlide)), this.args.callbacks && this.args.callbacks.onInit && "function" == typeof this.args.callbacks.onInit && this.args.callbacks.onInit(this.currentSlide);
                    },
                    slideChange: function (t) {
                        this.args.thumbNav && this.thumbnailsGoto(t),
                            this.args.callbacks && this.args.callbacks.onChange && "function" == typeof this.args.callbacks.onChange && this.args.callbacks.onChange(t),
                            this.$carouselNavPrev &&
                                this.$carouselNavPrev.length &&
                                (this.$carouselNavPrev[0].classList.toggle("is--hide", 0 === t), this.$carouselNavNext[0].classList.toggle("is--hide", t === this.$carouselNavLinks.length - 1)),
                            this.isMedia && this._switchMedia(t);
                    },
                    afterChange: function (t) {
                        this.args.thumbNav && this.thumbnailsGoto(this.flkty.selectedIndex);
                    },
                    destroy: function () {
                        this.$carouselNav && this.$carouselNav.find("." + s).removeClass(s), this.actionsAPI("destroy"), this.$el.off(v), n.off(e);
                    },
                    _togglePause: function () {
                        this.pauseBtn.classList.contains(i) ? (this.pauseBtn.classList.remove(i), this.actionsAPI("playPlayer")) : (this.pauseBtn.classList.add(i), this.actionsAPI("pausePlayer"));
                    },
                    actionsAPI: function (t) {
                        this.$carousel.flickityt4s(t);
                    },
                    _selectChange: function (t) {
                        var e = this;
                        e.$carousel.on("select.flickityt4s", function (t, i) {
                            e.$carousel.trigger(d);
                        });
                    },
                    _customNavUI: function () {
                        var e = this,
                            i = t(".btn__prev--" + e.IdSlider),
                            n = t(".btn__next--" + e.IdSlider),
                            o = e.args.wrapAround || !1;
                        0 != n.length &&
                            (i.on(f, function () {
                                e.actionsAPI("previous");
                            }),
                            n.on(f, function () {
                                e.actionsAPI("next");
                            }),
                            e.$carousel.on(d, function () {
                                e.flkty.cells[e.flkty.selectedIndex - 1] || o
                                    ? e.flkty.cells[e.flkty.selectedIndex + 1] || o
                                        ? (i.removeAttr("disabled"), n.removeAttr("disabled"))
                                        : (n.attr("disabled", "disabled"), i.removeAttr("disabled"))
                                    : (i.attr("disabled", "disabled"), n.removeAttr("disabled"));
                            }));
                    },
                    _customDotUI: function () {
                        var e = this,
                            i = t(".btn_group--cells" + e.IdSlider),
                            n = i.find(".btn_dott4s");
                        0 != n.length &&
                            (i.on(p, ".btn_dott4s", function () {
                                e.$carousel.flickityt4s("select", t(this).index());
                            }),
                            e.$carousel.on(d, function () {
                                n.filter(`.${u}`).removeClass(u), n.eq(e.flkty.selectedIndex).addClass(u);
                            }));
                    },
                    _parallaxEffect: function () {
                        var t = this;
                        if (t.$carousel.hasClass("slide-eff-parallax")) {
                            if (r) var e = ".t4s-slide .t4s-img-as-bg.t4s-d-md-none";
                            else e = ".t4s-slide .t4s-img-as-bg.t4s-d-md-block";
                            var i = t.$carousel.find(e);
                            0 != i.length &&
                                t.$carousel.on("scroll.flickityt4s", function (e, n) {
                                    t.flkty.slides.forEach(function (e, n) {
                                        var o = i[n],
                                            r = (-1 * (e.target + t.flkty.x)) / 3;
                                        o.style.transform = "translateX( " + r + "px)";
                                    });
                                });
                        }
                    },
                    _status: function () {
                        var e = this,
                            i = t(".carousel--status" + e.IdSlider);
                        if (0 != i.length) {
                            var n = i.find("[data-current-slide]"),
                                o = i.find("[data-total-number]"),
                                r = e.args.pad || !1,
                                s = 0,
                                a = 0;
                            l(), e.$carousel.on(d, l);
                        }
                        function l() {
                            (s = e.flkty.selectedIndex + 1), (a = e.flkty.slides.length), r && ((s = u(s, 2)), (a = u(a, 2))), n.text(s), o.text(a);
                        }
                        function u(t, e) {
                            return (t = t.toString()).length < e ? u("0" + t, e) : t;
                        }
                    },
                    _initCarouselNav: function () {
                        var e = this;
                        (e.$carouselNav = t(".carousel__nav--" + e.IdSlider)),
                            0 != e.$carouselNav.length &&
                                (x || e.addThumbIcons(),
                                e.thumbnailsMarkup(),
                                e.$carouselNavLinks.eq([e.args.initialIndex]).addClass(s),
                                (e.$carouselNavPrev = t(`[data-thumb-btn__prev="${e.IdSlider}"]`)),
                                (e.$carouselNavNext = t(`[data-thumb-btn__next="${e.IdSlider}"]`)),
                                (this.$carouselNavPrev.length || this.$carouselNavNext.length) &&
                                    (e.$carouselNavPrev.on(g, function () {
                                        e.actionsAPI("previous");
                                    }),
                                    e.$carouselNavNext.on(g, function () {
                                        e.actionsAPI("next");
                                    })),
                                e.args.isFilter
                                    ? e.$carouselNav.on(g, "." + l, function (i) {
                                          let n = e.$carouselNav.find(`.${l}:visible`).index(t(this));
                                          e.$carousel.flickityt4s("select", n);
                                      })
                                    : e.$carouselNav.on(g, "." + l, function (i) {
                                          e.$carousel.flickityt4s("select", t(this).index());
                                      }));
                    },
                    addThumbIcons: function () {
                        var e = t("template[data-icons-thumb]");
                        0 != e.length && (T4SThemeSP.$appendComponent.after(e.html()), (x = !0));
                    },
                    thumbnailsMarkup: function () {
                        (y = ""),
                            this.$el.find("[data-main-slide]").each(function () {
                                var e = t(this),
                                    i = e.hasClass("is--media-hide") ? "is--media-hide" : "",
                                    n = e.data("media-type"),
                                    o = e.data("vhost") || "",
                                    r = e.data("grname") || "",
                                    s = e.data("grpvl") || "",
                                    a = e.find(".t4s_ratio").attr("style"),
                                    u = e.find("img"),
                                    c = T4SThemeSP.Images.lazyloadImagePath(u.attr("data-master") || u.attr("data-src")),
                                    h = m[n + o] || "";
                                y += `<div class="t4s-col-item ${l} ${i}" data-grname="${r}" data-grpvl="${s}" data-mdtype="${n}" data-vhost="${o}"><div class="t4s_ratio t4s-carousel__nav-inner" style="${a};background: url(${c})"><img alt="${T4SThemeSP.escapeHtml(
                                    u.attr("alt")
                                )}" loading="lazy" class="lazyloadt4s" data-src="${c}" data-widths="[80, 120, 160 ,180, 360, 540]" data-optimumx="1.8" data-sizes="auto" src="${c}"><span class="t4s-thumbnail__badge t4s-not-style t4s-op-0" aria-hidden="true">${h}</span></div></div>`;
                            }),
                            this.$carouselNav.empty().append(y).addClass("is--nav-ready"),
                            (this.$carouselNavLinks = this.$carouselNav.find(`.${l}:not(.is--media-hide):visible`));
                    },
                    thumbnailsGoto: function (e) {
                        var i = this.$carouselNavLinks.eq(e),
                            n = i[0];
                        if (((this.$carouselNavScroller = t(`[data-thumb__scroller="${this.IdSlider}"]`)), this.$carouselNav.find("." + s).removeClass(s), i.addClass(s), this.args.thumbVertical)) {
                            var o = n.offsetTop;
                            S ? (this.$carouselNavScroller[0].scrollTop = o - 100) : this.$carouselNavScroller.stop().animate({ scrollTop: o - 100 }, 350);
                        } else {
                            var r = n.offsetLeft;
                            S ? (this.$carouselNavScroller[0].scrollLeft = r - 100) : this.$carouselNavScroller.stop().animate({ scrollLeft: r - 100 }, 350);
                        }
                    },
                    _switchMedia: function (e) {
                        this.$el.find(`.flickityt4s-slider ${c.productMediaWrapper}`).eq(this.selectedIndex);
                        var i = this.$el.find(`.flickityt4s-slider ${c.productMediaWrapper}`).eq(e);
                        (this.selectedIndex = this.flkty.selectedIndex),
                            this.$groupBtn.removeAttr("hidden"),
                            this.$mediaGroup.removeClass(a),
                            (this.flkty.options.draggable = !0),
                            t(c.productMediaPlay).each(function () {
                                this.dispatchEvent(new CustomEvent("mediaHidden", { bubbles: !0, cancelable: !0 })), this.removeAttribute(c.dataMediaPlay);
                            }),
                            i.is("[data-deferred-media]") || i.is('[data-media-type="360"]')
                                ? ((this.flkty.options.draggable = !1),
                                  this.flkty.updateDraggable(),
                                  i.is('[data-media-type="model"]') ? this.$mediaGroup.addClass(a) : this.$groupBtn.attr("hidden", !0),
                                  i.attr(c.dataMediaPlay, ""),
                                  i[0].dispatchEvent(new CustomEvent("mediaVisible", { bubbles: !0, cancelable: !0 })))
                                : this.flkty.updateDraggable();
                    },
                    _updateCarousel: function (e) {
                        var i = this;
                        i.$carousel.on("update.flickityt4s", function (e) {
                            t(this).flickityt4s("deactivate").flickityt4s("activate"), i.$carouselNav && (i.$carouselNavLinks = i.$carouselNav.find(`.${l}:not(.is--media-hide):visible`));
                        });
                    },
                    eventWheel: function (t) {
                        console.log(t), t.deltaY >= 0 ? console.log("Scroll bottom") : console.log("Scroll top");
                    },
                    _selectWithSelector: function () {
                        var e = this;
                        let i = t(`[data-carousel-id="${e.IdSlider}"]`);
                        if (0 == i.length) return;
                        i.on("click", function () {
                            e.$carousel.flickityt4s("select", t(this).index());
                        });
                        let n = e.$carousel.find("[data-flickity-link]");
                        e.$carousel.on(d, function () {
                            i.filter(`.${o}`).removeClass(o), i.eq(e.flkty.selectedIndex).addClass(o);
                            let r = t(e.flkty.selectedElement).data("url");
                            n[0] && r && n.attr("href", r);
                        });
                    },
                })),
                w
            );
        })()),
        (T4SThemeSP.initCarousel = void (
            0 != (e = t(".flickityt4s:not(.flickityt4s-later):not(.flickityt4s-enabled)")).length &&
            e.each(function () {
                this.flickityt4s = new T4SThemeSP.Carousel(this);
            })
        )),
        (T4SThemeSP.initWhenVisible = function (t) {
            var e = t.threshold ? t.threshold : 0;
            new IntersectionObserver(
                (e, i) => {
                    e.forEach((e) => {
                        e.isIntersecting && "function" == typeof t.callback && (t.callback(), i.unobserve(e.target));
                    });
                },
                { rootMargin: "0px 0px " + e + "px 0px" }
            ).observe(t.element);
        }),
        (T4SThemeSP.Isotopet4s = (function () {
            function e(t) {
                var e = t.attr("data-isotopet4s-js") || "{}";
                t.isotopet4s(JSON.parse(e)).addClass("isotopet4s-enabled");
            }
            function i() {
                var e = t("[data-isotopet4s-filter]");
                if (0 != e.length) {
                    var i = IsDesignMode ? "[data-isotopet4s-filter]>button" : ">button";
                    (IsDesignMode ? o : e).on("click", i, function () {
                        var e = t(this),
                            i = e.closest("[data-isotopet4s-filter]"),
                            n = i.data("grid"),
                            o = n ? t(n) : i.next();
                        i.find(".is--active").removeClass("is--active"), e.addClass("is--active"), o.isotopet4s({ filter: e.attr("data-filter") });
                    });
                }
            }
            return {
                initEach: function () {
                    var n = t(".isotopet4s:not(.isotopet4s-later):not(.isotopet4s-enabled)");
                    0 != n.length &&
                        (n.each(function () {
                            e(t(this));
                        }),
                        i());
                },
                init: e,
                filter: i,
            };
        })()),
        (T4SThemeSP.T4SWrappTable = function () {
            t("table:not('.t4s-table-res')").wrap("<div class='t4s-table-res-df'></div>");
        }),
        (T4SThemeSP.AccordionMobileInt = function () {
            var e = t(".t4s-accordion-mb-true");
            0 != e.length && (t(window).width() <= 1024 ? e.removeClass("t4s-type-tabs").addClass("t4s-type-accordion") : e.removeClass("t4s-type-accordion").addClass("t4s-type-tabs"));
        }),
        (T4SThemeSP.CartAttrHidden = function () {
            var e = t("[data-cart-attr-rm]"),
                i = 0;
            if (0 != e.length && !T4Sconfigs.CartAttrHidden) {
                var n = setInterval(function () {
                    e.val(""), 15 == i && clearInterval(n), i++;
                }, 500);
                o.on("click", 'button[type=submit][name="checkout"]', function (t) {
                    e.val("");
                });
            }
        }),
        (T4SThemeSP.announcement = function () {
            var e = ".t4s-announcement-bar__close",
                i = t(".t4s-announcement-bar"),
                n = i.attr("data-ver"),
                o = T4Sconfigs.theme,
                r = "t4s_announcement_" + o + "_" + n,
                s = parseInt(i.attr("data-date"));
            if (0 != i.length && "closed" != CookiesT4.get(r)) {
                var a = "t4s_announcement_" + o + "_" + ("1_nt" == n ? "2_nt" : "1_nt");
                "closed" == CookiesT4.get(a) && CookiesT4.remove(a),
                    t(e).on("click", function (t) {
                        i.css("min-height", "auto").attr("aria-hidden", !0).slideUp(), IsDesignMode || CookiesT4.set(r, "closed", { expires: s, path: "/" });
                    });
            }
        }),
        (T4SThemeSP.Marquee3k = (function () {
            var e,
                i = { enabled: "marqueet4s-enabled", animation: "t4s-marquee--animation", duplicate: "t4s-marquee--duplicate" };
            function o(o) {
                (this.el = o),
                    (this.$el = t(o)),
                    (this.width = 0),
                    (this.UID = T4SThemeSP.getUID()),
                    (e = "resize.marquee" + this.UID),
                    (this.marquee3kItem = o.querySelector(".t4s-marquee__item")),
                    IsDesignMode ? setTimeout(this.resizeHandler.bind(this), 100) : this.resizeHandler(),
                    this.$el.addClass(i.enabled);
                var r = this;
                n.on(
                    e,
                    T4SThemeSP.debounce(
                        300,
                        function () {
                            r.resizeHandler();
                        }.bind(this)
                    )
                );
            }
            return (
                (o.prototype = Object.assign({}, o.prototype, {
                    resizeHandler: function () {
                        if (this.width != window.innerWidth) {
                            (this.width = window.innerWidth), this.marquee3kItem.classList.remove(i.animation);
                            var t = this.el.querySelectorAll("." + i.duplicate);
                            t.length && t.forEach((t) => t.remove());
                            var e = window.innerWidth / this.marquee3kItem.offsetWidth,
                                n = !1;
                            e = e == 1 / 0 ? 5 : e;
                            for (var o = 0; o < e; o++) (n = this.marquee3kItem.cloneNode(!0)).classList.add(i.duplicate), n.classList.add(i.animation), this.el.append(n);
                            this.marquee3kItem.classList.add(i.animation);
                        }
                    },
                })),
                o
            );
        })()),
        (T4SThemeSP.initMarquee3k = void (
            0 != (i = t(".t4s-marquee:not(.marqueet4s-enabled)")).length &&
            i.each(function () {
                this.marquee3k = new T4SThemeSP.Marquee3k(this);
            })
        ));
})(jQuery_T4NT),
    jQuery_T4NT(document).ready(function (t) {
        "undefined" != typeof lazySizesT4
            ? lazySizesT4.init()
            : document.addEventListener("lazysizet4s:loaded", function (t) {
                  lazySizesT4.init();
              }),
            T4SThemeSP.fullHeightFirtSe(),
            jQuery_T4NT.fn.isotopet4s && T4SThemeSP.Isotopet4s && T4SThemeSP.Isotopet4s.initEach(),
            T4SThemeSP.announcement(),
            T4SThemeSP.T4SWrappTable(),
            T4SThemeSP.CartAttrHidden(),
            "fetch" in window && "assign" in Object && "ResizeObserver" in window && "IntersectionObserver" in window && "DateTimeFormat" in Intl
                ? $script(T4Sconfigs.script2, function () {
                      IsDesignMode && $script(T4Sconfigs.script9), $script(T4Sconfigs.script10);
                  })
                : $script(T4Sconfigs.script1, function () {
                      $script(T4Sconfigs.script2, function () {
                          IsDesignMode && $script(T4Sconfigs.script9), $script(T4Sconfigs.script10);
                      });
                  });
    }),
    jQuery_T4NT(window).on("resize", function () {
        T4SThemeSP.AccordionMobileInt();
    });
